(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[29],{

/***/ "04qU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LayerActivities_LayerActivities; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// EXTERNAL MODULE: ./src/client/components/widgets/layer/ClosableLayer.jsx
var ClosableLayer = __webpack_require__("FK6w");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineTrackingContext.js
var BookingEngineTrackingContext = __webpack_require__("v+bK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/activities/activities.utils.js
var activities_utils = __webpack_require__("8W+g");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/views/booking/booking-confirmation/BookingConfirmationTracking.utils.js
var BookingConfirmationTracking_utils = __webpack_require__("s1v2");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/hr/Hr.jsx
var Hr = __webpack_require__("3+yQ");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/filter-button/FilterButton.jsx
var FilterButton = __webpack_require__("Gf56");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/widgets/activity-card/ActivityCard.jsx
var ActivityCard = __webpack_require__("k0YQ");

// EXTERNAL MODULE: ./src/client/components/frameworks/columns/Columns.jsx + 1 modules
var Columns = __webpack_require__("bbEf");

// EXTERNAL MODULE: ./src/client/components/widgets/rentals-cta/RentalsCta.jsx
var RentalsCta = __webpack_require__("38qS");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-list/ActivitiesList.jsx

var __jsx = react_default.a.createElement;








var ActivitiesList_ActivitiesList = function ActivitiesList(_ref) {
  var _ref$activities = _ref.activities,
      activities = _ref$activities === void 0 ? [] : _ref$activities,
      _ref$colsNumber = _ref.colsNumber,
      colsNumber = _ref$colsNumber === void 0 ? 3 : _ref$colsNumber,
      category = _ref.category,
      _ref$hasRentals = _ref.hasRentals,
      hasRentals = _ref$hasRentals === void 0 ? false : _ref$hasRentals;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      bookingId = _useContext.bookingId;

  if (!(activities === null || activities === void 0 ? void 0 : activities.length) && !hasRentals) {
    return null;
  }

  return __jsx(Columns["a" /* Columns */], {
    colsNumber: colsNumber
  }, hasRentals && category.upsellType === BookingConfirmationTracking_utils["f" /* upSellTypeMapping */].WINTER_SPORT && __jsx(RentalsCta["a" /* RentalsCta */], {
    className: "h-200",
    onClick: function onClick() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACTIVITIES_SERVICES, {
        detail_click: 'service_ski_equipment'
      });
    }
  }), activities.map(function (activity) {
    return __jsx(ActivityCard["a" /* ActivityCard */], {
      activity: activity,
      bookingId: bookingId,
      className: "mb-20",
      key: activity.id
    });
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/availability-badge/AvailabilityBadge.jsx
var AvailabilityBadge = __webpack_require__("5iTF");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-filtered-list/ActivitiesFilteredList.jsx






var ActivitiesFilteredList_jsx = react_default.a.createElement;









var ActivitiesFilteredList_ActivitiesFilteredList = function ActivitiesFilteredList(_ref) {
  var _category$activities;

  var category = _ref.category,
      className = _ref.className,
      _ref$colsNumber = _ref.colsNumber,
      colsNumber = _ref$colsNumber === void 0 ? 3 : _ref$colsNumber,
      _ref$hasRentals = _ref.hasRentals,
      hasRentals = _ref$hasRentals === void 0 ? false : _ref$hasRentals,
      message = _ref.message;

  var _useState = Object(react["useState"])(null),
      filter = _useState[0],
      setFilter = _useState[1];

  if (!((_category$activities = category.activities) === null || _category$activities === void 0 ? void 0 : _category$activities.length)) {
    return null;
  }

  var activities = category.activities,
      categories = category.categories;
  var shouldDisplayNotification = (message === null || message === void 0 ? void 0 : message.title) && (message === null || message === void 0 ? void 0 : message.subtitle) && !!(category === null || category === void 0 ? void 0 : category.onlineBookableCount);
  var notEmptyCategories = (categories || []).filter(function (c) {
    var _c$activities;

    return (_c$activities = c.activities) === null || _c$activities === void 0 ? void 0 : _c$activities.some(function (a) {
      return !a.isIncluded;
    });
  });
  return ActivitiesFilteredList_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(className)
  }, ActivitiesFilteredList_jsx("div", {
    className: "mb-20 md:flex"
  }, shouldDisplayNotification && ActivitiesFilteredList_jsx(Notification["a" /* Notification */], {
    className: "mb-20 md:order-1 md:mb-0",
    "data-testid": "specialOfferBlock",
    iconName: icons["a" /* ICONS */].SPECIAL_OFFERS
  }, ActivitiesFilteredList_jsx(Text["a" /* Text */], {
    className: "font-bold text-sienna",
    "data-testid": "specialOfferText-title",
    text: (message === null || message === void 0 ? void 0 : message.title) || '',
    theme: "text-sans-n1"
  }), ActivitiesFilteredList_jsx(Text["a" /* Text */], {
    "data-testid": "specialOfferText-subtitle",
    text: (message === null || message === void 0 ? void 0 : message.subtitle) || '',
    theme: "text-sans-n1"
  })), ActivitiesFilteredList_jsx("p", {
    className: "flex flex-1 items-center gap-5 text-14 font-bold text-orange"
  }, ActivitiesFilteredList_jsx(AvailabilityBadge["a" /* AvailabilityBadge */], {
    isOnDemand: true
  }), Object(i18n["h" /* t */])('common.onDemand'))), notEmptyCategories.length > 1 && ActivitiesFilteredList_jsx("div", {
    className: "scroll-x scrollbar-hidden"
  }, ActivitiesFilteredList_jsx("ul", {
    className: "-m-5 mb-20 flex"
  }, ActivitiesFilteredList_jsx("li", {
    className: "p-5"
  }, ActivitiesFilteredList_jsx(FilterButton["a" /* FilterButton */], {
    isActive: !filter,
    onClick: function onClick() {
      return setFilter(null);
    }
  }, Object(i18n["h" /* t */])('common.activities.seeAll'))), notEmptyCategories.map(function (cat) {
    return ActivitiesFilteredList_jsx("li", {
      className: "p-5",
      key: cat.id
    }, ActivitiesFilteredList_jsx(FilterButton["a" /* FilterButton */], {
      isActive: filter === cat.id,
      onClick: function onClick() {
        return setFilter(cat.id);
      }
    }, cat.name));
  }))), ActivitiesFilteredList_jsx(ActivitiesList_ActivitiesList, {
    activities: filter ? activities.filter(function (a) {
      return a.categoriesIds.includes(filter);
    }) : activities,
    category: category,
    colsNumber: colsNumber,
    hasRentals: hasRentals
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx + 5 modules
var ImmersiveSlideShow = __webpack_require__("r+bv");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// CONCATENATED MODULE: ./src/client/components/widgets/information-card/InformationCard.jsx
var InformationCard_jsx = react_default.a.createElement;




var InformationCard_InformationCard = function InformationCard(_ref) {
  var className = _ref.className,
      text = _ref.text,
      title = _ref.title;

  if (!title || !text) {
    return null;
  }

  return InformationCard_jsx("article", {
    className: className
  }, InformationCard_jsx(Title["a" /* Title */], {
    className: "mb-10",
    theme: "title-brand-n3"
  }, title), InformationCard_jsx(TextSeeMore["a" /* TextSeeMore */], {
    text: text,
    dataTestIdPrefix: "InformationCard",
    hasNoScrollOnCollapse: true,
    seeLessLabel: Object(i18n["h" /* t */])('common.close'),
    seeMoreLabel: Object(i18n["h" /* t */])('common.viewMore'),
    seeMoreSize: 150
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/facility-card/FacilityCard.utils.js











var LABELS = {
  GOLF_HOLES_NUMBER: 'common.activities.holesNumber',
  GOLF_INDEX: 'common.activities.index',
  GOLF_PAR: 'common.activities.par',
  POOL_HEATING_DESCRIPTION: 'common.heated'
};
var FacilityCard_utils_getFacilityHeatedLabel = function getFacilityHeatedLabel(_ref) {
  var isHeated = _ref.isHeated,
      hasPoolHeatingDescription = _ref.hasPoolHeatingDescription;

  if (!hasPoolHeatingDescription && isHeated) {
    return Object(i18n["h" /* t */])('common.heated');
  }

  return null;
};
var FacilityCard_utils_getFacilityInfoList = function getFacilityInfoList(facility) {
  var _ref2 = facility || {},
      distanceAndTransferDescription = _ref2.distanceAndTransferDescription,
      hasFreeAccess = _ref2.hasFreeAccess,
      hasNightLighting = _ref2.hasNightLighting,
      level = _ref2.level,
      localisation = _ref2.localisation,
      openingHours = _ref2.openingHours,
      specificInformation = _ref2.specificInformation,
      technicalSpecificities = _ref2.technicalSpecificities,
      isOutdoor = _ref2.isOutdoor;

  var hasPoolHeatingDescription = (specificInformation || []).some(function (el) {
    return el.type === booking_constants["q" /* POOL_HEATING_DESCRIPTION */];
  });
  var facilityHeatedLabel = FacilityCard_utils_getFacilityHeatedLabel({
    isHeated: technicalSpecificities.isHeated,
    hasPoolHeatingDescription: hasPoolHeatingDescription
  });
  var list = [{
    value: isOutdoor === null ? '' : Object(i18n["h" /* t */])("common.".concat(isOutdoor ? 'outdoor' : 'indoor'))
  }, {
    value: distanceAndTransferDescription
  }, {
    value: hasFreeAccess ? Object(i18n["h" /* t */])('common.freeAccess') : null
  }, {
    value: hasNightLighting ? Object(i18n["h" /* t */])('common.nightLighting') : null
  }, {
    value: facilityHeatedLabel
  }, {
    value: level
  }, {
    value: localisation
  }, {
    value: (openingHours || []).map(function (_ref3) {
      var closing = _ref3.closing,
          opening = _ref3.opening;
      return [opening, closing].join(' - ');
    }).join(', ')
  }].concat(Object(toConsumableArray["a" /* default */])((specificInformation || []).map(function (_ref4) {
    var type = _ref4.type,
        value = _ref4.value;
    return {
      label: LABELS[type] ? Object(i18n["h" /* t */])(LABELS[type]) : '',
      value: value
    };
  })), [{
    value: ((technicalSpecificities === null || technicalSpecificities === void 0 ? void 0 : technicalSpecificities.typesDescription) || []).join(', ')
  }], Object(toConsumableArray["a" /* default */])(Object.entries(technicalSpecificities).filter(function (_ref5) {
    var _ref6 = Object(slicedToArray["a" /* default */])(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return !['isHeated', 'unit', 'typesDescription'].includes(key) && value;
  }).map(function (_ref7) {
    var _ref8 = Object(slicedToArray["a" /* default */])(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return {
      label: Object(i18n["h" /* t */])("common.".concat(key)),
      // $FlowFixMe
      value: "".concat(value).concat(technicalSpecificities.unit)
    };
  })));
  return list.filter(function (l) {
    return Boolean(l.value);
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/facility-card/FacilityCard.jsx




var FacilityCard_jsx = react_default.a.createElement;





var FacilityCard_FacilityCard = function FacilityCard(_ref) {
  var className = _ref.className,
      facility = _ref.facility;

  if (!facility) {
    return null;
  }

  var _ref2 = facility || {},
      description = _ref2.description,
      id = _ref2.id,
      name = _ref2.name,
      quantity = _ref2.quantity,
      subTitle = _ref2.subTitle;

  var list = FacilityCard_utils_getFacilityInfoList(facility);
  return FacilityCard_jsx("article", {
    className: Object(classnames_utils["a" /* classnames */])(className),
    id: id
  }, FacilityCard_jsx("header", {
    className: "mb-10"
  }, FacilityCard_jsx(Title["a" /* Title */], {
    hLevel: 3,
    theme: "title-brand-n4"
  }, quantity, " ", name), subTitle && FacilityCard_jsx("h4", {
    className: "text-14"
  }, subTitle)), FacilityCard_jsx(Text["a" /* Text */], {
    className: "mb-10",
    text: description,
    theme: "text-sans-n1"
  }), Boolean(list.length) && FacilityCard_jsx("ul", {
    className: "space-y-5 text-14"
  }, list.map(function (l, index) {
    var label = l.label || '';
    return FacilityCard_jsx("li", {
      key: label + '-' + index
    }, label && FacilityCard_jsx("span", {
      className: "font-bold"
    }, label, " "), l.value);
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/layer-activities/Facilities.jsx

var Facilities_jsx = react_default.a.createElement;



var Facilities_Facilities = function Facilities(_ref) {
  var className = _ref.className,
      items = _ref.items,
      title = _ref.title;

  if (!(items === null || items === void 0 ? void 0 : items.length)) {
    return null;
  }

  return Facilities_jsx("section", {
    className: className
  }, Facilities_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n3"
  }, title), Facilities_jsx("div", {
    className: "md:columns-2 gap-20"
  }, items.map(function (facility) {
    return Facilities_jsx(FacilityCard_FacilityCard, {
      className: "break-inside-avoid-column mb-40",
      facility: facility,
      key: facility.id
    });
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/layer-activities/LayerActivitiesBody.jsx











var LayerActivitiesBody_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var getCols = function getCols(isDesktop, isTablet) {
  if (isDesktop) {
    return 3;
  }

  if (isTablet) {
    return 2;
  }

  return 1;
};

var LayerActivitiesBody_LayerActivitiesBody = function LayerActivitiesBody(_ref) {
  var _category$categories, _category$categories2;

  var category = _ref.category;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      bookingId = _useContext.bookingId,
      hasRentals = _useContext.hasRentals;

  if (!category) {
    return null;
  }

  var cols = getCols(isDesktop, isTablet);

  var _ref2 = category || {},
      activities = _ref2.activities,
      bookingDescription = _ref2.bookingDescription,
      description = _ref2.description,
      equipmentRentalDescription = _ref2.equipmentRentalDescription,
      id = _ref2.id,
      images = _ref2.images,
      keywords = _ref2.keywords,
      name = _ref2.name,
      shortDescription = _ref2.shortDescription,
      supervisionDescription = _ref2.supervisionDescription,
      termsAndConditionsDescription = _ref2.termsAndConditionsDescription;

  var flattenActivities = Object(activities_utils["b" /* flatActivities */])([], category);
  var includedActivities = flattenActivities.filter(Object(activities_utils["a" /* filterActivities */])(true));
  var onDemandActivities = (activities || []).filter(Object(activities_utils["a" /* filterActivities */])(false));
  var flattenFacilities = Object(activities_utils["c" /* flatFacilities */])([], category);
  var outsideFacilities = flattenFacilities.filter(function (facility) {
    return !facility.isOnSite;
  });
  var resortFacilities = flattenFacilities.filter(function (facility) {
    return facility.isOnSite;
  });
  var information = [{
    text: bookingDescription,
    title: Object(i18n["h" /* t */])('common.bookingLabel')
  }, {
    text: supervisionDescription,
    title: Object(i18n["h" /* t */])('common.supervisionLabel')
  }, {
    text: termsAndConditionsDescription,
    title: Object(i18n["h" /* t */])('common.termsAndConditionsLabel')
  }, {
    text: equipmentRentalDescription,
    title: Object(i18n["h" /* t */])('common.equipments')
  }].filter(function (_ref3) {
    var text = _ref3.text;
    return Boolean(text);
  });
  var catName = name || Object(i18n["h" /* t */])('booking.activities.otherActivities');
  var message = id === 'AC_Wellness' ? {
    title: Object(i18n["h" /* t */])('booking.activities.wellness.priceAndAvailibiltyInformations'),
    subtitle: Object(i18n["h" /* t */])('booking.activities.wellness.priceAndAvailibiltyInformations2')
  } : {};
  var items = (category.categories || []).map(function (c) {
    var categoryOnDemandActivities = Object(activities_utils["b" /* flatActivities */])([], c).filter(Object(activities_utils["a" /* filterActivities */])(false));
    var onlineCategoryOnDemandActivitiesSorted = Object(activities_utils["h" /* sortCategoryOnDemandActivitiesByStartingPrice */])(categoryOnDemandActivities);

    if (!onlineCategoryOnDemandActivitiesSorted.length) {
      return null;
    }

    return {
      header: {
        title: c.name
      },
      headerId: c.id,
      panelId: "panel-".concat(c.id),
      content: LayerActivitiesBody_jsx(ActivitiesFilteredList_ActivitiesFilteredList, {
        category: _objectSpread(_objectSpread({}, c), {}, {
          activities: onlineCategoryOnDemandActivitiesSorted
        }),
        colsNumber: cols,
        hasRentals: hasRentals,
        message: message
      })
    };
  }).filter(Boolean);
  return LayerActivitiesBody_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col', {
      'pb-80': !information.length
    })
  }, LayerActivitiesBody_jsx("div", {
    className: "relative mb-70 md:mb-60"
  }, (images === null || images === void 0 ? void 0 : images.length) > 1 ? LayerActivitiesBody_jsx(ImmersiveSlideShow["a" /* ImmersiveSlideShow */], {
    controlsTheme: "activities",
    isPaginationDisabled: false,
    immersiveSize: "medium",
    media: images,
    nextLabel: "next",
    pictureAltLabel: "picture",
    previousLabel: "previous"
  }) : LayerActivitiesBody_jsx(Hero["a" /* Hero */], {
    className: "bg-darkGrey",
    size: "medium",
    url: images === null || images === void 0 ? void 0 : images[0]
  }), LayerActivitiesBody_jsx("div", {
    className: "absolute bottom-0 w-full translate-y-1/2 transform text-center leading-0"
  }, LayerActivitiesBody_jsx(Badge["a" /* Badge */], {
    className: "size-140 border-white bg-white text-black md:size-120",
    iconName: Object(activities_utils["d" /* getActivitiesCategoryIcon */])(keywords, id),
    iconSize: "3.25rem",
    variant: "pill"
  }))), LayerActivitiesBody_jsx(SiteContainer["a" /* SiteContainer */], null, LayerActivitiesBody_jsx("div", {
    className: "flex flex-col gap-20 md:flex-row"
  }, LayerActivitiesBody_jsx("div", {
    className: "md:basis-2/5"
  }, LayerActivitiesBody_jsx(Title["a" /* Title */], {
    dataTestId: "Activities-Layer-Header",
    theme: "title-brand-n44"
  }, catName), shortDescription && LayerActivitiesBody_jsx("p", {
    className: "text-20 md:text-24"
  }, shortDescription)), description && LayerActivitiesBody_jsx("div", {
    className: "md:basis-3/5"
  }, LayerActivitiesBody_jsx(Text["a" /* Text */], {
    "data-testid": "Activities-Layer-Description",
    text: description,
    theme: "text-sans-n3"
  })))), !!includedActivities.length && LayerActivitiesBody_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "py-40"
  }, LayerActivitiesBody_jsx("p", {
    className: "mb-20 flex items-center gap-5 text-14 font-bold leading-1 text-green"
  }, LayerActivitiesBody_jsx(AvailabilityBadge["a" /* AvailabilityBadge */], null), Object(i18n["h" /* t */])('common.included')), LayerActivitiesBody_jsx(Slider["a" /* Slider */], {
    cols: cols > 1 ? cols : 0,
    hasControls: isTablet,
    navPosition: "top",
    nbItemsToScroll: cols,
    nextLabel: Object(i18n["h" /* t */])('common.next'),
    previousLabel: Object(i18n["h" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden -mx-10",
    scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
    scrollItemClassName: Object(classnames_utils["a" /* classnames */])('w-full max-w-full flex-none overflow-hidden p-10', {
      'w-[calc(100vw-2*1.25rem)]': !(cols > 1) && includedActivities.length > 1
    })
  }, includedActivities.map(function (a) {
    return LayerActivitiesBody_jsx(ActivityCard["a" /* ActivityCard */], {
      activity: a,
      bookingId: bookingId,
      key: a.id
    });
  }))), (!!onDemandActivities.length || hasRentals && category.upsellType === BookingConfirmationTracking_utils["f" /* upSellTypeMapping */].WINTER_SPORT || !!((_category$categories = category.categories) === null || _category$categories === void 0 ? void 0 : _category$categories.length)) && LayerActivitiesBody_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "py-40"
  }, !!((_category$categories2 = category.categories) === null || _category$categories2 === void 0 ? void 0 : _category$categories2.length) && LayerActivitiesBody_jsx(Tabs["a" /* Tabs */], {
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    id: "activities",
    scrollBackwardLabel: Object(i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(i18n["h" /* t */])('common.scrollForward')
  }), (!!onDemandActivities.length || hasRentals && category.upsellType === BookingConfirmationTracking_utils["f" /* upSellTypeMapping */].WINTER_SPORT) && LayerActivitiesBody_jsx(react["Fragment"], null, LayerActivitiesBody_jsx("p", {
    className: "mb-20 flex items-center gap-5 text-14 font-bold text-orange"
  }, LayerActivitiesBody_jsx(AvailabilityBadge["a" /* AvailabilityBadge */], {
    isOnDemand: true
  }), Object(i18n["h" /* t */])('common.onDemand')), LayerActivitiesBody_jsx(ActivitiesList_ActivitiesList, {
    activities: Object(activities_utils["h" /* sortCategoryOnDemandActivitiesByStartingPrice */])(onDemandActivities),
    colsNumber: cols,
    category: category,
    hasRentals: hasRentals
  }))), (!!resortFacilities.length || !!outsideFacilities.length) && LayerActivitiesBody_jsx(SiteContainer["a" /* SiteContainer */], null, LayerActivitiesBody_jsx(Title["a" /* Title */], {
    className: "border-b-1 border-lightGrey",
    theme: "title-brand-n1"
  }, Object(i18n["h" /* t */])('common.activities.facilitiesLabel')), LayerActivitiesBody_jsx(Facilities_Facilities, {
    className: "py-40",
    items: resortFacilities,
    title: Object(i18n["h" /* t */])('booking.activities.resortFacilities')
  }), LayerActivitiesBody_jsx(Facilities_Facilities, {
    className: "py-40",
    items: outsideFacilities,
    title: Object(i18n["h" /* t */])('booking.activities.outsideFacilities')
  })), !!information.length && LayerActivitiesBody_jsx(react["Fragment"], null, LayerActivitiesBody_jsx(Hr["a" /* Hr */], null), LayerActivitiesBody_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "mb-100 mt-auto py-40"
  }, LayerActivitiesBody_jsx("section", {
    className: "gap-20 md:columns-2"
  }, information.map(function (_ref4) {
    var text = _ref4.text,
        title = _ref4.title;
    return LayerActivitiesBody_jsx(InformationCard_InformationCard, {
      className: "mb-40 break-inside-avoid-column",
      key: title,
      text: text,
      title: title
    });
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/layer-activities/LayerActivities.jsx










var LayerActivities_jsx = react_default.a.createElement;

function LayerActivities_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function LayerActivities_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LayerActivities_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LayerActivities_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var LayerActivities_LayerActivities = function LayerActivities(_ref) {
  var categories = _ref.categories,
      forwardRef = _ref.forwardRef,
      layerName = _ref.layerName,
      thematics = _ref.thematics,
      tracking = _ref.tracking;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      updateInfo = _useContext.updateInfo,
      setUpdateInfo = _useContext.setUpdateInfo;

  var beEngineTrackingContext = Object(react["useContext"])(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */]);
  var toasterRef = Object(react["useRef"])();
  var router = Object(next_router["useRouter"])();
  var queryParams = router.query;
  var items = queryParams.type === 'CATEGORIES' ? categories : thematics;
  var category = items.find(function (c) {
    return c.id === (queryParams === null || queryParams === void 0 ? void 0 : queryParams.catId);
  });

  if (!category) {
    return null;
  }

  var stateTracking = tracking || {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].BE_LAYER_ACTIVITIES,
    payload: LayerActivities_objectSpread(LayerActivities_objectSpread({}, beEngineTrackingContext), {}, {
      activity_type: Object(string_util["b" /* camelToSnakeCase */])(category.upsellType),
      availability: category.onlineBookableCount !== 0 ? 'yes' : 'no'
    })
  };
  var title = category.name || Object(i18n["h" /* t */])('booking.activities.otherActivities');
  return LayerActivities_jsx(ClosableLayer["a" /* ClosableLayer */], {
    ariaLabel: title,
    ariaLabelledby: constants["d" /* ID_LAYER_HEADER__CA__ACTIVITIES */],
    bgColor: colors["a" /* COLORS */].WHITE,
    dataTestId: "UpsellActivitiesLayer",
    externalFocusTrapRefs: [forwardRef, toasterRef],
    hasAnimateEnter: true,
    header: LayerActivities_jsx(Title["a" /* Title */], {
      className: "w-full justify-center",
      id: constants["d" /* ID_LAYER_HEADER__CA__ACTIVITIES */],
      theme: "title-brand-n3"
    }, title),
    name: layerName || layers_constants["c" /* LAYER_NAME_UPSELL_ACTIVITIES */],
    params: ['catId', 'type'],
    tracking: stateTracking
  }, LayerActivities_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].SIENNA,
    onClose: function onClose() {
      return setUpdateInfo && setUpdateInfo(null);
    },
    isFixed: true,
    portalName: Portal_constants["b" /* AFTER_APP */],
    ref: toasterRef,
    visible: !!updateInfo
  }, LayerActivities_jsx("span", {
    className: "flex items-center gap-10"
  }, !!(updateInfo === null || updateInfo === void 0 ? void 0 : updateInfo.itemsNumber) && LayerActivities_jsx("span", {
    className: "inline-flex aspect-square h-30 shrink-0 items-center justify-center rounded-full bg-success p-5 text-white"
  }, "+", updateInfo.itemsNumber), updateInfo === null || updateInfo === void 0 ? void 0 : updateInfo.message)), LayerActivities_jsx(LayerActivitiesBody_LayerActivitiesBody, {
    category: category
  }));
};

/***/ }),

/***/ "0GXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlyerCard; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("u/u4");
/* harmony import */ var _badge_Badge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("VHif");
/* harmony import */ var _dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("i5Mr");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _title_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var FlyerCard = function FlyerCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      imageUrl = _ref.imageUrl,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isSmall = _ref.isSmall,
      isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
      label = _ref.label,
      onClick = _ref.onClick,
      title = _ref.title,
      url = _ref.url,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "imageUrl", "isChecked", "isDisabled", "isSmall", "label", "onClick", "title", "url"]);

  return __jsx("article", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('rounded-12 bg-white shadow-sm transition-all duration-250 ease-in', className)
  }), __jsx(_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('relative isolate flex h-full flex-col justify-start', {
      'p-15': !isSmall,
      'p-10': isSmall
    }),
    onClick: onClick,
    shallow: true,
    tagname: "div",
    url: isDisabled ? '' : url
  }, isChecked && __jsx("span", {
    className: "absolute end-0 top-0 m-5"
  }, __jsx(_badge_Badge__WEBPACK_IMPORTED_MODULE_6__[/* Badge */ "a"], {
    className: "size-20 border-success bg-success text-white",
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CHECK,
    variant: "pill"
  })), __jsx("div", {
    className: "w-full shrink-0 self-center overflow-hidden rounded-full bg-grey"
  }, __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* Image */ "a"], {
    className: "h-full",
    imageUrl: imageUrl,
    ratioDisplay: 1 / 4,
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__[/* default */ "c"].SQUARE
  })), __jsx("div", {
    className: "basis-[20%]"
  }, __jsx("p", {
    className: "text-12 font-bold text-sienna"
  }, label), __jsx(_title_Title__WEBPACK_IMPORTED_MODULE_9__[/* Title */ "a"], {
    theme: "title-sans-n3"
  }, __jsx("span", {
    className: "overflow-wrap-break-word line-clamp-2"
  }, title))), children));
};

/***/ }),

/***/ "1CQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useLayer; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ESA2");











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





var useLayer = function useLayer(layerName) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var uri = arguments.length > 2 ? arguments[2] : undefined;
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_10__["useRouter"])();
  var query = router.query;
  var isLayerOpened = (query === null || query === void 0 ? void 0 : query[_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["appQueryParameters"].openLayer]) === layerName;
  var nextUri = new urijs__WEBPACK_IMPORTED_MODULE_11___default.a(uri ? uri : router.asPath).addQuery(_objectSpread(Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({}, _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["appQueryParameters"].openLayer, layerName), params)).hash('');

  var openLayer = function openLayer(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    router.push(nextUri.resource(), undefined, {
      shallow: true
    });
  };

  var cleanUrl = function cleanUrl(path) {
    return new urijs__WEBPACK_IMPORTED_MODULE_11___default.a(path).clone().removeSearch([_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["appQueryParameters"].openLayer].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Object.keys(params)))).resource();
  };

  var closeLayer = function closeLayer(forceRefreshOnClose) {
    var newUri = cleanUrl(router.asPath);

    if (forceRefreshOnClose) {
      Object(_utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_13__[/* clearAllCacheFront */ "a"])();
      window.location = newUri;
    } else {
      router.push(newUri, undefined, {
        shallow: true
      });
    }
  };

  return {
    closeLayer: closeLayer,
    isLayerOpened: isLayerOpened,
    nextUri: nextUri,
    openLayer: openLayer
  };
};

/***/ }),

/***/ "1Wgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveIndexes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("jHPj");
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_pull__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("nnm9");
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_18__);


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ActiveIndexes = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(ActiveIndexes, _Component);

  var _super = _createSuper(ActiveIndexes);

  function ActiveIndexes() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, ActiveIndexes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "state", {
      activeIndexes: _this.props.activeIndexes || [],
      isPristine: true,
      lastIndex: 0
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "clear", function () {
      _this.setState(function (prevState) {
        if (prevState.activeIndexes.length) {
          return {
            activeIndexes: []
          };
        }
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "update", function (index) {
      var _this$props$onUpdate = _this.props.onUpdate,
          onUpdate = _this$props$onUpdate === void 0 ? lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a : _this$props$onUpdate;
      var activeIndexes = _this.state.activeIndexes;
      var newActiveIndexes = activeIndexes.includes(index) ? _this.removeIndex(activeIndexes, index) : _this.addIndex(activeIndexes, index);

      _this.setState({
        activeIndexes: newActiveIndexes,
        isPristine: false,
        lastIndex: index
      }, function () {
        onUpdate(index);
        Object(react_lazyload__WEBPACK_IMPORTED_MODULE_18__["forceCheck"])();
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(ActiveIndexes, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$activeInd = this.props.activeIndexes,
          activeIndexes = _this$props$activeInd === void 0 ? [] : _this$props$activeInd;

      if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_16___default()(prevProps.activeIndexes, activeIndexes)) {
        var lastIndex = activeIndexes[activeIndexes.length - 1];
        this.setState({
          activeIndexes: activeIndexes,
          lastIndex: lastIndex >= 0 ? lastIndex : prevState.lastIndex
        });
      }
    }
  }, {
    key: "addIndex",
    value: function addIndex(activeIndexes, index) {
      var hasMultipleIndexEnabled = this.props.hasMultipleIndexEnabled;

      if (hasMultipleIndexEnabled) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(activeIndexes), [index]);
      }

      return [index];
    }
  }, {
    key: "removeIndex",
    value: function removeIndex(activeIndexes, index) {
      var hasNoIndexEnabled = this.props.hasNoIndexEnabled;

      if (hasNoIndexEnabled || activeIndexes.length > 1) {
        return lodash_pull__WEBPACK_IMPORTED_MODULE_14___default()(activeIndexes, index);
      }

      return activeIndexes;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        activeIndexes: this.state.activeIndexes,
        clear: this.clear,
        isPristine: this.state.isPristine,
        lastIndex: this.state.lastIndex,
        update: this.update
      });
    }
  }]);

  return ActiveIndexes;
}(react__WEBPACK_IMPORTED_MODULE_17__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(ActiveIndexes, "defaultProps", {
  activeIndexes: [],
  hasMultipleIndexEnabled: false,
  hasNoIndexEnabled: false
});

/***/ }),

/***/ "2Odu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServicesContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // $FlowFixMe

var ServicesContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "3+yQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hr; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var Hr = function Hr(_ref) {
  var className = _ref.className;
  return __jsx("hr", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('block border-0 border-solid border-lightGrey border-t-1 h-1 m-0 p-0', className)
  });
};

/***/ }),

/***/ "38qS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RentalsCta; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_layers_layers_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("RDfq");
/* harmony import */ var _hooks_use_current_uri_useCurrentUri__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Ka70");
/* harmony import */ var _hooks_use_layer_useLayer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("1CQ+");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MWZw");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qqKu");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;













var RentalsCta = function RentalsCta(_ref) {
  var className = _ref.className,
      layerName = _ref.layerName,
      onClick = _ref.onClick,
      text = _ref.text;
  var currentUri = Object(_hooks_use_current_uri_useCurrentUri__WEBPACK_IMPORTED_MODULE_5__[/* useCurrentUri */ "a"])();
  var newUri = currentUri.clone().removeSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["appQueryParameters"].openLayer).removeSearch('catId').resource();

  var _useLayer = Object(_hooks_use_layer_useLayer__WEBPACK_IMPORTED_MODULE_6__[/* useLayer */ "a"])(layerName || _utils_layers_layers_constants__WEBPACK_IMPORTED_MODULE_4__[/* LAYER_NAME_UPSELL_RENTALS */ "h"], {}, newUri),
      nextUri = _useLayer.nextUri;

  var title = Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('common.rentals.title');
  var txt = text || Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('common.rentals.text');
  var imageSrc = Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])('common.rentals.image');
  return __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
    onClick: onClick,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('group relative isolate flex items-end justify-between overflow-hidden rounded-12 p-20 text-white', className),
    "data-testid": "UpsellRentals",
    shallow: true,
    url: nextUri
  }, __jsx("div", {
    className: "absolute inset-0 -z-1 flex transform items-center transition-all duration-250 ease-in group-hover:scale-105"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_10__[/* Image */ "a"], {
    className: "flex h-full w-full",
    imageUrl: imageSrc
  }), __jsx("div", {
    className: "absolute bottom-0 h-1/2 w-full bg-gradient-to-t from-black/80"
  })), __jsx("div", null, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_11__[/* Title */ "a"], {
    className: "text-white",
    theme: "title-brand-n0"
  }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "a"], {
    className: "text-white",
    text: txt,
    theme: "text-sans-n3"
  })), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
    className: "shrink-0",
    hasRtl: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ARROW_RIGHT,
    width: "1rem"
  }));
};

/***/ }),

/***/ "4/4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tabs; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.themes.js
var themes = {
  "default": {
    thScrollable: 'w-full',
    thHeader: 'flex-col md:flex-row gap-5 md:items-center md:justify-between mb-20',
    thList: 'gap-5',
    thSlot: '',
    thBody: 'relative'
  },
  simple: {
    thList: 'pb-10 justify-between',
    thListItem: '',
    thSlot: 'pb-10'
  },
  underlined: {
    thHeader: 'flex-col md:flex-row md:items-center md:justify-between',
    thList: 'gap-10 md:gap-20 whitespace-nowrap',
    thListItem: 'flex-none',
    thSlot: 'flex items-center ms-auto top-full mt-10 absolute md:static md:mt-0 px-20 md:px-0 mb-5 end-0',
    thBody: 'py-20'
  },
  rounded: {
    thScrollable: 'flex-1',
    thListItem: 'flex-1',
    thBody: 'bg-white border-1 border-t-0 border-lightGrey rounded-b-12'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var Tabs_Tabs = function _Tabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      bgColor = _ref.bgColor,
      className = _ref.className,
      containerSize = _ref.containerSize,
      _ref$forceEnableHeade = _ref.forceEnableHeaderClick,
      forceEnableHeaderClick = _ref$forceEnableHeade === void 0 ? false : _ref$forceEnableHeade,
      hasControlsOnTouch = _ref.hasControlsOnTouch,
      hasBackground = _ref.hasBackground,
      isContainerWide = _ref.isContainerWide,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      _ref$initialSelectedI = _ref.initialSelectedItem,
      initialSelectedItem = _ref$initialSelectedI === void 0 ? 0 : _ref$initialSelectedI,
      id = _ref.id,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onSelect = _ref.onSelect,
      onTabClick = _ref.onTabClick,
      scrollForwardLabel = _ref.scrollForwardLabel,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      slotLeft = _ref.slotLeft,
      slotRight = _ref.slotRight,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      message = _ref.message;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  if (!items.length) {
    return null;
  }

  var refsArray = [];
  var _themes$theme = themes[theme],
      thBody = _themes$theme.thBody,
      thHeader = _themes$theme.thHeader,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thScrollable = _themes$theme.thScrollable,
      thSlot = _themes$theme.thSlot;

  var tabUpdate = function tabUpdate(idx, update) {
    update(idx);
    refsArray[idx] && refsArray[idx].focus();
  };

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index,
        update = _ref2.update;

    if (items.length > 1) {
      var lastItem = items.length - 1;

      switch (e.which) {
        case keyCodes["c" /* ARROW_RIGHT */]:
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          tabUpdate(index === lastItem ? 0 : index + 1, update);
          break;

        case keyCodes["b" /* ARROW_LEFT */]:
        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          tabUpdate(index === 0 ? lastItem : index - 1, update);
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          tabUpdate(0, update);
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          tabUpdate(lastItem, update);
          break;

        default:
      }
    }
  };

  var tabsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: [initialSelectedItem],
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        lastIndex = _ref3.lastIndex;
    var els = items.filter(Boolean).map(function (_ref4, index) {
      var customHeader = _ref4.customHeader,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var onClick = function onClick() {
        tabUpdate(index, update);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(headerId, index);
      };

      var isActive = activeIndexes.includes(index);

      var setRef = function setRef(ref) {
        refsArray[index] = ref;
      };

      var title = header.title,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title"]);

      var headerProps = _objectSpread(_objectSpread({}, rest), {}, {
        className: thListItem,
        controlsId: panelId,
        id: headerId,
        isActive: isActive,
        isDisabled: forceEnableHeaderClick ? false : tabsCount <= 1,
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index,
            update: update
          });
        },
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        tabIndex: isActive || index === lastIndex ? 0 : -1
      });

      if (isFunction_default()(customHeader)) {
        return customHeader(headerProps, setRef);
      }

      return title && __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, headerProps, {
        key: headerId,
        ref: setRef,
        role: "tab",
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        theme: theme
      }), title);
    });

    var tabsList = __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex w-full', thList),
      role: "tablist"
    }, els);

    var hasActiveIndex = activeIndexes.length > 0 && !activeIndexes.includes(-1);
    return __jsx("section", {
      className: Object(classnames_utils["a" /* classnames */])('relative isolate', className),
      id: id,
      "data-cs-override-id": "Tabs" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
      ,
      "data-testid": "tabs"
    }, __jsx(SiteContainer["a" /* SiteContainer */], {
      className: "z-1",
      isWide: isContainerWide,
      size: containerSize
    }, __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex', thHeader)
    }, slotLeft && __jsx("div", {
      className: thSlot
    }, slotLeft(activeIndexes)), isScrollable ? __jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      className: thScrollable,
      forwardLabel: scrollForwardLabel,
      hasControlsOnTouch: hasControlsOnTouch,
      navPosition: "top",
      theme: "tabs"
    }, tabsList) : tabsList, slotRight && __jsx("div", {
      className: thSlot
    }, slotRight(activeIndexes)))), message && __jsx("div", {
      className: "justify-end md:flex"
    }, __jsx(Notification["a" /* Notification */], {
      className: "mb-20 md:order-1 md:mb-0",
      "data-testid": "specialOfferBlock",
      iconName: icons["a" /* ICONS */].SPECIAL_OFFERS
    }, __jsx(Text["a" /* Text */], {
      "data-testid": "specialOfferText",
      text: message,
      theme: "text-sans-n1"
    }))), __jsx("div", {
      "data-testid": "tabs-items-container",
      className: Object(classnames_utils["a" /* classnames */])(Object(defineProperty["a" /* default */])({}, Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground, bgColor), hasActiveIndex), thBody)
    }, items.filter(Boolean).map(function (_ref5, index) {
      var content = _ref5.content,
          headerId = _ref5.headerId,
          panelId = _ref5.panelId;
      var isActive = activeIndexes.includes(index);
      return (!isContentUnmountedOnCollapse || isActive) && __jsx("div", {
        "aria-hidden": !isActive,
        "aria-labelledby": headerId,
        className: Object(classnames_utils["a" /* classnames */])({
          'pointer-events-none invisible h-0 overflow-hidden': !isActive,
          'animation-duration-500 animate-fadeIn': isActive
        }),
        "data-cs-override-id": "Tabs-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        key: panelId,
        role: "tabpanel",
        "data-testid": "tabs-item-".concat(index, "-content")
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        isWide: isContainerWide,
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i),
          index: index
        }) : null;
      })));
    })));
  });
};

var Tabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Tabs_Tabs);

/***/ }),

/***/ "4xcl":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

module.exports = upperCase;


/***/ }),

/***/ "5YQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivitiesBooking; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _context_ServicesContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2Odu");
/* harmony import */ var _layer_activities_LayerActivities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("04qU");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var ActivitiesBooking = function ActivitiesBooking(_ref) {
  var categories = _ref.categories,
      children = _ref.children,
      contextValue = _ref.contextValue,
      thematics = _ref.thematics,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["categories", "children", "contextValue", "thematics"]);

  return __jsx(_context_ServicesContext__WEBPACK_IMPORTED_MODULE_3__[/* ServicesContext */ "a"].Provider, {
    value: contextValue
  }, children, __jsx(_layer_activities_LayerActivities__WEBPACK_IMPORTED_MODULE_4__[/* LayerActivities */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    categories: categories,
    thematics: thematics
  })));
};

/***/ }),

/***/ "5iTF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvailabilityBadge; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VHif");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var AvailabilityBadge = function AvailabilityBadge(_ref) {
  var _ref$isOnDemand = _ref.isOnDemand,
      isOnDemand = _ref$isOnDemand === void 0 ? false : _ref$isOnDemand,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["isOnDemand"]);

  return __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('size-30 border-green bg-green text-white', {
      'border-orange bg-orange': isOnDemand
    }),
    iconSize: "0.875rem",
    variant: "pill"
  }, rest, {
    iconName: isOnDemand ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ON_DEMAND : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ALL_INCLUSIVE
  }));
};

/***/ }),

/***/ "625B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return featuresIcons; });
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");


var featuresIcons = {
  /* activities */
  activity_search_criterion_archery: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].ARCHERY
  },
  activity_search_criterion_climbing: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].CLIMBING
  },
  activity_search_criterion_creactive: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].CREACTIVE
  },
  activity_search_criterion_cycling_mountain_biking: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].VTT
  },
  activity_search_criterion_dance: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].DANCE
  },
  activity_search_criterion_entertainment: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].DANCE
  },
  activity_search_criterion_fitness: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].CARDIO_TRAINING
  },
  activity_search_criterion_fitness_and_work_out: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].CARDIO_TRAINING
  },
  activity_search_criterion_flying_trapeze_circus: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].TRAPEZE
  },
  activity_search_criterion_football: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SPORT
  },
  activity_search_criterion_golf: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].GOLF
  },
  activity_search_criterion_horseriding: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].RIDING
  },
  activity_search_criterion_ice_skating: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].ICE_SKATING
  },
  activity_search_criterion_kayak: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].KAYAK
  },
  activity_search_criterion_kitesurfing: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].KITESURF
  },
  activity_search_criterion_nordic_walking: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].NORDIC_WALKING
  },
  activity_search_criterion_padel_tennis: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].PADEL_TENNIS
  },
  activity_search_criterion_pickleball: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].PICKLEBALL
  },
  activity_search_criterion_sailing: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SAILING
  },
  activity_search_criterion_scuba_diving: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].DIVING
  },
  activity_search_criterion_skiing_snowboarding: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SKI
  },
  activity_search_criterion_snorkelling: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SNORKELLING
  },
  activity_search_criterion_snowboard: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SNOWBOARD
  },
  activity_search_criterion_snow_shoe_walks: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SKI_IN_OUT
  },
  activity_search_criterion_stand_up_paddle: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].STAND_UP_PADDLE
  },
  activity_search_criterion_volleyball: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SPORT_SCHOOL
  },
  activity_search_criterion_surfing: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].TRIDENT1
  },
  activity_search_criterion_swimming: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].SWIM
  },
  activity_search_criterion_tai_chi: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].TRIDENT1
  },
  activity_search_criterion_tennis: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].TENNIS
  },
  activity_search_criterion_trail: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].RUNNING
  },
  activity_search_criterion_treeetop_adventure: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].TREETOP_ADVENTURE
  },
  activity_search_criterion_walking_hiking: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].WALKING
  },
  activity_search_criterion_waterskiing_wakeboarding: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].WATERSKI
  },
  activity_search_criterion_whitewater_sports: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].TRIDENT1
  },
  activity_search_criterion_wingfoil: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].WINGFOIL
  },
  activity_search_criterion_windsurfing: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].WINDSURFING
  },
  activity_search_criterion_yoga: {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].YOGA
  },

  /* childcare */
  activity_search_criterion_petit_club: {
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].TURQUOISE,
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].PETIT_CLUB
  },
  activity_search_criterion_mini_club: {
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    textColor: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE_WAVE,
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].MINI_CLUB_PLUS
  },
  activity_search_criterion_mini_club_plus: {
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    textColor: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE_WAVE,
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].MINI_CLUB_PLUS
  },
  activity_search_criterion_baby_club: {
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].BABY_CLUB
  },
  activity_search_criterion_passworld: {
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLACK,
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].PASSWORLD
  },
  activity_search_criterion_junior: {
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLACK,
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_0__[/* ICONS */ "a"].JUNIOR
  }
};

/***/ }),

/***/ "7x6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Zoom; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1JJ2");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0IQ5");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};
var Zoom = function Zoom(_ref) {
  var imageUrl = _ref.imageUrl,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? '' : _ref$hint,
      inert = _ref.inert;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_1__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop,
      isRTL = _useResponsive.isRTL;

  var scrollArea = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (isRTL && (scrollArea === null || scrollArea === void 0 ? void 0 : scrollArea.current)) {
      scrollArea.current.scrollLeft = scrollArea.current.scrollWidth;
    }
  });
  return __jsx("div", {
    className: "direction-ltr relative h-400 lg:h-full"
  }, hint && !isDesktop && __jsx("span", {
    className: "absolute inset-x-0 top-0 mt-20 flex items-center justify-center gap-5 px-10 font-brand text-14 leading-0 text-saffron"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    width: "1.25rem",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].LIGHTBULB
  }), __jsx("span", {
    className: "leading-1"
  }, hint)), __jsx("div", {
    onTouchStart: function onTouchStart(e) {
      return inert ? e.stopPropagation() : null;
    },
    onTouchMove: function onTouchMove(e) {
      return inert ? e.stopPropagation() : null;
    },
    onTouchEnd: function onTouchEnd(e) {
      return inert ? e.stopPropagation() : null;
    },
    className: "flex h-full w-full items-center justify-start overflow-x-scroll",
    ref: scrollArea
  }, __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_2__[/* Image */ "a"], {
    classNameImg: "max-w-initial max-h-initial h-full",
    hasLazyLoading: false,
    imageUrl: imageUrl,
    altMsg: alt,
    dimensions: DIMENSIONS,
    fullscreen: true,
    transformation: "resize",
    className: "h-full py-20 pt-60 sm:mx-auto lg:p-0"
  })));
};

/***/ }),

/***/ "8W+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getHowToBookI18n */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getParticpantsI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flatActivities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flatFacilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterActivities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getActivitiesCategoryIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUpsellCmsKeyPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getActivitiesLayerName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sortCategoryOnDemandActivitiesByStartingPrice; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_partition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Zl10");
/* harmony import */ var lodash_partition__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_partition__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _cms_toolkit_product_utils_productFeatures_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("625B");
/* harmony import */ var _icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _layers_layers_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("RDfq");










var getHowToBookI18n = function getHowToBookI18n(_ref) {
  var hasBookingOnline = _ref.hasBookingOnline,
      hasBookingOnsite = _ref.hasBookingOnsite;

  if (!hasBookingOnline && !hasBookingOnsite) {
    return '';
  }

  if (hasBookingOnline && hasBookingOnsite) {
    return 'common.bookOnlineOrOnsite';
  }

  return hasBookingOnline ? 'common.bookOnlineOnly' : 'common.bookOnsiteOnly';
};
var getParticpantsI18n = function getParticpantsI18n(participants) {
  var _ref2 = participants || {},
      max = _ref2.max,
      min = _ref2.min;

  var hasMinValue = min && min > 0;
  var hasMaxValue = max && max > 0;

  if (hasMinValue && hasMaxValue) {
    return 'common.groupRange';
  }

  if (hasMaxValue) {
    return 'common.groupMax';
  }

  if (hasMinValue) {
    return 'common.groupMin';
  }

  return '';
};
var flatActivities = function flatActivities(acc, cat) {
  var _cat$categories;

  var a = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(cat.activities || []));

  if ((_cat$categories = cat.categories) === null || _cat$categories === void 0 ? void 0 : _cat$categories.length) {
    return cat.categories.reduce(flatActivities, a);
  }

  return a;
};
var flatFacilities = function flatFacilities(acc, cat) {
  var _cat$categories2;

  var a = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(cat.facilities || []));

  if ((_cat$categories2 = cat.categories) === null || _cat$categories2 === void 0 ? void 0 : _cat$categories2.length) {
    return cat.categories.reduce(flatFacilities, a);
  }

  return a;
};
var filterActivities = function filterActivities(isIncluded) {
  return function (a) {
    return a.isIncluded === isIncluded;
  };
};
var getActivitiesCategoryIcon = function getActivitiesCategoryIcon(keywords, id) {
  if (keywords === null || keywords === void 0 ? void 0 : keywords.length) {
    var _featuresIcons$keywor;

    var keyword = keywords.find(function (k) {
      return _cms_toolkit_product_utils_productFeatures_icons__WEBPACK_IMPORTED_MODULE_7__[/* featuresIcons */ "a"].hasOwnProperty(k);
    });
    return keyword ? (_featuresIcons$keywor = _cms_toolkit_product_utils_productFeatures_icons__WEBPACK_IMPORTED_MODULE_7__[/* featuresIcons */ "a"][keyword]) === null || _featuresIcons$keywor === void 0 ? void 0 : _featuresIcons$keywor.icon : _icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].TRIDENT1;
  }

  switch (id) {
    case 'AC_Wellness':
      return _icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].WELL_BEING;

    case 'AC_excursions':
      return _icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CULTURE_DISCOVERY;

    default:
      return _icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].TRIDENT1;
  }
};
var getUpsellCmsKeyPath = function getUpsellCmsKeyPath(upsellType) {
  switch (upsellType) {
    case 'LAND_SPORT':
    case 'WATER_SPORT':
    case 'WINTER_SPORT':
      return 'sportActivities';

    case 'RENTAL':
      return 'skiEquipment';

    case 'EXCURSION':
      return 'excursions';

    case 'WELLNESS':
      return 'wellness';

    case 'CHILDCARE':
      return 'childcare';

    default:
      return '';
  }
};
var getActivitiesLayerName = function getActivitiesLayerName(bookingId, stayId) {
  return "".concat(_layers_layers_constants__WEBPACK_IMPORTED_MODULE_9__[/* LAYER_NAME_UPSELL_ACTIVITIES */ "c"], "_").concat(bookingId, "_").concat(stayId);
};
var sortCategoryOnDemandActivitiesByStartingPrice = function sortCategoryOnDemandActivitiesByStartingPrice(categoryOnDemandActivities) {
  var _partition2 = lodash_partition__WEBPACK_IMPORTED_MODULE_6___default()(categoryOnDemandActivities, function (_ref3) {
    var _additionalService$pr, _additionalService$pr2;

    var additionalService = _ref3.additionalService;
    return additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr = additionalService.pricingInfo) === null || _additionalService$pr === void 0 ? void 0 : (_additionalService$pr2 = _additionalService$pr.startingPricePerAdult) === null || _additionalService$pr2 === void 0 ? void 0 : _additionalService$pr2.value;
  }),
      _partition3 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_partition2, 2),
      onlineCategoryOnDemandActivities = _partition3[0],
      checkPriceInResortCategoryOnDemandActivities = _partition3[1];

  var _partition4 = lodash_partition__WEBPACK_IMPORTED_MODULE_6___default()(checkPriceInResortCategoryOnDemandActivities, function (_ref4) {
    var price = _ref4.price;
    return price === null || price === void 0 ? void 0 : price.value;
  }),
      _partition5 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_partition4, 2),
      checkPriceInResortWithPrice = _partition5[0],
      checkPriceInResortWithoutPrice = _partition5[1];

  var onlineCategoryOnDemandActivitiesSorted = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(onlineCategoryOnDemandActivities.sort(function (a, b) {
    return (// $FlowFixMe defined in partition
      a.additionalService.pricingInfo.startingPricePerAdult.value - // $FlowFixMe defined in partition
      b.additionalService.pricingInfo.startingPricePerAdult.value
    );
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(checkPriceInResortWithPrice.sort(function (a, b) {
    var _a$price, _b$price;

    return ((a === null || a === void 0 ? void 0 : (_a$price = a.price) === null || _a$price === void 0 ? void 0 : _a$price.value) || 0) - ((b === null || b === void 0 ? void 0 : (_b$price = b.price) === null || _b$price === void 0 ? void 0 : _b$price.value) || 0);
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(checkPriceInResortWithoutPrice));
  return onlineCategoryOnDemandActivitiesSorted;
};

/***/ }),

/***/ "A0wc":
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),

/***/ "DyR2":
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__("v5ZW");

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),

/***/ "ExLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ FlexRates_getFlexRatesOptions; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FlexRates_FlexRates; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/radio-button/RadioButton.jsx
var RadioButton = __webpack_require__("zwQs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/widgets/flex-rates/FlexRates.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var small = {
  thTitle: 'font-bold font-sans text-12 text-black text-center w-full',
  thNrr: 'mb-10'
};
var medium = {
  thRoot: 'sm:flex sm:flex-wrap',
  thTitle: Object(classnames_utils["a" /* classnames */])(small.thTitle, 'sm:flex-none px-10 pt-10'),
  thNrr: Object(classnames_utils["a" /* classnames */])(small.thNrr, 'sm:flex-1 sm:mb-0'),
  thStandard: Object(classnames_utils["a" /* classnames */])(small.thStandard, 'sm:flex-1')
};
var themes = {
  "default": small,
  medium: medium,
  large: _objectSpread(_objectSpread({}, medium), {}, {
    thTitle: Object(classnames_utils["a" /* classnames */])(medium.thTitle, 'md:flex-1 md:p-20 md:pb-0 md:text-initial')
  })
};
// CONCATENATED MODULE: ./src/client/components/widgets/flex-rates/FlexRates.jsx













var __jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */














var FLEX_RATES = dist["constants"].FLEX_RATES;
var FlexRates_getFlexRatesOptions = function getFlexRatesOptions(_ref, appContext, theme) {
  var price = _ref.price,
      alternativePrice = _ref.alternativePrice;

  function getPriceOffers(_ref2) {
    var _ref2$discounts = _ref2.discounts,
        discounts = _ref2$discounts === void 0 ? [] : _ref2$discounts;
    return discounts.reduce(function (acc, _ref3) {
      var offerId = _ref3.offerId;

      if (offerId) {
        return [].concat(Object(toConsumableArray["a" /* default */])(acc), [offerId]);
      }

      return acc;
    }, []);
  }

  var priceOffers = getPriceOffers(price);
  var isNRR = price.selectedRate === FLEX_RATES.NRR;
  var isStandard = price.selectedRate === FLEX_RATES.STANDARD;
  var isFLR = price.selectedRate === FLEX_RATES.FLR;
  var isEBB = price.selectedRate === FLEX_RATES.EBB;
  var isUsa = appContext.locale === 'en-US';
  var isStandardRateAloneAuthorized = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.standardRateAlone');

  if (!isEmpty_default()(alternativePrice) && alternativePrice.total.value != null) {
    var rateDiff = Object(proposalUtils["i" /* getPriceDiff */])(alternativePrice.total.value, price.total.value, appContext.locale, price.currency);
    var alternativePriceOffers = getPriceOffers(alternativePrice);
    var nrrOffers = isNRR ? priceOffers : alternativePriceOffers;
    var standardOffers = isStandard ? priceOffers : alternativePriceOffers;
    var flrOffers = isFLR ? priceOffers : alternativePriceOffers;
    var ebbOffers = isEBB ? priceOffers : alternativePriceOffers;
    var nonRefundableRate = {
      bullets: [Object(i18n["h" /* t */])('booking.accommodation.packageContent.nonRefundableRateBestPrice'), Object(i18n["h" /* t */])('booking.accommodation.packageContent.nonRefundableRateCancellation')],
      className: themes[theme].thNrr,
      dataTestId: 'flexRates-nrr',
      id: FLEX_RATES.NRR,
      offers: nrrOffers,
      price: isNRR ? Object(i18n["h" /* t */])('common.included') : rateDiff,
      title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.nonRefundableRateLabel').replace('\\n', '\n'),
      tooltipContent: Object(i18n["h" /* t */])('booking.accommodation.packageContent.nonRefundableRateLegal')
    };
    var standardRate = {
      bullets: [Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardBestPrice'), Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardCancellation')],
      className: themes[theme].thStandard,
      dataTestId: 'flexRates-standard',
      id: FLEX_RATES.STANDARD,
      offers: standardOffers,
      price: isStandard ? Object(i18n["h" /* t */])('common.included') : rateDiff,
      title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLabel'),
      tooltipContent: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLegal')
    };
    var ebbRate = {
      bullets: [Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardBestPrice'), Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardCancellation')],
      className: themes[theme].thStandard,
      dataTestId: 'flexRates-ebb',
      id: FLEX_RATES.EBB,
      offers: ebbOffers,
      price: ebbOffers ? Object(i18n["h" /* t */])('common.included') : rateDiff,
      title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLabel'),
      tooltipContent: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLegal')
    };
    var flexibleRate = {
      bullets: [Object(i18n["h" /* t */])('booking.accommodation.packageContent.flexibleRateCancellation2'), Object(i18n["h" /* t */])('booking.accommodation.packageContent.flexibleRateCancellation')],
      className: themes[theme].thNrr,
      dataTestId: 'flexRates-flr',
      id: FLEX_RATES.FLR,
      offers: flrOffers,
      price: isFLR ? Object(i18n["h" /* t */])('common.included') : rateDiff,
      title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.flexibleRateLabel'),
      tooltipContent: Object(i18n["h" /* t */])('booking.accommodation.packageContent.flexibleRateLegal')
    };

    if (isUsa) {
      if (new Set([].concat(Object(toConsumableArray["a" /* default */])(priceOffers), Object(toConsumableArray["a" /* default */])(alternativePriceOffers))).has('EBB')) {
        return [ebbRate, flexibleRate];
      }

      if (new Set([].concat(Object(toConsumableArray["a" /* default */])(priceOffers), Object(toConsumableArray["a" /* default */])(alternativePriceOffers))).has('FLR')) {
        return [standardRate, flexibleRate];
      }
    }

    return [nonRefundableRate, standardRate];
  }

  if ((isEmpty_default()(alternativePrice) || alternativePrice.total.value == null) && isEBB && isUsa) {
    return [{
      bullets: [Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardBestPrice'), Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardCancellation')],
      className: themes[theme].thStandard,
      dataTestId: 'flexRates-ebb',
      id: FLEX_RATES.EBB,
      offers: priceOffers,
      price: Object(i18n["h" /* t */])('common.included'),
      title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLabel'),
      tooltipContent: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLegal')
    }];
  }

  if ((isEmpty_default()(alternativePrice) || alternativePrice.total.value == null) && isStandard && !isUsa && isStandardRateAloneAuthorized) {
    return [{
      bullets: [Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardBestPrice'), Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardCancellation')],
      className: themes[theme].thStandard,
      dataTestId: 'flexRates-standard',
      id: FLEX_RATES.STANDARD,
      offers: priceOffers,
      price: Object(i18n["h" /* t */])('common.included'),
      title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLabel'),
      tooltipContent: Object(i18n["h" /* t */])('booking.accommodation.packageContent.standardLegal')
    }];
  }

  return [];
};
var FlexRates_FlexRates = function FlexRates(_ref4) {
  var className = _ref4.className,
      isInMoreRoomLayer = _ref4.isInMoreRoomLayer,
      isLoading = _ref4.isLoading,
      isMobile = _ref4.isMobile,
      proposal = _ref4.proposal,
      selectedRate = _ref4.selectedRate,
      setSelectedRate = _ref4.setSelectedRate,
      switchOffers = _ref4.switchOffers,
      _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? 'default' : _ref4$theme;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var options = FlexRates_getFlexRatesOptions(proposal, appContext, theme);
  Object(react["useEffect"])(function () {
    if (proposal.price.selectedRate !== selectedRate) {
      setSelectedRate(proposal.price.selectedRate);
    }
  }, [proposal.price.selectedRate]);
  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thTitle = _themes$theme.thTitle;
  return __jsx(react["Fragment"], null, options.length > 1 && __jsx("p", {
    className: thTitle
  }, Object(i18n["h" /* t */])('booking.accommodation.packageContent.chooseFlexibility')), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, 'gap-15', {
      'sm:flex-col': isInMoreRoomLayer
    }, className)
  }, options.map(function (option) {
    return __jsx(FlexRates_Rate, Object(esm_extends["a" /* default */])({}, option, {
      isChecked: option.id === selectedRate,
      isLoading: isLoading,
      isMobile: isMobile,
      isInMoreRoomLayer: isInMoreRoomLayer,
      key: option.id,
      onClick: function onClick() {
        if (!switchOffers) {
          setSelectedRate(option.id);
        } else if (option.id !== proposal.price.selectedRate) {
          // $FlowFixMe is alternativePrice is defined offers cannot be undefined
          switchOffers(option.offers);
          setSelectedRate(option.id);
        }
      }
    }));
  })));
};

var FlexRates_Rate = function Rate(_ref5) {
  var bullets = _ref5.bullets,
      className = _ref5.className,
      dataTestId = _ref5.dataTestId,
      isChecked = _ref5.isChecked,
      isLoading = _ref5.isLoading,
      _onClick = _ref5.onClick,
      price = _ref5.price,
      title = _ref5.title,
      tooltipContent = _ref5.tooltipContent,
      isMobile = _ref5.isMobile,
      isInMoreRoomLayer = _ref5.isInMoreRoomLayer;
  var rootRef = Object(react["useRef"])();
  var isMobileOrInMoreRoomLayer = isMobile || isInMoreRoomLayer;

  var _useState = Object(react["useState"])(false),
      isOpened = _useState[0],
      setIsOpened = _useState[1];

  var tooltip = function tooltip() {
    return __jsx(Tooltip["a" /* Tooltip */] // $FlowFixMe does not understand children prop comes from nested cmp
    , {
      modalProps: {
        ariaLabel: title,
        closeLabel: Object(i18n["h" /* t */])('common.close'),
        size: 'small'
      },
      renderTrigger: function renderTrigger(toggle) {
        return __jsx("button", {
          className: "leading-0 text-mediumGrey",
          "data-testid": "flexRatesTooltipTrigger",
          onClick: function onClick(e) {
            // prevent click on the tooltip icon to select the rate
            e.stopPropagation();
            e.preventDefault();
            toggle();
          },
          type: "button"
        }, __jsx(Icon["a" /* Icon */], {
          name: icons["a" /* ICONS */].INFORMATION,
          width: "1rem"
        }));
      }
    }, __jsx(Text["a" /* Text */], {
      className: "p-20",
      "data-testid": "flexRatesTooltipContent",
      text: tooltipContent,
      theme: "text-sans-n2"
    }));
  };

  return __jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('text-initial relative flex min-h-70 w-full cursor-pointer flex-wrap rounded-12 border-1 p-10', {
      'border-lightGrey': !isChecked,
      'border-black': isChecked
    }, className),
    "data-testid": dataTestId,
    onClick: function onClick(event) {
      // prevent click inside the modal to select the rate
      if (rootRef.current && rootRef.current.contains(event.target)) {
        _onClick();
      }
    },
    ref: rootRef,
    type: "button"
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'flex w-full': !isMobileOrInMoreRoomLayer,
      'w-full': isMobileOrInMoreRoomLayer
    })
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full gap-10', {
      'items-center': isMobileOrInMoreRoomLayer,
      'items-start': !isMobileOrInMoreRoomLayer
    })
  }, __jsx(RadioButton["a" /* RadioButton */], {
    isChecked: isChecked,
    isDisabled: isLoading
  }), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'flex w-full items-center gap-5': isMobileOrInMoreRoomLayer
    })
  }, __jsx(Text["a" /* Text */], {
    className: Object(classnames_utils["a" /* classnames */])('font-bold', {
      'flex-1': isMobileOrInMoreRoomLayer
    }),
    text: title,
    theme: "text-sans-n1"
  }), __jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('w-full text-16 font-bold text-sienna', {
      'flex-1 text-right': isMobileOrInMoreRoomLayer
    })
  }, price), isMobileOrInMoreRoomLayer && tooltip()), !isMobileOrInMoreRoomLayer && tooltip()), isMobileOrInMoreRoomLayer ? __jsx(lib["UnmountClosed"], {
    isOpened: isOpened,
    theme: {
      collapse: 'collapse-transition px-10 w-full',
      content: 'pt-20'
    }
  }, __jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])('mb-20 w-full space-y-5 text-14', {
      'ms-30': !isMobileOrInMoreRoomLayer
    })
  }, bullets.map(function (bullet) {
    return __jsx("li", {
      key: bullet,
      className: "flex items-baseline gap-10"
    }, __jsx(Icon["a" /* Icon */], {
      className: "shrink-0 text-green",
      name: icons["a" /* ICONS */].CHECK,
      width: "0.75rem"
    }), bullet);
  }))) : __jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])('mb-20 w-full space-y-5 text-14', {
      'ms-30': !isMobileOrInMoreRoomLayer
    })
  }, bullets.map(function (bullet) {
    return __jsx("li", {
      key: bullet,
      className: "flex items-baseline gap-10"
    }, __jsx(Icon["a" /* Icon */], {
      className: "shrink-0 text-green",
      name: icons["a" /* ICONS */].CHECK,
      width: "0.75rem"
    }), bullet);
  })), isMobileOrInMoreRoomLayer && __jsx("div", {
    className: "absolute bottom-0 left-0 w-full text-center",
    onClick: function onClick(e) {
      // prevent click on the arrow icon to select the rate
      e.stopPropagation();
      e.preventDefault();
      setIsOpened(!isOpened);
    }
  }, __jsx("button", {
    "data-testid": "flex-rates-arrow-icon",
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    rotation: isOpened ? 180 : 0,
    width: "0.50rem"
  })))));
};

/***/ }),

/***/ "FK6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClosableLayer; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_track_page_TrackPage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tZiC");
/* harmony import */ var _utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ESA2");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("U2fG");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;









var closeLayer = function closeLayer(_ref) {
  var cleanUrl = _ref.cleanUrl,
      forceRefreshOnClose = _ref.forceRefreshOnClose,
      router = _ref.router;
  var newUri = cleanUrl(router);

  if (forceRefreshOnClose) {
    Object(_utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_11__[/* clearAllCacheFront */ "a"])();
    window.location = newUri;
  } else {
    router.push(newUri, undefined, {
      shallow: true
    });
  }
};

var ClosableLayer = function ClosableLayer(props) {
  var children = props.children,
      close = props.close,
      forceRefreshOnClose = props.forceRefreshOnClose,
      _props$hasContainerHe = props.hasContainerHeader,
      hasContainerHeader = _props$hasContainerHe === void 0 ? true : _props$hasContainerHe,
      iconName = props.iconName,
      onBack = props.onBack,
      params = props.params,
      tracking = props.tracking,
      layerProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(props, ["children", "close", "forceRefreshOnClose", "hasContainerHeader", "iconName", "onBack", "params", "tracking"]);

  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_7__["useRouter"])();
  var openLayer = router.query.openLayer;
  var showLayer = openLayer === props.name;

  var cleanUrl = function cleanUrl(nextRouter) {
    return new urijs__WEBPACK_IMPORTED_MODULE_6___default.a(nextRouter.asPath).clone().removeSearch(['openLayer'].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(params || []))).resource();
  };

  var onClose = function onClose() {
    closeLayer({
      cleanUrl: cleanUrl,
      forceRefreshOnClose: forceRefreshOnClose,
      router: router
    });

    if (props.onClose) {
      props.onClose();
    }
  };

  Object(react__WEBPACK_IMPORTED_MODULE_5__["useEffect"])(function () {
    if (close) {
      close(onClose);
    }
  }, []);
  return showLayer ? __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_12__[/* Layer */ "b"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, layerProps, {
    buttonLeft: {
      iconName: iconName || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].ARROW_TAIL_LEFT,
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.close'),
      onClick: onBack || onClose
    },
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.close'),
    hasContainerHeader: hasContainerHeader,
    onClose: onClose
  }), (tracking === null || tracking === void 0 ? void 0 : tracking.pageName) && __jsx(_tracking_track_page_TrackPage__WEBPACK_IMPORTED_MODULE_10__[/* TrackPage */ "a"], {
    pageName: tracking.pageName,
    payload: tracking.payload
  }), children) : null;
};

/***/ }),

/***/ "GzVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTabsBackgroundClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabsMainId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTabsItemIds; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("m1JM");
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var getTabsBackgroundClasses = function getTabsBackgroundClasses() {
  var hasBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].PEARL;
  return hasBackground ? "bg-".concat(color, " border-b-1 border-t-1 border-grey") : '';
};
var getTabsMainId = function getTabsMainId() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = items.filter(Boolean).map(function (_ref) {
    var header = _ref.header,
        title = _ref.title;
    return header && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(header.title) || title && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title);
  }).filter(Boolean);
  return Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])(list, 'tabs-');
};
var getTabsItemIds = function getTabsItemIds(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      index = _ref2.index,
      mainId = _ref2.mainId;
  var headerId = id || Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), "".concat(index)], 'tabs-header-');
  var panelId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), id && "".concat(id), "".concat(index)], 'tabs-panel-');
  return [headerId, panelId];
};

/***/ }),

/***/ "HKmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StreetView; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UlIv");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;




var GoogleMapReact = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 2).then(__webpack_require__.t.bind(null, "h6Ot", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Ot")];
    },
    modules: ['google-map-react']
  }
});

var addStreetView = function addStreetView(_ref) {
  var hideFloorControls = _ref.hideFloorControls,
      map = _ref.map,
      maps = _ref.maps,
      position = _ref.position,
      pov = _ref.pov,
      ref = _ref.ref;
  var panorama = new maps.StreetViewPanorama(ref, {
    addressControl: true,
    addressControlOptions: {
      position: maps.ControlPosition.TOP_LEFT
    },
    disableDefaultUI: hideFloorControls,
    fullscreenControl: false,
    position: position,
    pov: pov,
    linksControl: true,
    panControl: true,
    zoomControl: true
  });
  map.setStreetView(panorama);
};

function StreetView(props) {
  var _props$fov = props.fov,
      fov = _props$fov === void 0 ? 2 : _props$fov,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? 2 : _props$heading,
      _props$hideFloorContr = props.hideFloorControls,
      hideFloorControls = _props$hideFloorContr === void 0 ? false : _props$hideFloorContr,
      latitude = props.latitude,
      longitude = props.longitude;

  var _map = Object(react__WEBPACK_IMPORTED_MODULE_4__["useRef"])();

  var coordinates = {
    lat: latitude,
    lng: longitude
  };
  return __jsx("div", {
    className: "h-full",
    "data-testid": "StreetViewComponent",
    ref: _map
  }, __jsx(GoogleMapReact, {
    bootstrapURLKeys: {
      key: _config__WEBPACK_IMPORTED_MODULE_5___default.a.get(_utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__[/* GOOGLE_API_KEY */ "c"])
    },
    defaultCenter: coordinates,
    defaultZoom: fov,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      return addStreetView({
        hideFloorControls: hideFloorControls,
        map: map,
        maps: maps,
        position: coordinates,
        pov: {
          heading: heading,
          pitch: 0
        },
        // same here, for now
        ref: _map.current
      });
    },
    yesIWantToUseGoogleMapApiInternals: true
  }));
}

/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* unused harmony export getVideoThumbnail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoutubeThumbnail(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://img.youtube.com/vi/".concat(urlId[1], "/sddefault.jpg") : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function getVideoThumbnail(url) {
  return getYoutubeThumbnail(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "Ka70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCurrentUri; });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);




var useCurrentUri = function useCurrentUri() {
  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_0__["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useAppContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* useAppContext */ "c"])(),
      originalUrl = _useAppContext.originalUrl;

  var origin = new urijs__WEBPACK_IMPORTED_MODULE_3___default.a(originalUrl);
  return new urijs__WEBPACK_IMPORTED_MODULE_3___default.a(asPath).origin(origin);
};

/***/ }),

/***/ "LR4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LabeledIconsList_LabeledIconsList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/chunk.js
var chunk = __webpack_require__("RBiB");
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center',
    thListWidth: 'w-1/2',
    thListRoot: 'flex flex-row flex-wrap gap-x-10 gap-y-20 justify-between w-full',
    thItem: 'flex gap-30 items-center leading-normal text-center text-current text-16 w-280',
    thIcon: 'flex items-center justify-center leading-0',
    thIconWidth: '2.5rem',
    thLabels: 'text-black'
  },
  list: {
    thRoot: 'flex flex-wrap',
    thListWidth: 'md:w-1/2',
    thListRoot: 'flex flex-col gap-20',
    thItem: 'flex gap-10 items-start w-280',
    thIcon: 'flex shrink-0 items-center justify-center leading-0',
    thIconWidth: '1.375rem',
    thLabels: 'leading-normal text-14 text-black'
  },
  listCondensed: {
    thRoot: 'flex',
    thListWidth: 'md:w-1/2',
    thListRoot: 'flex flex-col gap-20',
    thItem: 'flex gap-10 items-start',
    thIcon: 'flex shrink-0 items-center justify-center leading-0',
    thIconWidth: '1.375rem',
    thLabels: 'leading-normal text-14 text-black'
  },
  comparator: {
    thRoot: 'h-full',
    thListRoot: 'flex font-bold h-1/2',
    thListFirst: 'py-15 border-lightGrey',
    thListSubsequent: 'border-t-1 py-15 border-lightGrey -mt-1',
    thItem: 'flex flex-1 px-20 flex-col items-center text-center',
    thItemNth: 'border-s-1 border-lightGrey',
    thIconWidth: '2.5rem',
    thLabels: 'text-12'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx






var __jsx = react_default.a.createElement;






var LabeledIconsList_LabeledIconsListItems = function LabeledIconsListItems(_ref) {
  var _classnames;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
      isMoreThanOneList = _ref.isMoreThanOneList,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$listIndex = _ref.listIndex,
      listIndex = _ref$listIndex === void 0 ? 0 : _ref$listIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItem = _themes$theme.thItem,
      thItemNth = _themes$theme.thItemNth,
      thLabels = _themes$theme.thLabels,
      thListRoot = _themes$theme.thListRoot,
      thListWidth = _themes$theme.thListWidth,
      thListFirst = _themes$theme.thListFirst,
      thListSubsequent = _themes$theme.thListSubsequent;
  return __jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])("text-".concat(color), thListRoot, (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, thListWidth, isMoreThanOneList), Object(defineProperty["a" /* default */])(_classnames, thListFirst, listIndex === 0), Object(defineProperty["a" /* default */])(_classnames, thListSubsequent, listIndex !== 0), _classnames))
  }, items.map(function (_ref2, idx) {
    var icon = _ref2.icon,
        labels = _ref2.labels;
    return __jsx("li", {
      className: Object(classnames_utils["a" /* classnames */])(thItem, Object(defineProperty["a" /* default */])({}, thItemNth, idx > 0)),
      "data-testid": "LabeledIconsList-item",
      key: idx
    }, __jsx("div", {
      className: thIcon
    }, __jsx(Icon["a" /* Icon */], {
      name: icon,
      width: thIconWidth,
      alt: (labels || []).join('/')
    })), !!labels.length && __jsx("div", {
      className: thLabels
    }, labels.map(function (label) {
      return __jsx("div", {
        "data-testid": "LabeledIconsList-label",
        key: label
      }, label);
    })));
  }));
};

var LabeledIconsList_LabeledIconsList = function LabeledIconsList(props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;

  if (!items.length) {
    return null;
  }

  var shouldSplitItems = theme !== 'default' && items.length > 2;
  var thRoot = themes[theme].thRoot;

  var splitItems = chunk_default()(Object(toConsumableArray["a" /* default */])(items), Math.ceil(items.length / 2));

  var isMoreThanOneList = splitItems.length > 1;
  return __jsx("div", {
    className: thRoot
  }, shouldSplitItems ? splitItems.map(function (splitItem, idx) {
    return __jsx(LabeledIconsList_LabeledIconsListItems, Object(esm_extends["a" /* default */])({}, props, {
      key: idx,
      listIndex: idx,
      isMoreThanOneList: isMoreThanOneList,
      items: splitItem
    }));
  }) : __jsx(LabeledIconsList_LabeledIconsListItems, Object(esm_extends["a" /* default */])({}, props, {
    listIndex: 0,
    items: items
  })));
};

/***/ }),

/***/ "OWQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Accommodation_Accommodation; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/accommodation/accommodation.utils.js
var accommodation_utils = __webpack_require__("+2Ph");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 2 modules
var SeeMore = __webpack_require__("NPTU");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/arrangement/AccommodationRoomArrangement.jsx
var __jsx = react_default.a.createElement;





var AccommodationRoomArrangement_AccommodationRoomArrangement = function AccommodationRoomArrangement(_ref) {
  var className = _ref.className,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin;
  var message = isCabin ? Object(i18n["h" /* t */])('booking.accommodation.cabinArrangementYourChoiceMessage') : Object(i18n["h" /* t */])('booking.accommodation.roomArrangementYourChoiceMessage');

  if (!message) {
    return null;
  }

  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('border-1 border-orange flex font-sans gap-10 items-center px-10 py-5 rounded-12 text-12 text-orange', className)
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "2em"
  }), message);
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/availability/AccommodationRoomAvailability.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var small = {
  thRoot: 'flex flex-wrap font-bold gap-5 items-center leading-tight text-green text-14',
  thLastLabel: 'bg-orange font-bold px-10 py-5 rounded-pill text-12 text-white w-auto',
  thStock: 'flex gap-2 items-center min-w-1/2 text-orange text-12 w-auto',
  thIconLastSize: '1em',
  thIconSize: '0.75em'
};
var AccommodationRoomAvailability_themes_themes = {
  "default": small,
  medium: _objectSpread({}, small),
  large: _objectSpread(_objectSpread({}, small), {}, {
    thRoot: Object(classnames_utils["a" /* classnames */])(small.thRoot, 'md:text-16'),
    thLastLabel: Object(classnames_utils["a" /* classnames */])(small.thLastLabel, 'md:text-14'),
    thStock: Object(classnames_utils["a" /* classnames */])(small.thStock, 'md:min-w-0 md:mt-0 md:text-14')
  })
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/availability/AccommodationRoomAvailability.jsx
var AccommodationRoomAvailability_jsx = react_default.a.createElement;







var AccommodationRoomAvailability_AccommodationRoomAvailability = function AccommodationRoomAvailability(_ref) {
  var className = _ref.className,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin,
      _ref$stock = _ref.stock,
      stock = _ref$stock === void 0 ? accommodation_utils["a" /* REMAINING_STOCK_LIMIT */] + 1 : _ref$stock,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var isLast = stock <= accommodation_utils["a" /* REMAINING_STOCK_LIMIT */];
  var _themes$theme = AccommodationRoomAvailability_themes_themes[theme],
      thIconLastSize = _themes$theme.thIconLastSize,
      thIconSize = _themes$theme.thIconSize,
      thLastLabel = _themes$theme.thLastLabel,
      thRoot = _themes$theme.thRoot,
      thStock = _themes$theme.thStock;
  return AccommodationRoomAvailability_jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, isLast ? AccommodationRoomAvailability_jsx(react["Fragment"], null, stock > 1 && AccommodationRoomAvailability_jsx("span", {
    className: thLastLabel
  }, isCabin ? Object(i18n["h" /* t */])('booking.accommodation.lastAvailabilityCabins') : Object(i18n["h" /* t */])('booking.accommodation.lastAvailability')), AccommodationRoomAvailability_jsx("span", {
    className: thStock
  }, AccommodationRoomAvailability_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WARNING,
    width: thIconLastSize
  }), stock === 1 ? Object(i18n["h" /* t */])('booking.accommodation.moreRooms.lastAvailability') : Object(i18n["h" /* t */])('booking.accommodation.roomAvailabilities', {
    numberOfRoomsLeft: stock
  }))) : AccommodationRoomAvailability_jsx(react["Fragment"], null, Object(i18n["h" /* t */])('booking.accommodation.available'), AccommodationRoomAvailability_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CHECK,
    width: thIconSize
  })));
};
// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/dates/AccommodationRoomDates.jsx
var AccommodationRoomDates_jsx = react_default.a.createElement;





var AccommodationRoomDates_AccommodationRoomDates = function AccommodationRoomDates(_ref) {
  var className = _ref.className,
      dates = _ref.dates;

  if (!(dates === null || dates === void 0 ? void 0 : dates.endDate) || !(dates === null || dates === void 0 ? void 0 : dates.startDate)) {
    return null;
  }

  return AccommodationRoomDates_jsx(TemplateString["a" /* TemplateString */], {
    className: Object(classnames_utils["a" /* classnames */])('bg-black font-bold inline-block px-10 py-5 rounded-pill text-16 text-white', className),
    template: Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.departureDateFormat'),
    values: {
      arrivalDate: String(Object(dateUtils["b" /* formatTimestampDate */])(dates.startDate, Object(i18n["h" /* t */])('booking.common.condensedDateFormat'))),
      departureDate: String(Object(dateUtils["b" /* formatTimestampDate */])(dates.endDate, Object(i18n["h" /* t */])('booking.common.condensedDateFormat')))
    }
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/distribution/AccommodationRoomDistribution.jsx



var AccommodationRoomDistribution_jsx = react_default.a.createElement;






var MESSAGES = {
  CABIN: {
    SELLER: 'booking.accommodation.cabinArrangementMessageB2B',
    NOT_SELLER: 'booking.accommodation.cabinArrangementMessage'
  },
  DEFAULT: {
    SELLER: 'booking.accommodation.roomArrangementMessage',
    NOT_SELLER: 'booking.accommodation.roomArrangementMessage'
  }
};
var LABELS = {
  ADULT: 'booking.common.adult',
  BABY: 'booking.common.baby',
  CHILD: 'booking.common.child'
};
var AccommodationRoomDistribution_AccommodationRoomDistribution = function AccommodationRoomDistribution(_ref) {
  var className = _ref.className,
      distribution = _ref.distribution,
      isCabin = _ref.isCabin;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (!distribution) {
    return null;
  }

  var NODE = isCabin ? MESSAGES.CABIN : MESSAGES.DEFAULT;
  var msg = Object(sellerUtils["f" /* isSeller */])(appContext) ? NODE.SELLER : NODE.NOT_SELLER;
  var adults = distribution.adults,
      babies = distribution.babies,
      children = distribution.children;
  return AccommodationRoomDistribution_jsx("div", {
    className: className
  }, AccommodationRoomDistribution_jsx("ul", {
    className: "flex items-end flex-wrap -mx-5 mb-5"
  }, [adults, babies, children].filter(Boolean).map(function (d) {
    return d.map(function (_ref2) {
      var firstName = _ref2.firstName,
          id = _ref2.id,
          index = _ref2.index,
          lastName = _ref2.lastName,
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? 'ADULT' : _ref2$type;
      return AccommodationRoomDistribution_jsx("li", {
        className: "p-5 text-14 text-sienna",
        key: id,
        "data-testid": "test_".concat(type, "_").concat(index)
      }, AccommodationRoomDistribution_jsx(Icon["a" /* Icon */], {
        className: "me-5",
        name: icons["a" /* ICONS */].PEOPLE,
        width: type === 'ADULT' ? '1.3em' : '1em'
      }), Object(i18n["h" /* t */])(LABELS[type]), " ", index + 1, Object(sellerUtils["f" /* isSeller */])(appContext) && firstName && lastName ? AccommodationRoomDistribution_jsx("span", {
        className: "capitalize ms-10"
      }, "".concat(firstName, " ").concat(lastName).toLocaleLowerCase()) : null);
    });
  })), AccommodationRoomDistribution_jsx("p", {
    className: "font-sans text-sienna text-12"
  }, Object(i18n["h" /* t */])(msg)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-room/infos/AccommodationRoomInfos.jsx + 2 modules
var AccommodationRoomInfos = __webpack_require__("pciL");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/shared-room/AccommodationRoomSharedRoom.jsx
var AccommodationRoomSharedRoom_jsx = react_default.a.createElement;





var AccommodationRoomSharedRoom_AccommodationRoomSharedRoom = function AccommodationRoomSharedRoom(_ref) {
  var className = _ref.className;
  return AccommodationRoomSharedRoom_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('border-1 border-orange flex font-sans gap-10 items-center px-10 py-5 rounded-12 text-12 text-orange', className)
  }, AccommodationRoomSharedRoom_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SHARED_ROOM,
    width: "2.5em"
  }), Object(i18n["h" /* t */])('booking.accommodation.sharedRooms'));
};
// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/medias/medias.js
var medias_medias = __webpack_require__("SyAd");

// EXTERNAL MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx + 7 modules
var Multimedia = __webpack_require__("h3D+");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/slideshow/AccommodationRoomSlideshow.jsx

var AccommodationRoomSlideshow_jsx = react_default.a.createElement;









var AccommodationRoomSlideshow_AccommodationRoomSlideshow = function AccommodationRoomSlideshow(_ref) {
  var accommodationName = _ref.accommodationName,
      className = _ref.className,
      _ref$floorPlans = _ref.floorPlans,
      floorPlans = _ref$floorPlans === void 0 ? [] : _ref$floorPlans,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      streetView = _ref.streetView;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  if (!(images === null || images === void 0 ? void 0 : images.length)) {
    return null;
  }

  var closeLabel = Object(i18n["h" /* t */])('common.close');
  var nextLabel = Object(i18n["h" /* t */])('common.next');
  var previousLabel = Object(i18n["h" /* t */])('common.previous');
  var roomGalleryLabel = Object(i18n["h" /* t */])('common.galleries.roomGallery');
  var galleryLabel = accommodationName && roomGalleryLabel ? Object(dist["messageFormat"])(roomGalleryLabel).format({
    roomName: accommodationName
  }) : Object(i18n["h" /* t */])('common.galleries.gallery');
  var medias = {
    photos: images.map(function (_ref2) {
      var src = _ref2.src;
      return {
        url: src
      };
    }),
    streetViews: streetView ? [streetView] : undefined,
    floorPlans: floorPlans.map(function (plan) {
      return {
        url: plan
      };
    })
  };
  return AccommodationRoomSlideshow_jsx(Multimedia["a" /* Multimedia */], {
    className: Object(classnames_utils["a" /* classnames */])(className, 'flex flex-col justify-center'),
    closeLabel: closeLabel,
    descriptionLabels: {
      photos: '',
      streetViews: Object(i18n["h" /* t */])('common.view360Disclaimer'),
      floorPlans: Object(i18n["h" /* t */])('common.roomPlan.disclaimer')
    },
    galleryLabel: galleryLabel,
    hasImageSlideShowLauncher: true,
    isExclusiveCollection: isExclusiveCollection,
    labels: {
      floorPlans: isCabin ? Object(i18n["h" /* t */])('common.roomPlan.titleCruise') : Object(i18n["h" /* t */])('common.roomPlan.title'),
      photos: Object(i18n["h" /* t */])('common.photoTitle'),
      streetViews: ''
    },
    launcherPictureAltLabel: Object(i18n["h" /* t */])('common.galleries.openProductSlideShowGalleryAt', {
      productName: accommodationName
    }),
    medias: medias,
    nextLabel: nextLabel,
    onClickMediaBtn: function onClickMediaBtn(type) {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: medias_medias["c" /* MEDIA_TYPES_NAMES */][type]
      });
    },
    openGalleryLabel: Object(i18n["h" /* t */])('common.galleries.openSlideShowGallery'),
    pictureAltLabel: Object(i18n["h" /* t */])('common.galleries.productPictureItem', {
      productName: accommodationName
    }),
    portalName: Portal_constants["d" /* OVER_BOT */],
    previousLabel: previousLabel,
    theme: "accommodation"
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/tag/AccommodationRoomTag.jsx
var AccommodationRoomTag_jsx = react_default.a.createElement;


var AccommodationRoomTag_AccommodationRoomTag = function AccommodationRoomTag(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return AccommodationRoomTag_jsx(Tag["a" /* Tag */], {
    className: className
  }, label);
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/title/AccommodationRoomTitle.jsx

var AccommodationRoomTitle_jsx = react_default.a.createElement;






var AccommodationRoomTitle_AccommodationRoomTitle = function AccommodationRoomTitle(_ref) {
  var className = _ref.className,
      _ref$isExclusiveColle = _ref.isExclusiveCollectionSpace,
      isExclusiveCollectionSpace = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      name = _ref.name,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity;
  return AccommodationRoomTitle_jsx("h3", {
    className: Object(classnames_utils["a" /* classnames */])('flex font-bold font-brand gap-20 items-baseline justify-between leading-tight text-20', {
      'text-black': !isExclusiveCollectionSpace,
      'text-ultramarine': isExclusiveCollectionSpace
    }, className)
  }, AccommodationRoomTitle_jsx("span", null, name, ' ', isExclusiveCollectionSpace && AccommodationRoomTitle_jsx("span", {
    className: "aspect-square bg-ultramarine inline-flex items-center justify-center leading-0 h-[1em] rounded-full text-white"
  }, AccommodationRoomTitle_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].DIAMOND,
    width: "0.4em"
  }))), !!quantity && quantity > 1 && AccommodationRoomTitle_jsx(TemplateString["a" /* TemplateString */], {
    className: "font-brand text-18 text-black whitespace-nowrap",
    template: Object(i18n["h" /* t */])('booking.accommodation.packageContent.numberOfSameRooms'),
    valuesClassName: {
      count: 'text-24'
    },
    values: {
      count: quantity
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/AccommodationRoom.themes.js









function AccommodationRoom_themes_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function AccommodationRoom_themes_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? AccommodationRoom_themes_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AccommodationRoom_themes_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var AccommodationRoom_themes_small = {
  thHeader: 'md:py-10 w-full',
  thDates: 'hidden',
  thSlideshowBlock: 'isolate relative',
  thSlideshow: 'isolate overflow-hidden rounded-t-12',
  thTag: 'absolute m-10 end-0 top-0 z-1',
  thContent: 'pb-10',
  thInfos: 'my-10 -mx-5',
  thTitle: 'mb-5',
  thAvailability: 'my-5',
  thDesc: 'mb-10',
  thDistribution: 'mb-10',
  thArrangement: 'mb-10',
  thShared: 'mb-10',
  thSeemore: 'w-full',
  thSeemoreBtn: 'ms-auto text-end',
  thSeemoreContent: 'flex flex-wrap',
  thDetail: 'pb-10 w-full',
  thDetailTitle: 'mb-10',
  thDetailListTheme: 'listCondensed'
};
var AccommodationRoom_themes_themes = function themes(isExclusiveCollectionSpace, isExclusiveCollectionRoom, isMobile) {
  return {
    "default": AccommodationRoom_themes_small,
    medium: AccommodationRoom_themes_small,
    large: AccommodationRoom_themes_objectSpread(AccommodationRoom_themes_objectSpread({}, AccommodationRoom_themes_small), {}, {
      thRoot: 'sm:flex sm:flex-row sm:flex-wrap',
      thHeader: 'sm:hidden',
      thDates: Object(classnames_utils["a" /* classnames */])(AccommodationRoom_themes_small.thDates, 'mb-10 w-full md:block'),
      thSlideshowBlock: Object(classnames_utils["a" /* classnames */])(AccommodationRoom_themes_small.thSlideshowBlock, 'sm:pe-10', {
        'sm:w-1/2 md:w-2/5': !isExclusiveCollectionSpace && !isExclusiveCollectionRoom,
        'sm:w-1/2 md:w-3/5': isExclusiveCollectionSpace || isExclusiveCollectionRoom
      }),
      thTag: Object(classnames_utils["a" /* classnames */])(AccommodationRoom_themes_small.thTag, 'sm:mx-20'),
      thContent: Object(classnames_utils["a" /* classnames */])(AccommodationRoom_themes_small.thContent, 'flex flex-col sm:pb-0 sm:ps-10', {
        'sm:w-1/2 sm:justify-between md:w-3/5': !isExclusiveCollectionSpace && !isExclusiveCollectionRoom,
        'sm:w-1/2 md:w-2/5': isExclusiveCollectionSpace || isExclusiveCollectionRoom
      }),
      thHeaderElements: Object(classnames_utils["a" /* classnames */])('mb-5', {
        hidden: isMobile
      }),
      thInfos: Object(classnames_utils["a" /* classnames */])(AccommodationRoom_themes_small.thInfos, 'sm:order-last sm:mb-0'),
      thSeemoreContent: Object(classnames_utils["a" /* classnames */])(AccommodationRoom_themes_small.thSeemoreContent, 'sm:-mx-10'),
      thDetail: Object(classnames_utils["a" /* classnames */])(AccommodationRoom_themes_small.thDetail, 'sm:w-1/2 sm:p-10'),
      thDetailListTheme: 'listCondensed'
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/AccommodationRoom.jsx




var AccommodationRoom_jsx = react_default.a.createElement;






















var AccommodationRoom_Detail = function Detail(_ref) {
  var isPremium = _ref.isPremium,
      items = _ref.items,
      theme = _ref.theme,
      title = _ref.title;
  var _themes$theme = AccommodationRoom_themes_themes()[theme],
      thDetail = _themes$theme.thDetail,
      thDetailTitle = _themes$theme.thDetailTitle,
      thDetailListTheme = _themes$theme.thDetailListTheme;
  return (items === null || items === void 0 ? void 0 : items.length) ? AccommodationRoom_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thDetail, {
      'order-first': isPremium
    })
  }, AccommodationRoom_jsx(Title["a" /* Title */], {
    className: thDetailTitle,
    hLevel: 3,
    theme: "title-sans-n3"
  }, title), AccommodationRoom_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
    items: items.map(function (_ref2) {
      var id = _ref2.id,
          label = _ref2.label;
      return {
        icon: icons["a" /* ICONS */][id] || icons["a" /* ICONS */].TRIDENT1,
        labels: [label]
      };
    }),
    theme: thDetailListTheme
  })) : null;
};

var AccommodationRoom_AccommodationRoom = function AccommodationRoom(_ref3) {
  var accommodationsComparator = _ref3.accommodationsComparator,
      _ref3$bathroomEquipme = _ref3.bathroomEquipments,
      bathroomEquipments = _ref3$bathroomEquipme === void 0 ? [] : _ref3$bathroomEquipme,
      categoryId = _ref3.categoryId,
      className = _ref3.className,
      dates = _ref3.dates,
      description = _ref3.description,
      distribution = _ref3.distribution,
      _ref3$equipments = _ref3.equipments,
      equipments = _ref3$equipments === void 0 ? [] : _ref3$equipments,
      _ref3$floorPlans = _ref3.floorPlans,
      floorPlans = _ref3$floorPlans === void 0 ? [] : _ref3$floorPlans,
      _ref3$hasArrangement = _ref3.hasArrangement,
      hasArrangement = _ref3$hasArrangement === void 0 ? false : _ref3$hasArrangement,
      _ref3$hasDates = _ref3.hasDates,
      hasDates = _ref3$hasDates === void 0 ? false : _ref3$hasDates,
      _ref3$hasDistribution = _ref3.hasDistribution,
      hasDistribution = _ref3$hasDistribution === void 0 ? false : _ref3$hasDistribution,
      _ref3$hasSharedRoom = _ref3.hasSharedRoom,
      hasSharedRoom = _ref3$hasSharedRoom === void 0 ? false : _ref3$hasSharedRoom,
      _ref3$hasHiddenStock = _ref3.hasHiddenStock,
      hasHiddenStock = _ref3$hasHiddenStock === void 0 ? false : _ref3$hasHiddenStock,
      id = _ref3.id,
      images = _ref3.images,
      infosList = _ref3.infosList,
      _ref3$isBestFamilyDea = _ref3.isBestFamilyDeal,
      isBestFamilyDeal = _ref3$isBestFamilyDea === void 0 ? false : _ref3$isBestFamilyDea,
      _ref3$isBooking = _ref3.isBooking,
      isBooking = _ref3$isBooking === void 0 ? false : _ref3$isBooking,
      _ref3$isCabin = _ref3.isCabin,
      isCabin = _ref3$isCabin === void 0 ? false : _ref3$isCabin,
      _ref3$isExclusiveColl = _ref3.isExclusiveCollectionRoom,
      isExclusiveCollectionRoom = _ref3$isExclusiveColl === void 0 ? false : _ref3$isExclusiveColl,
      _ref3$isExclusiveColl2 = _ref3.isExclusiveCollectionSpace,
      isExclusiveCollectionSpace = _ref3$isExclusiveColl2 === void 0 ? false : _ref3$isExclusiveColl2,
      _ref3$isInMoreRoomLay = _ref3.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref3$isInMoreRoomLay === void 0 ? false : _ref3$isInMoreRoomLay,
      _ref3$isMobile = _ref3.isMobile,
      isMobile = _ref3$isMobile === void 0 ? false : _ref3$isMobile,
      _ref3$isPremium = _ref3.isPremium,
      isPremium = _ref3$isPremium === void 0 ? false : _ref3$isPremium,
      name = _ref3.name,
      _ref3$outsideFaciliti = _ref3.outsideFacilities,
      outsideFacilities = _ref3$outsideFaciliti === void 0 ? [] : _ref3$outsideFaciliti,
      proposal = _ref3.proposal,
      quantity = _ref3.quantity,
      _ref3$services = _ref3.services,
      services = _ref3$services === void 0 ? [] : _ref3$services,
      servicesIconsList = _ref3.servicesIconsList,
      stock = _ref3.stock,
      streetView = _ref3.streetView,
      _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? 'default' : _ref3$theme;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _themes$theme2 = AccommodationRoom_themes_themes(isExclusiveCollectionSpace, isExclusiveCollectionRoom, isMobile)[theme],
      thArrangement = _themes$theme2.thArrangement,
      thAvailability = _themes$theme2.thAvailability,
      thContent = _themes$theme2.thContent,
      thDates = _themes$theme2.thDates,
      thDesc = _themes$theme2.thDesc,
      thDistribution = _themes$theme2.thDistribution,
      thHeader = _themes$theme2.thHeader,
      thHeaderElements = _themes$theme2.thHeaderElements,
      thInfos = _themes$theme2.thInfos,
      thRoot = _themes$theme2.thRoot,
      thSeemore = _themes$theme2.thSeemore,
      thSeemoreBtn = _themes$theme2.thSeemoreBtn,
      thSeemoreContent = _themes$theme2.thSeemoreContent,
      thShared = _themes$theme2.thShared,
      thSlideshowBlock = _themes$theme2.thSlideshowBlock,
      thSlideshow = _themes$theme2.thSlideshow,
      thTag = _themes$theme2.thTag,
      thTitle = _themes$theme2.thTitle;

  var _useRouter = Object(router["useRouter"])(),
      queryParams = _useRouter.query;

  var isAccommodationView = queryParams.bookingStep === 'accommodation';
  var isAdditionalAccommodationsLayer = queryParams.openLayer === 'AdditionalAccommodationsLayer';
  return AccommodationRoom_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    id: id
  }, AccommodationRoom_jsx("div", {
    className: thHeader
  }, hasDates && AccommodationRoom_jsx(AccommodationRoomDates_AccommodationRoomDates, {
    className: "mb-10",
    dates: dates
  }), AccommodationRoom_jsx(AccommodationRoomTitle_AccommodationRoomTitle, {
    className: thTitle,
    isExclusiveCollectionSpace: isExclusiveCollectionSpace,
    name: name,
    quantity: quantity
  }), theme !== 'default' && AccommodationRoom_jsx("div", {
    className: "my-10"
  }, accommodationsComparator), !hasHiddenStock && AccommodationRoom_jsx(AccommodationRoomAvailability_AccommodationRoomAvailability, {
    className: thAvailability,
    isCabin: isCabin,
    stock: stock,
    theme: theme
  })), hasDates && AccommodationRoom_jsx("p", {
    className: thDates
  }, AccommodationRoom_jsx(AccommodationRoomDates_AccommodationRoomDates, {
    dates: dates
  })), AccommodationRoom_jsx("div", {
    className: thSlideshowBlock
  }, AccommodationRoom_jsx(AccommodationRoomSlideshow_AccommodationRoomSlideshow, {
    accommodationName: name,
    className: thSlideshow,
    images: images,
    isCabin: isCabin,
    floorPlans: floorPlans,
    isExclusiveCollection: isExclusiveCollectionRoom || isExclusiveCollectionSpace,
    streetView: streetView
  }), isBestFamilyDeal && AccommodationRoom_jsx(AccommodationRoomTag_AccommodationRoomTag, {
    className: thTag,
    label: Object(i18n["h" /* t */])('booking.accommodation.bestFamilyDealLabel')
  }), (isExclusiveCollectionSpace || isExclusiveCollectionRoom) && AccommodationRoom_jsx(AccommodationRoomInfos["a" /* AccommodationRoomInfos */], {
    className: thInfos,
    isFilterableInfoList: true,
    isInMoreRoomLayer: isInMoreRoomLayer,
    items: infosList,
    proposal: proposal,
    roomCategoryId: categoryId,
    theme: theme,
    isAccommodationSummary: false
  })), AccommodationRoom_jsx("div", {
    className: thContent
  }, !isExclusiveCollectionSpace && !isExclusiveCollectionRoom && AccommodationRoom_jsx(AccommodationRoomInfos["a" /* AccommodationRoomInfos */], {
    className: thInfos,
    isFilterableInfoList: true,
    isInMoreRoomLayer: isInMoreRoomLayer,
    items: infosList,
    proposal: proposal,
    roomCategoryId: categoryId,
    theme: theme,
    isAccommodationSummary: false
  }), servicesIconsList && AccommodationRoom_jsx(AccommodationRoomInfos["a" /* AccommodationRoomInfos */], {
    className: thInfos,
    isExclusiveCollection: true,
    isInMoreRoomLayer: isInMoreRoomLayer,
    isScrollable: false,
    items: servicesIconsList,
    proposal: proposal,
    theme: theme,
    isAccommodationSummary: false
  }), AccommodationRoom_jsx("div", null, AccommodationRoom_jsx("div", {
    "data-testid": "accommodationRoomHeader",
    className: thHeaderElements
  }, (isAccommodationView && !isAdditionalAccommodationsLayer || isBooking) && AccommodationRoom_jsx("div", {
    className: "w-full"
  }, AccommodationRoom_jsx("div", {
    className: "flex flex-wrap"
  }, AccommodationRoom_jsx(AccommodationRoomTitle_AccommodationRoomTitle, {
    className: thTitle,
    isExclusiveCollectionSpace: isExclusiveCollectionSpace,
    name: name,
    quantity: quantity
  }), accommodationsComparator), !hasHiddenStock && AccommodationRoom_jsx(AccommodationRoomAvailability_AccommodationRoomAvailability, {
    className: thAvailability,
    isCabin: isCabin,
    stock: stock,
    theme: theme
  }))), AccommodationRoom_jsx(Text["a" /* Text */], {
    className: Object(classnames_utils["a" /* classnames */])(thDesc, isExclusiveCollectionSpace ? 'text-ultramarine' : 'text-black'),
    text: description
  }), hasDistribution && AccommodationRoom_jsx(AccommodationRoomDistribution_AccommodationRoomDistribution, {
    className: thDistribution,
    distribution: distribution,
    isCabin: isCabin
  }), hasArrangement && AccommodationRoom_jsx(AccommodationRoomArrangement_AccommodationRoomArrangement, {
    className: thArrangement,
    isCabin: isCabin
  }), hasSharedRoom && AccommodationRoom_jsx(AccommodationRoomSharedRoom_AccommodationRoomSharedRoom, {
    className: thShared
  }))), AccommodationRoom_jsx(SeeMore["a" /* SeeMore */], {
    className: Object(classnames_utils["a" /* classnames */])(thSeemore, 'mt-15'),
    classNameButton: thSeemoreBtn,
    isCollapseEnabled: true,
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'see_details'
      });
    },
    seeMoreLabel: Object(i18n["h" /* t */])('booking.accommodation.packageContent.showFullDescription'),
    seeLessLabel: Object(i18n["h" /* t */])('booking.accommodation.packageContent.lessDetails'),
    seeMoreSize: 80
  }, AccommodationRoom_jsx("div", {
    className: thSeemoreContent
  }, AccommodationRoom_jsx(AccommodationRoom_Detail, {
    items: equipments,
    theme: theme,
    title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.equipment')
  }), AccommodationRoom_jsx(AccommodationRoom_Detail, {
    items: bathroomEquipments,
    theme: theme,
    title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.bathroomEquipments')
  }), AccommodationRoom_jsx(AccommodationRoom_Detail, {
    isPremium: isPremium,
    items: services,
    theme: theme,
    title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.services')
  }), AccommodationRoom_jsx(AccommodationRoom_Detail, {
    items: outsideFacilities,
    theme: theme,
    title: Object(i18n["h" /* t */])('booking.accommodation.packageContent.outsideEquipments')
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/flex-rates/FlexRates.jsx + 1 modules
var FlexRates = __webpack_require__("ExLU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/header/AccommodationHeader.themes.js









function AccommodationHeader_themes_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function AccommodationHeader_themes_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? AccommodationHeader_themes_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AccommodationHeader_themes_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var AccommodationHeader_themes_small = {
  thRoot: 'flex flex-col gap-10',
  thRecap: '',
  thAttendees: 'font-bold text-12',
  thAttendeesNumbers: 'font-bold text-sienna',
  thRooms: 'font-brand text-18 text-sienna',
  thAlert: 'border-1 border-orange flex font-sans gap-10 items-center px-10 py-5 rounded-12 text-10 text-orange'
};
var AccommodationHeader_themes_themes = {
  "default": AccommodationHeader_themes_small,
  medium: AccommodationHeader_themes_small,
  large: AccommodationHeader_themes_objectSpread(AccommodationHeader_themes_objectSpread({}, AccommodationHeader_themes_small), {}, {
    thRoot: Object(classnames_utils["a" /* classnames */])(AccommodationHeader_themes_small.thRoot, 'sm:flex-row sm:gap-20 sm:items-center'),
    thRecap: Object(classnames_utils["a" /* classnames */])(AccommodationHeader_themes_small.thRecap, 'basis-full sm:basis-2/5'),
    thAttendees: Object(classnames_utils["a" /* classnames */])(AccommodationHeader_themes_small.thAttendees, 'text-12 md:text-14'),
    thRooms: Object(classnames_utils["a" /* classnames */])(AccommodationHeader_themes_small.thRooms, 'sm:text-20 md:text-24'),
    thAlert: Object(classnames_utils["a" /* classnames */])(AccommodationHeader_themes_small.thAlert, 'sm:text-12 md:text-14 w-full sm:basis-3/5')
  })
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/header/AccommodationHeader.jsx



var AccommodationHeader_jsx = react_default.a.createElement;








var AccommodationHeader_AccommodationHeader = function AccommodationHeader(_ref) {
  var className = _ref.className,
      _ref$hasConsecutiveRo = _ref.hasConsecutiveRooms,
      hasConsecutiveRooms = _ref$hasConsecutiveRo === void 0 ? false : _ref$hasConsecutiveRo,
      _ref$hasHiddenStock = _ref.hasHiddenStock,
      hasHiddenStock = _ref$hasHiddenStock === void 0 ? false : _ref$hasHiddenStock,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin,
      numberOfAdults = _ref.numberOfAdults,
      numberOfBabies = _ref.numberOfBabies,
      numberOfChildren = _ref.numberOfChildren,
      numberOfRooms = _ref.numberOfRooms,
      stock = _ref.stock,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = AccommodationHeader_themes_themes[theme],
      thAlert = _themes$theme.thAlert,
      thAttendees = _themes$theme.thAttendees,
      thAttendeesNumbers = _themes$theme.thAttendeesNumbers,
      thRecap = _themes$theme.thRecap,
      thRooms = _themes$theme.thRooms,
      thRoot = _themes$theme.thRoot;
  var totalAttendees = numberOfAdults + numberOfBabies + numberOfChildren;
  return AccommodationHeader_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, AccommodationHeader_jsx("div", {
    className: thRecap
  }, totalAttendees > 0 && AccommodationHeader_jsx("p", {
    className: thAttendees
  }, Object(i18n["h" /* t */])('booking.accommodation.proposalFor'), ' ', AccommodationHeader_jsx("span", {
    className: thAttendeesNumbers
  }, ["".concat(numberOfAdults, " ").concat(numberOfAdults > 1 ? Object(i18n["h" /* t */])('booking.common.adults') : Object(i18n["h" /* t */])('booking.common.adult')), numberOfBabies ? "".concat(numberOfBabies, " ").concat(numberOfBabies > 1 ? Object(i18n["h" /* t */])('booking.common.babies') : Object(i18n["h" /* t */])('booking.common.baby')) : null, numberOfChildren ? "".concat(numberOfChildren, " ").concat(numberOfChildren > 1 ? Object(i18n["h" /* t */])('booking.common.children') : Object(i18n["h" /* t */])('booking.common.child')) : null].filter(Boolean).join(' - '))), !hasConsecutiveRooms && AccommodationHeader_jsx("p", {
    className: thRooms
  }, numberOfRooms, " ", Object(i18n["h" /* t */])('booking.accommodation.packageContent.separatedRooms')), !hasHiddenStock && stock <= accommodation_utils["a" /* REMAINING_STOCK_LIMIT */] && AccommodationHeader_jsx(AccommodationRoomAvailability_AccommodationRoomAvailability, {
    isCabin: isCabin,
    stock: stock,
    theme: theme
  })), !isCabin && AccommodationHeader_jsx("div", {
    className: thAlert
  }, AccommodationHeader_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEPARATED_BUILDINGS,
    width: "2.5em"
  }), Object(i18n["h" /* t */])('booking.accommodation.separatedRooms')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/separator/AccommodationSeparator.jsx
var AccommodationSeparator_jsx = react_default.a.createElement;


var AccommodationSeparator_AccommodationSeparator = function AccommodationSeparator(_ref) {
  var className = _ref.className;
  return AccommodationSeparator_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-center justify-center', className)
  }, AccommodationSeparator_jsx("div", {
    className: "block border-0 border-dashed border-lightGrey border-t-1 h-1 m-0 p-0 w-full"
  }), AccommodationSeparator_jsx("div", {
    className: "bg-saffron font-bold inline-block leading-1 mx-10 px-15 py-10 rounded-12 text-24 text-black"
  }, "&"), AccommodationSeparator_jsx("div", {
    className: "block border-0 border-dashed border-lightGrey border-t-1 h-1 m-0 p-0 w-full"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/Accommodation.themes.js

var Accommodation_themes_small = {
  thSeparated: 'border-b-1 border-lightGrey p-10',
  thRoom: 'p-10',
  thFlexRates: 'border-b-1 border-lightGrey p-10'
};
var Accommodation_themes_themes = {
  "default": Accommodation_themes_small,
  medium: Accommodation_themes_small,
  large: {
    thSeparated: Object(classnames_utils["a" /* classnames */])(Accommodation_themes_small.thSeparated, 'sm:p-20'),
    thRoom: Object(classnames_utils["a" /* classnames */])(Accommodation_themes_small.thRoom, 'sm:p-20'),
    thFlexRates: Object(classnames_utils["a" /* classnames */])(Accommodation_themes_small.thFlexRates, 'sm:p-20')
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/Accommodation.jsx




var Accommodation_jsx = react_default.a.createElement;








var Accommodation_Accommodation = function Accommodation(_ref) {
  var _rooms$;

  var accommodationsComparator = _ref.accommodationsComparator,
      className = _ref.className,
      key = _ref.key,
      _ref$hasFlexRates = _ref.hasFlexRates,
      hasFlexRates = _ref$hasFlexRates === void 0 ? false : _ref$hasFlexRates,
      _ref$hasHiddenStock = _ref.hasHiddenStock,
      hasHiddenStock = _ref$hasHiddenStock === void 0 ? false : _ref$hasHiddenStock,
      _ref$isBooking = _ref.isBooking,
      isBooking = _ref$isBooking === void 0 ? false : _ref$isBooking,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin,
      isInMoreRoomLayer = _ref.isInMoreRoomLayer,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      proposal = _ref.proposal,
      _ref$rooms = _ref.rooms,
      rooms = _ref$rooms === void 0 ? [] : _ref$rooms,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      stock = _ref.stock,
      switchOffers = _ref.switchOffers,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = Accommodation_themes_themes[theme],
      thFlexRates = _themes$theme.thFlexRates,
      thRoom = _themes$theme.thRoom,
      thSeparated = _themes$theme.thSeparated;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var isMobile = !isTablet;
  var counters = isCabin ? null : rooms.reduce(function (t, r) {
    var _r$distribution, _r$distribution$adult, _r$distribution2, _r$distribution2$babi, _r$distribution3, _r$distribution3$chil;

    return {
      adults: t.adults + (((_r$distribution = r.distribution) === null || _r$distribution === void 0 ? void 0 : (_r$distribution$adult = _r$distribution.adults) === null || _r$distribution$adult === void 0 ? void 0 : _r$distribution$adult.length) || 0),
      babies: t.babies + (((_r$distribution2 = r.distribution) === null || _r$distribution2 === void 0 ? void 0 : (_r$distribution2$babi = _r$distribution2.babies) === null || _r$distribution2$babi === void 0 ? void 0 : _r$distribution2$babi.length) || 0),
      children: t.children + (((_r$distribution3 = r.distribution) === null || _r$distribution3 === void 0 ? void 0 : (_r$distribution3$chil = _r$distribution3.children) === null || _r$distribution3$chil === void 0 ? void 0 : _r$distribution3$chil.length) || 0),
      rooms: t.rooms + r.quantity
    };
  }, {
    adults: 0,
    babies: 0,
    children: 0,
    rooms: 0
  });
  var firstRoomDates = ((_rooms$ = rooms[0]) === null || _rooms$ === void 0 ? void 0 : _rooms$.dates) || {};
  var hasConsecutiveRooms = rooms.some(function (_ref2) {
    var dates = _ref2.dates;
    return dates.startDate !== firstRoomDates.startDate || dates.endDate !== firstRoomDates.endDate;
  });
  return Accommodation_jsx("div", {
    className: className,
    "data-testid": "Accommodation",
    key: key
  }, counters && counters.rooms > 1 && Accommodation_jsx(AccommodationHeader_AccommodationHeader, {
    className: thSeparated,
    hasConsecutiveRooms: hasConsecutiveRooms,
    hasHiddenStock: hasHiddenStock,
    isCabin: isCabin,
    numberOfAdults: counters.adults,
    numberOfBabies: counters.babies,
    numberOfChildren: counters.children,
    numberOfRooms: counters.rooms,
    stock: stock,
    theme: theme
  }), hasFlexRates && proposal && selectedRate && setSelectedRate && Accommodation_jsx(FlexRates["a" /* FlexRates */], {
    className: thFlexRates,
    isInMoreRoomLayer: isInMoreRoomLayer,
    isLoading: isLoading,
    isMobile: isMobile,
    proposal: proposal,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers,
    theme: theme
  }), rooms.map(function (room, i) {
    return Accommodation_jsx(react["Fragment"], {
      key: room.id
    }, i > 0 && Accommodation_jsx(AccommodationSeparator_AccommodationSeparator, null), Accommodation_jsx(AccommodationRoom_AccommodationRoom, Object(esm_extends["a" /* default */])({}, room, {
      accommodationsComparator: accommodationsComparator,
      className: thRoom,
      hasDates: hasConsecutiveRooms,
      hasHiddenStock: hasHiddenStock,
      isBooking: isBooking,
      isInMoreRoomLayer: isInMoreRoomLayer,
      isMobile: isMobile,
      proposal: proposal,
      stock: counters && counters.rooms > 1 && stock > 0 ? accommodation_utils["a" /* REMAINING_STOCK_LIMIT */] + 1 : stock,
      theme: theme
    })));
  }));
};

/***/ }),

/***/ "OwO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeatureCard; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("C/y5");
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("3OwS");
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_collapse__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _button_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("e0Ti");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qBqs");
/* harmony import */ var _spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7amT");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("qqKu");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_string_string_util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("tX1K");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("E8Xq");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("0IQ5");
/* harmony import */ var _image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("DQFb");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("u/u4");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("1JJ2");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */

















var getListValue = function getListValue(value) {
  return (value === null || value === void 0 ? void 0 : value.filter(Boolean).length) ? __jsx("ul", {
    className: "font-bold"
  }, value.map(function (v) {
    return __jsx("li", {
      className: "flex items-center justify-between",
      key: v.id
    }, v.label, __jsx("span", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('font-brand font-normal', {
        'text-green': v.isIncluded,
        'text-orange': !v.isIncluded
      })
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])(v.isIncluded ? 'common.included' : 'common.onDemand')));
  })) : null;
};

var getTextValue = function getTextValue(value) {
  return value ? __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_13__[/* Text */ "a"], {
    className: "font-bold",
    text: value
  }) : null;
};

var FeatureCard = function FeatureCard(_ref) {
  var className = _ref.className,
      description = _ref.description,
      duration = _ref.duration,
      _ref$hasReverseLayout = _ref.hasReverseLayout,
      hasReverseLayout = _ref$hasReverseLayout === void 0 ? false : _ref$hasReverseLayout,
      id = _ref.id,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      _ref$isAdded = _ref.isAdded,
      isAdded = _ref$isAdded === void 0 ? false : _ref$isAdded,
      _ref$isIncluded = _ref.isIncluded,
      isIncluded = _ref$isIncluded === void 0 ? false : _ref$isIncluded,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$isUnavailable = _ref.isUnavailable,
      isUnavailable = _ref$isUnavailable === void 0 ? false : _ref$isUnavailable,
      _ref$isCartLocked = _ref.isCartLocked,
      isCartLocked = _ref$isCartLocked === void 0 ? false : _ref$isCartLocked,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      name = _ref.name,
      note = _ref.note,
      onBook = _ref.onBook,
      price = _ref.price,
      remainingStock = _ref.remainingStock,
      subtitle = _ref.subtitle,
      isExpanded = _ref.isExpanded,
      _ref$showSliderOfImag = _ref.showSliderOfImages,
      showSliderOfImages = _ref$showSliderOfImag === void 0 ? false : _ref$showSliderOfImag;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_22__[/* useResponsive */ "b"])(),
      isRTL = _useResponsive.isRTL;

  var discount = Math.abs(Math.round(Number(price === null || price === void 0 ? void 0 : price.discount)));
  var hasDiscount = discount >= 5;
  return __jsx("article", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('relative isolate flex flex-col rounded-12 bg-white shadow', {
      'opacity-50': isUnavailable && !!images.length
    }, className),
    id: id
  }, images.length > 1 && showSliderOfImages && __jsx(_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_20__[/* ImageSlideShow */ "a"], {
    hasLazyLoading: true,
    itemClassName: "rounded-t-12 isolate overflow-hidden will-change-transform",
    media: images.map(function (src) {
      return {
        src: src
      };
    }),
    ratio: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_21__[/* default */ "c"].XL,
    ratioDisplay: 1 / 3,
    hasOverlappingClick: true,
    hasInfiniteScroll: true
  }), images.length > 0 && !showSliderOfImages || images.length === 1 && __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_19__[/* Image */ "a"], {
    className: "overflow-hidden rounded-t-12",
    imageUrl: images[0],
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_21__[/* default */ "c"].XL
  }), __jsx("div", {
    className: "flex min-h-200 flex-col p-15 md:p-20"
  }, __jsx("header", {
    className: "mb-auto flex min-h-42 items-baseline justify-between"
  }, __jsx("div", {
    className: "w-full max-w-220 flex-1 pe-15"
  }, __jsx("h3", {
    className: "font-brand text-16 font-bold leading-normal text-black"
  }, name), !isAdded && remainingStock && __jsx("p", {
    className: "mt-5 flex items-center gap-5 text-14 font-bold leading-1 text-red"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
    className: "shrink-0",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__[/* ICONS */ "a"].WARNING,
    width: "18px"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('booking.activities.remainingService', {
    nb: Number(remainingStock.quantity)
  })), subtitle && __jsx("h4", {
    className: "text-14"
  }, subtitle), isUnavailable && __jsx("p", {
    className: "mt-5 flex items-center gap-5 text-14 font-bold leading-1 text-red"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
    className: "shrink-0",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__[/* ICONS */ "a"].WARNING,
    width: "18px"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('booking.activities.unavailableActivity'))), isIncluded && __jsx("p", {
    className: "font-bold text-green"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.included')), isLoading ? __jsx(_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__[/* Spinner */ "a"], {
    size: "small"
  }) : __jsx(react__WEBPACK_IMPORTED_MODULE_7__["Fragment"], null, !isIncluded && !isAdded && __jsx("div", null, (price === null || price === void 0 ? void 0 : price.value) ? __jsx(react__WEBPACK_IMPORTED_MODULE_7__["Fragment"], null, hasDiscount && __jsx("p", {
    className: "-translate-y-50 absolute end-0 top-0 mx-15 -mt-5 rounded-pill bg-sienna px-10 py-5 text-12 font-bold leading-1 text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.price.variationUpTo', {
    discount: "".concat(discount, "%")
  })), __jsx("p", {
    className: "flex flex-col text-end text-12"
  }, __jsx("span", {
    className: "font-sans text-12 font-normal text-black"
  }, Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_18__[/* capitalize */ "a"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('price.format.from'))), ' ', __jsx("span", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('font-brand text-16 text-black')
  }, price.formattedInitialValue && hasDiscount && __jsx("s", {
    className: "me-5 text-12 text-sienna line-through"
  }, price.formattedInitialValue), price.formattedValue), __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('price.format.unitPerPerson')))) : __jsx("p", {
    className: "max-w-80 text-end text-12 leading-tight text-mediumGrey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.price.checkInResort'))), !isIncluded && isAdded && __jsx("div", {
    className: "text-center text-12"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
    className: "text-success",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__[/* ICONS */ "a"].CHECK,
    width: "1em"
  }), __jsx("span", {
    className: "block"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.added'))))), __jsx("div", {
    dir: isRTL ? 'rtl' : 'ltr',
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('mt-40 flex', {
      'flex-col': isExpanded
    })
  }, __jsx("div", null, duration && __jsx("p", {
    className: "mb-5 flex items-center gap-10 text-14 leading-0"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
    className: "text-sienna",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__[/* ICONS */ "a"].DURATION,
    width: "1.375rem"
  }), __jsx("span", {
    className: "sr-only"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.durationLabel')), duration), __jsx(react_collapse__WEBPACK_IMPORTED_MODULE_9__["Collapse"], {
    initialStyle: {
      minHeight: 45
    },
    isOpened: isExpanded
  }, __jsx("div", {
    className: "flex flex-col"
  }, __jsx("div", {
    className: "text-initial py-5"
  }, !!description && __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_13__[/* Text */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])({
      'line-clamp-2': !isExpanded
    }),
    text: isExpanded ? description : Object(_utils_string_string_util__WEBPACK_IMPORTED_MODULE_16__[/* truncate */ "d"])(description, 100, true)
  })), !!list.length && __jsx("ul", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('py-5 text-14', {
      'order-first': hasReverseLayout
    })
  }, list.map(function (l) {
    var _l$value;

    return ((_l$value = l.value) === null || _l$value === void 0 ? void 0 : _l$value.length) ? __jsx("li", {
      className: "mb-15",
      key: l.label
    }, l.label && __jsx("span", {
      className: "me-10 shrink-0"
    }, l.label), __jsx("div", null, Array.isArray(l.value) ? getListValue(l.value) : getTextValue(l.value), l.note && __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_13__[/* Text */ "a"], {
      className: "mt-5",
      text: l.note,
      theme: "text-sans-n2"
    }))) : null;
  })), !isIncluded && !isCartLocked && onBook && (price === null || price === void 0 ? void 0 : price.value) && __jsx(_button_Button__WEBPACK_IMPORTED_MODULE_10__[/* Button */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('mb-15 mt-25 w-full transition-all duration-250 ease-in', {
      'opacity-0': !isExpanded
    }),
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].BLACK,
    colorBg: isAdded ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TRANSPARENT : _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].SAFFRON,
    colorBorder: isAdded ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].BLACK : _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].SAFFRON,
    "data-testid": "Add-activity",
    isLoading: isLoading,
    onClick: onBook,
    tabIndex: isExpanded ? 0 : -1
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])(isAdded ? 'booking.common.editPrice' : 'booking.common.addPrice', {
    price: "+".concat(price === null || price === void 0 ? void 0 : price.formattedValue)
  })), note && __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_13__[/* Text */ "a"], {
    className: "-mb-10 pe-20",
    text: note.trim(),
    theme: "text-sans-n2"
  })))), __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('flex justify-end self-end ps-20', {
      'pb-5': isExpanded
    }),
    "data-testid": "See-more-details"
  }, __jsx("span", {
    className: "sr-only"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])(isExpanded ? 'common.close' : 'common.viewMore')), __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__[/* ICONS */ "a"].ARROW_DOWN,
    rotation: isExpanded ? 180 : 0,
    width: "0.9375rem"
  })))));
};

/***/ }),

/***/ "RBiB":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("0Ocv"),
    isIterateeCall = __webpack_require__("R5u7"),
    toInteger = __webpack_require__("m2YG");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),

/***/ "RDfq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LAYER_NAME_UPSELL_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LAYER_NAME_UPSELL_CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LAYER_NAME_UPSELL_ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LAYER_NAME_UPSELL_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LAYER_NAME_UPSELL_PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LAYER_NAME_UPSELL_RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LAYER_NAME_UPSELL_TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LAYER_NAME_STAY_STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LAYER_NAME_VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LAYER_NAME_UPGRADE_ROOM; });
var LAYER_NAME_UPSELL_ACTIVITIES = 'UpsellActivities';
var LAYER_NAME_UPSELL_CHILDCARES = 'UpsellChildcares';
var LAYER_NAME_UPSELL_ESF = 'UpsellESF';
var LAYER_NAME_UPSELL_INSURANCES = 'UpsellInsurances';
var LAYER_NAME_UPSELL_PACKAGES = 'UpsellPackages';
var LAYER_NAME_UPSELL_RENTALS = 'UpsellRentals';
var LAYER_NAME_UPSELL_TRANSFERS = 'UpsellTansfers';
var LAYER_NAME_STAY_STAFF = 'StayStaff';
var LAYER_NAME_VOUCHERS = 'Vouchers';
var LAYER_NAME_UPGRADE_ROOM = 'UpgradeRoom';

/***/ }),

/***/ "RO1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ActivitiesCategories_ActivitiesCategories; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/@react-spring/web/dist/react-spring-web.esm.js
var react_spring_web_esm = __webpack_require__("rd3t");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/hooks/use-current-uri/useCurrentUri.js
var useCurrentUri = __webpack_require__("Ka70");

// EXTERNAL MODULE: ./src/hooks/use-layer/useLayer.js
var useLayer = __webpack_require__("1CQ+");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/frameworks/flyer-card/FlyerCard.jsx
var FlyerCard = __webpack_require__("0GXo");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-category-card/ActivitiesCategoryCard.jsx



var __jsx = react_default.a.createElement;






var ActivitiesCategoryCard_ActivitiesCategoryCard = function ActivitiesCategoryCard(_ref) {
  var _category$activitiesC, _category$activitiesC2, _category$images;

  var className = _ref.className,
      category = _ref.category,
      _ref$hasCounters = _ref.hasCounters,
      hasCounters = _ref$hasCounters === void 0 ? false : _ref$hasCounters,
      _ref$hasOnlineBookabl = _ref.hasOnlineBookableCount,
      hasOnlineBookableCount = _ref$hasOnlineBookabl === void 0 ? false : _ref$hasOnlineBookabl,
      _ref$hasOnlineBookabl2 = _ref.hasOnlineBookableTotal,
      hasOnlineBookableTotal = _ref$hasOnlineBookabl2 === void 0 ? false : _ref$hasOnlineBookabl2,
      _ref$isSmall = _ref.isSmall,
      isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
      onClick = _ref.onClick,
      url = _ref.url,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "category", "hasCounters", "hasOnlineBookableCount", "hasOnlineBookableTotal", "isSmall", "onClick", "url"]);

  var onlineBookableActivitiesCount = (category === null || category === void 0 ? void 0 : category.onlineBookableCount) || 0;
  var totalActivities = hasOnlineBookableTotal ? onlineBookableActivitiesCount : ((category === null || category === void 0 ? void 0 : (_category$activitiesC = category.activitiesCounters) === null || _category$activitiesC === void 0 ? void 0 : _category$activitiesC.included) || 0) + ((category === null || category === void 0 ? void 0 : (_category$activitiesC2 = category.activitiesCounters) === null || _category$activitiesC2 === void 0 ? void 0 : _category$activitiesC2.onDemand) || 0);
  return __jsx(FlyerCard["a" /* FlyerCard */], Object(esm_extends["a" /* default */])({}, rest, {
    className: className,
    "data-testid": category.name,
    imageUrl: (_category$images = category.images) === null || _category$images === void 0 ? void 0 : _category$images[0],
    isChecked: Object(bookingUtils["o" /* hasSomeActivityBooked */])(category),
    isSmall: isSmall,
    label: Object(i18n["h" /* t */])('common.activities.label'),
    onClick: onClick,
    title: (category === null || category === void 0 ? void 0 : category.name) || Object(i18n["h" /* t */])('booking.activities.otherActivities'),
    url: url
  }), hasCounters && __jsx("div", {
    className: "mt-15 basis-[20%]"
  }, !!totalActivities && __jsx("p", {
    className: "flex items-center gap-10 text-14 font-bold text-black"
  }, Object(i18n["h" /* t */])(totalActivities > 1 ? 'common.activities.counters._n' : 'common.activities.counters._1', {
    count: totalActivities
  }), ' ', __jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: "0.75em"
  })), hasOnlineBookableCount && onlineBookableActivitiesCount > 0 && __jsx("p", {
    className: "flex items-center justify-between text-14 font-bold text-sienna"
  }, Object(i18n["h" /* t */])('booking.activities.onDemandCount.totalOnline', {
    count: onlineBookableActivitiesCount
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/upsell-card/UpsellCard.jsx
var UpsellCard = __webpack_require__("yr32");

// CONCATENATED MODULE: ./src/client/components/widgets/upsell-activities-card/UpsellActivitiesCard.jsx

var UpsellActivitiesCard_jsx = react_default.a.createElement;




var UpsellActivitiesCard_UpsellActivitiesCard = function UpsellActivitiesCard(_ref) {
  var _category$activitiesC, _category$activitiesC2, _category$images, _category$bestPrice;

  var category = _ref.category,
      className = _ref.className,
      _ref$hasOnlineBookabl = _ref.hasOnlineBookableTotal,
      hasOnlineBookableTotal = _ref$hasOnlineBookabl === void 0 ? false : _ref$hasOnlineBookabl,
      onClick = _ref.onClick,
      url = _ref.url;
  var onlineBookableActivitiesCount = (category === null || category === void 0 ? void 0 : category.onlineBookableCount) || 0;
  var totalActivities = hasOnlineBookableTotal ? onlineBookableActivitiesCount : ((category === null || category === void 0 ? void 0 : (_category$activitiesC = category.activitiesCounters) === null || _category$activitiesC === void 0 ? void 0 : _category$activitiesC.included) || 0) + ((category === null || category === void 0 ? void 0 : (_category$activitiesC2 = category.activitiesCounters) === null || _category$activitiesC2 === void 0 ? void 0 : _category$activitiesC2.onDemand) || 0);
  return UpsellActivitiesCard_jsx(UpsellCard["a" /* UpsellCard */], {
    className: className,
    imageUrl: (_category$images = category.images) === null || _category$images === void 0 ? void 0 : _category$images[0],
    key: category.id,
    isChecked: Object(bookingUtils["o" /* hasSomeActivityBooked */])(category),
    label: category.name || Object(i18n["h" /* t */])('booking.activities.otherActivities'),
    onClick: onClick,
    text: Object(i18n["h" /* t */])(totalActivities > 1 ? 'common.activities.counters._n' : 'common.activities.counters._1', {
      count: totalActivities
    }),
    price: (_category$bestPrice = category.bestPrice) === null || _category$bestPrice === void 0 ? void 0 : _category$bestPrice.formattedValue,
    url: url
  });
};
// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-categories/ActivitiesCategories.jsx







var ActivitiesCategories_jsx = react_default.a.createElement;














var ActivitiesCategories_ActivitiesCategories = function ActivitiesCategories(_ref) {
  var className = _ref.className,
      categories = _ref.categories,
      _ref$colsNumber = _ref.colsNumber,
      colsNumber = _ref$colsNumber === void 0 ? 4 : _ref$colsNumber,
      _ref$hasCounters = _ref.hasCounters,
      hasCounters = _ref$hasCounters === void 0 ? false : _ref$hasCounters,
      _ref$hasOnlineBookabl = _ref.hasOnlineBookableCount,
      hasOnlineBookableCount = _ref$hasOnlineBookabl === void 0 ? false : _ref$hasOnlineBookabl,
      _ref$hasOnlineBookabl2 = _ref.hasOnlineBookableTotal,
      hasOnlineBookableTotal = _ref$hasOnlineBookabl2 === void 0 ? false : _ref$hasOnlineBookabl2,
      layerName = _ref.layerName,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'default' : _ref$layout,
      onClickCard = _ref.onClickCard,
      onClickMore = _ref.onClickMore;
  var currentUri = Object(useCurrentUri["a" /* useCurrentUri */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var columnsNumber = isTablet && !isDesktop ? 3 : colsNumber;

  var _useState = Object(react["useState"])(columnsNumber),
      shownItems = _useState[0],
      setShownItems = _useState[1];

  var _useLayer = Object(useLayer["a" /* useLayer */])(layerName || layers_constants["c" /* LAYER_NAME_UPSELL_ACTIVITIES */], {
    type: 'CATEGORIES'
  }),
      nextUri = _useLayer.nextUri;

  Object(react["useEffect"])(function () {
    setShownItems(columnsNumber);
  }, [columnsNumber]);
  var displayExcursionsOnly = currentUri.path().startsWith('/l/qr-code') || currentUri.query().indexOf('disableLayout') !== -1;
  var filteredCategories = categories.filter(function (c) {
    var _c$categories, _c$activities;

    return Boolean(((_c$categories = c.categories) === null || _c$categories === void 0 ? void 0 : _c$categories.length) || ((_c$activities = c.activities) === null || _c$activities === void 0 ? void 0 : _c$activities.length)) && (!displayExcursionsOnly || c.id.toLowerCase().indexOf('excursions') !== -1);
  });
  var transitions = Object(react_spring_web_esm["useTransition"])(filteredCategories.slice(0, shownItems), {
    from: {
      marginTop: -75,
      opacity: 0
    },
    enter: {
      marginTop: 0,
      opacity: 1
    },
    keys: function keys(item) {
      return item.id;
    },
    config: {
      duration: 150
    },
    trail: 150
  });

  var getUrl = function getUrl(catId) {
    return new URI_default.a(nextUri).addQuery({
      catId: catId
    }).toString();
  };

  if (layout === 'small') {
    return filteredCategories.slice(0, 3).map(function (item) {
      return ActivitiesCategories_jsx("div", {
        "data-testid": "activities-category-card",
        key: item.id
      }, ActivitiesCategories_jsx(ActivitiesCategoryCard_ActivitiesCategoryCard, {
        category: item,
        className: "h-full min-h-170 w-130 flex-none overflow-hidden border-1 border-solid border-lightGrey focus-within:border-saffron hocus:border-saffron",
        hasCounters: false,
        hasOnlineBookableTotal: hasOnlineBookableTotal,
        isSmall: true,
        key: item.id,
        onClick: function onClick() {
          return onClickCard === null || onClickCard === void 0 ? void 0 : onClickCard(Object(string_util["b" /* camelToSnakeCase */])(item.upsellType), item.onlineBookableCount !== 0);
        },
        url: getUrl(item.id)
      }));
    });
  }

  if (layout === 'card') {
    return filteredCategories.map(function (item) {
      return ActivitiesCategories_jsx(UpsellActivitiesCard_UpsellActivitiesCard, {
        category: item,
        hasOnlineBookableTotal: hasOnlineBookableTotal,
        key: item.id,
        onClick: function onClick() {
          return onClickCard === null || onClickCard === void 0 ? void 0 : onClickCard(Object(string_util["b" /* camelToSnakeCase */])(item.upsellType), item.onlineBookableCount !== 0);
        },
        url: getUrl(item.id)
      });
    });
  }

  return ActivitiesCategories_jsx("section", {
    className: className
  }, ActivitiesCategories_jsx("section", {
    className: "grid grid-cols-2 gap-20 md:grid-cols-3 lg:grid-cols-".concat(colsNumber),
    "data-testid": "Activities-all-componant"
  }, transitions(function (styles, item, key) {
    var url = getUrl(item.id);
    return ActivitiesCategories_jsx(react_spring_web_esm["animated"].div, {
      key: key,
      style: styles,
      "data-testid": "activities-category-card"
    }, ActivitiesCategories_jsx(ActivitiesCategoryCard_ActivitiesCategoryCard, {
      category: item,
      className: Object(classnames_utils["a" /* classnames */])('h-full transform hover:scale-105', {
        'min-h-300': hasCounters
      }),
      hasCounters: hasCounters,
      hasOnlineBookableCount: hasOnlineBookableCount,
      hasOnlineBookableTotal: hasOnlineBookableTotal,
      onClick: function onClick() {
        return onClickCard === null || onClickCard === void 0 ? void 0 : onClickCard(Object(string_util["b" /* camelToSnakeCase */])(item.upsellType), item.onlineBookableCount !== 0);
      },
      url: url
    }));
  })), shownItems < filteredCategories.length && ActivitiesCategories_jsx("div", {
    className: "mt-40 flex justify-center"
  }, ActivitiesCategories_jsx(Button["a" /* Button */], {
    "data-testid": "Activities-seeMore",
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_DOWN
    },
    onClick: function onClick() {
      setShownItems(shownItems + columnsNumber);
      onClickMore === null || onClickMore === void 0 ? void 0 : onClickMore();
    }
  }, Object(i18n["h" /* t */])('common.loadMore'))));
};

/***/ }),

/***/ "SyAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEDIA_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MEDIA_TYPES_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORDERED_MEDIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDERED_MEDIAS_LAUNCHER; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var _ICONS, _MEDIA_TYPES_NAMES;


var MEDIA_TYPES = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  VIDEOS360: 'videos360',
  STREETVIEWS: 'streetViews',
  FLOORPLAN: 'floorPlans'
};
var ORDERED_MEDIAS = [MEDIA_TYPES.PHOTOS, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.FLOORPLAN, MEDIA_TYPES.STREETVIEWS];
var ORDERED_MEDIAS_LAUNCHER = [MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.PHOTOS];
var ICONS = (_ICONS = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.PHOTOS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_PICTURE), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.VIDEOS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_VIDEO), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.VIDEOS360, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_360_VIDEO), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.STREETVIEWS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].STREET_VIEWS_360), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.FLOORPLAN, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].FLOOR_PLAN), _ICONS);
var MEDIA_TYPES_NAMES = (_MEDIA_TYPES_NAMES = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.FLOORPLAN, 'media_room_plan'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.PHOTOS, 'media_photos'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.STREETVIEWS, 'media_streetviews'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.VIDEOS, 'media_videos'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.VIDEOS360, 'media_360_view'), _MEDIA_TYPES_NAMES);


/***/ }),

/***/ "UlIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_API_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GOOGLE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GOOGLE_API_STREET_VIEW_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GOOGLE_API_JS_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GOOGLE_API_STATIC_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GOOGLE_PLACE_URL; });
var GOOGLE_API_DOMAIN = 'googlemap.api.domain';
var GOOGLE_API_KEY = 'googlemap.api.key';
var GOOGLE_API_STREET_VIEW_PATH = 'googlemap.api.streetViewPath';
var GOOGLE_API_JS_PATH = 'googlemap.api.jsPath';
var GOOGLE_API_STATIC_PATH = 'googlemap.api.staticPath';
var GOOGLE_PLACE_URL = 'http://www.google.com/maps/place';


/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    "data-testid": "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "XGb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FavoriteProductListContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var FavoriteProductListContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  favoriteProductsState: {
    favoriteProductList: [],
    hasTooManyFavorites: false,
    showcaseLatestFavorite: false,
    showAllFavorite: false
  },
  loading: false,
  addTravelPlan: function addTravelPlan() {},
  setHasTooManyFavorites: function setHasTooManyFavorites() {},
  setFavoriteProductList: function setFavoriteProductList() {}
});

/***/ }),

/***/ "YOo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopInReservationBlock_PopInReservationBlock; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/hooks/use-disclosure/useDisclosure.js
var useDisclosure = __webpack_require__("Re84");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/partition.js
var partition = __webpack_require__("Zl10");
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/utils/activities/activities.utils.js
var activities_utils = __webpack_require__("8W+g");

// EXTERNAL MODULE: ./src/client/components/widgets/reservation-block/reservationBlock.utils.js
var reservationBlock_utils = __webpack_require__("2hfc");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationBlockHeader.jsx
var __jsx = react_default.a.createElement;





var ReservationBlockHeader_ReservationBlockHeader = function ReservationBlockHeader(_ref) {
  var isActive = _ref.isActive,
      label = _ref.label,
      onEdit = _ref.onEdit,
      stepNumber = _ref.stepNumber,
      stepsTotal = _ref.stepsTotal,
      _ref$isEditVisible = _ref.isEditVisible,
      isEditVisible = _ref$isEditVisible === void 0 ? true : _ref$isEditVisible;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex font-bold gap-10 items-baseline justify-between text-14', {
      'text-black': isActive,
      'mb-10 text-grey': !isActive
    })
  }, __jsx("p", null, stepsTotal > 1 && __jsx(react["Fragment"], null, stepNumber, __jsx("span", {
    className: "text-12"
  }, "/", stepsTotal), "\xA0-\xA0"), label), !isActive && onEdit && isEditVisible && __jsx("button", {
    className: "cursor-pointer flex gap-5 items-center text-12 text-black hocus:text-black-active whitespace-nowrap",
    onClick: onEdit,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PEN,
    width: "1em"
  }), __jsx("span", {
    className: "underline"
  }, Object(i18n["h" /* t */])('common.edit'))));
};
// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationAttendeesStep.jsx















var ReservationAttendeesStep_jsx = react_default.a.createElement;









var TIMESLOT_REGEX = /([a-z0-9_]+)-([0-9]{8})-([0-9]{8})-([a-z])/;
var ReservationAttendeesStep_ReservationAttendeesStep = function ReservationAttendeesStep(_ref) {
  var attendees = _ref.attendees,
      hasReservedSchedule = _ref.hasReservedSchedule,
      cancellingActivity = _ref.cancellingActivity,
      setCancellingActivity = _ref.setCancellingActivity,
      getLowerPrice = _ref.getLowerPrice;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      attendeesList = _useContext.attendeesList;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var checkAllAttendees = function checkAllAttendees(_ref2) {
    var target = _ref2.target;
    Object.keys(values.attendees).forEach(function (attendeeId) {
      dist["windowWrapper"].requestAnimationFrame(function () {
        setFieldValue("attendees.".concat(attendeeId, ".selected"), target.checked);
      });
    });

    if (hasReservedSchedule && !target.checked) {
      setCancellingActivity(true);
    } else if (cancellingActivity && target.checked) {
      setCancellingActivity(false);
    }
  };

  var uncheckOneAttendee = function uncheckOneAttendee(attendee, target) {
    if (cancellingActivity && target.checked) {
      setCancellingActivity(false);
    } else if (!target.checked) {
      // make sure alls slots are unchecked on attendee unselection
      Object.keys(values.slots).forEach(function (slotKey) {
        var timeSlotRegex = new RegExp(TIMESLOT_REGEX, 'gi'); // $FlowFixMe (An index signature declaring the expected key / value type is missing in null [1])

        var _timeSlotRegex$exec = timeSlotRegex.exec(slotKey),
            _timeSlotRegex$exec2 = Object(slicedToArray["a" /* default */])(_timeSlotRegex$exec, 5),
            timeSlotCustomerId = _timeSlotRegex$exec2[4];

        if (timeSlotCustomerId && timeSlotCustomerId === attendee.id) {
          setFieldValue("slots.".concat(slotKey, ".isSelected"), false);
        }
      });

      if (hasReservedSchedule && !Object.entries(values.attendees).some( // $FlowFixMe (property selected is missing in mixed [1])
      function (_ref3) {
        var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 2),
            attendeeID = _ref4[0],
            selected = _ref4[1].selected;

        return attendeeID !== attendee.id && selected;
      })) {
        setCancellingActivity(true);
      }
    }
  };

  return ReservationAttendeesStep_jsx(react["Fragment"], null, Object.values(values.attendees).length > 1 && ReservationAttendeesStep_jsx("div", {
    className: "border-b-1 border-lightGrey py-15"
  }, ReservationAttendeesStep_jsx(FormikInput["a" /* FormikInput */], {
    label: Object(i18n["h" /* t */])('booking.activities.skiEquipment.sameScheduleAllParticipants'),
    name: "sameScheduleForAll",
    onChange: checkAllAttendees,
    type: "checkbox"
  })), attendees.map(function (attendee) {
    var lowerPrice = getLowerPrice(attendee);
    return ReservationAttendeesStep_jsx("div", {
      className: "py-10",
      key: attendee.id
    }, ReservationAttendeesStep_jsx(FormikInput["a" /* FormikInput */], {
      isDisabled: attendee.schedules.every(function (_ref5) {
        var isFullyPaid = _ref5.isFullyPaid;
        return isFullyPaid;
      }),
      label: ReservationAttendeesStep_jsx(react["Fragment"], null, ReservationAttendeesStep_jsx("span", {
        className: "air360-replay-ignore",
        "data-cs-mask": true
      }, Object(reservationBlock_utils["i" /* getAttendeeLabel */])(attendeesList, attendee.id, appContext)), lowerPrice.formattedInitialValue && ReservationAttendeesStep_jsx(react["Fragment"], null, ReservationAttendeesStep_jsx("span", {
        className: "font-sans font-normal ms-20 text-12 text-black"
      }, Object(i18n["h" /* t */])('price.format.from')), ' ', ReservationAttendeesStep_jsx("s", {
        className: "line-through ms-10 text-sienna"
      }, lowerPrice.formattedInitialValue)), ReservationAttendeesStep_jsx("span", {
        className: Object(classnames_utils["a" /* classnames */])('px-10 text-black')
      }, lowerPrice.formattedValue)),
      name: "attendees.".concat(attendee.id, ".selected"),
      onChange: function onChange(e) {
        return uncheckOneAttendee(attendee, e.target);
      },
      type: "checkbox"
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/activity-card/ActivityCard.jsx
var ActivityCard = __webpack_require__("k0YQ");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/widgets/reservation-block/DateSchedule.jsx
var DateSchedule = __webpack_require__("djlj");

// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationScheduleStep.jsx















var ReservationScheduleStep_jsx = react_default.a.createElement;














var ReservationScheduleStep_ReservationScheduleStep = function ReservationScheduleStep(_ref) {
  var attendees = _ref.attendees;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      attendeesList = _useContext.attendeesList,
      scheduleReservationMessage = _useContext.scheduleReservationMessage,
      showRentAllSchedules = _useContext.showRentAllSchedules,
      departureDate = _useContext.departureDate,
      arrivalDate = _useContext.arrivalDate;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      validateForm = _useFormikContext.validateForm,
      setFieldValue = _useFormikContext.setFieldValue;

  var _useState = Object(react["useState"])({}),
      lastAvailableSchedule = _useState[0],
      setLastAvailableSchedule = _useState[1]; // find the all duration schedule if exists
  // he has a special treatment because of the childcare BY DAY
  // that is equivalent to the whole duration of stay


  Object(react["useEffect"])(function () {
    validateForm();
    Object.entries(values.attendees) // $FlowFixMe
    .filter(function (_ref2) {
      var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
          selected = _ref3[1].selected;

      return !selected;
    }).forEach(function (_ref4) {
      var _ref5 = Object(slicedToArray["a" /* default */])(_ref4, 1),
          attendeeId = _ref5[0];

      var attendeeSchedules = values.attendees[attendeeId].schedules;
      attendeeSchedules.forEach(function (_ref6, scheduleIndex) {
        var isSelected = _ref6.isSelected;

        if (!isSelected) {
          return;
        }

        setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), false);
      });
    });
    return function () {
      // when the component is unmount the validation is not triggered and the confirm button can stay disabled
      validateForm();
    };
  }, []);
  var hasPaidSchedules = attendees.some(function (attendee) {
    return attendee.schedules.some(function (_ref7) {
      var timeSlots = _ref7.timeSlots;
      return timeSlots.some(function (_ref8) {
        var isPaid = _ref8.isPaid;
        return isPaid;
      });
    });
  });

  var checkAllSchedules = function checkAllSchedules(_ref9) {
    var target = _ref9.target;
    Object.entries(values.attendees).forEach( // $FlowFixMe (Property schedules is missing in mixed [1])
    function (_ref10) {
      var _ref11 = Object(slicedToArray["a" /* default */])(_ref10, 2),
          attendeeId = _ref11[0],
          schedules = _ref11[1].schedules;

      if (target.checked && attendeeId === 'A') {
        return null;
      }

      dist["windowWrapper"].requestAnimationFrame(function () {
        // hack to fix weired formik bug when calling setFieldValue in onChange
        // @see https://github.com/jaredpalmer/formik/issues/2059
        setFieldValue("wholeDurationOfStay.".concat(attendeeId), target.checked ? values.wholeDurationOfStay.A : false);
      });
      schedules.forEach(function (_, scheduleIndex) {
        dist["windowWrapper"].requestAnimationFrame(function () {
          setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), target.checked ? values.attendees.A.schedules[scheduleIndex].isSelected : false);
        });
      });
    });
  };

  return ReservationScheduleStep_jsx(react["Fragment"], null, scheduleReservationMessage && ReservationScheduleStep_jsx("p", {
    className: "font-bold mt-10 text-sienna text-12"
  }, scheduleReservationMessage), // $FlowFixMe
  !hasPaidSchedules && // $FlowFixMe
  Object.values(values.attendees).filter(function (_ref12) {
    var selected = _ref12.selected;
    return selected;
  }).length > 1 && ReservationScheduleStep_jsx("div", {
    className: "border-b-1 border-lightGrey py-15"
  }, ReservationScheduleStep_jsx(FormikInput["a" /* FormikInput */], {
    label: Object(i18n["h" /* t */])('booking.activities.skiEquipment.sameScheduleAllParticipants'),
    name: "sameScheduleForAll",
    onChange: checkAllSchedules,
    type: "checkbox"
  })), // $FlowFixMe
  Object.entries(values.attendees).map( // $FlowFixMe
  function (_ref13) {
    var _ref14 = Object(slicedToArray["a" /* default */])(_ref13, 2),
        attendeeId = _ref14[0],
        _ref14$ = _ref14[1],
        schedules = _ref14$.schedules,
        selected = _ref14$.selected;

    if (!selected) {
      return null;
    }

    var fullStayScheduleIndex = schedules.findIndex(function (_ref15) {
      var startDate = _ref15.startDate,
          endDate = _ref15.endDate;
      return startDate === arrivalDate && endDate === departureDate;
    });
    var fullStaySchedule = schedules[fullStayScheduleIndex];
    var isThereAFullStaySchedule = fullStayScheduleIndex !== -1;
    var shouldActivateFullStayScheduleMode = isThereAFullStaySchedule && schedules.length > 1;
    var attendeeSelectedSchedules = schedules.filter(function (_ref16) {
      var isSelected = _ref16.isSelected;
      return isSelected;
    });
    return ReservationScheduleStep_jsx("div", {
      className: "divide-y divide-lightGrey",
      key: attendeeId
    }, ReservationScheduleStep_jsx("p", {
      className: "air360-replay-ignore flex gap-5 items-center py-10 text-14",
      "data-cs-mask": true
    }, ReservationScheduleStep_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].PEOPLE,
      width: "1em"
    }), Object(reservationBlock_utils["i" /* getAttendeeLabel */])(attendeesList, attendeeId, appContext)), showRentAllSchedules && ReservationScheduleStep_jsx(FormikInput["a" /* FormikInput */], {
      className: "py-10",
      label: Object(i18n["h" /* t */])('booking.activities.skiEquipment.wholeDurationOfStay'),
      name: "wholeDurationOfStay.".concat(attendeeId),
      onChange: function onChange(_ref17) {
        var target = _ref17.target;
        schedules.forEach(function (_, scheduleIndex) {
          dist["windowWrapper"].requestAnimationFrame(function () {
            if (!values.attendees[attendeeId].schedules[scheduleIndex].isPaid) {
              setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), target.checked);
            }
          });

          if (!values.sameScheduleForAll) {
            return;
          }

          Object.keys(values.attendees).forEach(function (otherAttendeeId) {
            if (otherAttendeeId === attendeeId) {
              return null;
            }

            dist["windowWrapper"].requestAnimationFrame(function () {
              setFieldValue("attendees.".concat(otherAttendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), target.checked);
              setFieldValue("wholeDurationOfStay.".concat(otherAttendeeId), target.checked);
            });
          });
        });
      },
      type: "checkbox"
    }), ReservationScheduleStep_jsx("div", {
      className: "flex flex-wrap gap-10 py-10"
    }, schedules.map(function (_ref18, scheduleIndex) {
      var endDate = _ref18.endDate,
          startDate = _ref18.startDate;
      var overlap = attendeeSelectedSchedules.some(function (attendeeSelectedSchedule) {
        return (attendeeSelectedSchedule.startDate !== startDate || attendeeSelectedSchedule.endDate !== endDate) && [Object(apiDate["j" /* momentFromApiDate */])(attendeeSelectedSchedule.startDate), Object(apiDate["j" /* momentFromApiDate */])(attendeeSelectedSchedule.endDate)].every(function (date) {
          return date.isBetween(Object(apiDate["j" /* momentFromApiDate */])(startDate), Object(apiDate["j" /* momentFromApiDate */])(endDate)) || date.isSame(Object(apiDate["j" /* momentFromApiDate */])(startDate)) || date.isSame(Object(apiDate["j" /* momentFromApiDate */])(endDate));
        });
      }); // Disabling schedules frontend

      var currentChildSchedule = values.attendees[attendeeId].schedules[scheduleIndex];
      var fullStayScheduleIsPaid = fullStaySchedule === null || fullStaySchedule === void 0 ? void 0 : fullStaySchedule.isPaid; // TODO TODO : check if this is the right way to do it

      var isDisabledRegularCase = currentChildSchedule.isPaid || overlap;

      var isSingleDaySchedule = function isSingleDaySchedule(schedule) {
        return schedule.startDate === schedule.endDate;
      };

      var isCurrentSingleAndFullStayPaid = isSingleDaySchedule(currentChildSchedule) && currentChildSchedule.isPaid && fullStayScheduleIsPaid;
      var isCurrentFullStayAndOneSinglePaid = !isSingleDaySchedule(currentChildSchedule) && schedules.some(function (schedule) {
        return isSingleDaySchedule(schedule) && schedule.isPaid;
      });
      var isDisableInFSSM = // if the current schedule if it's a single schedule & full stay schedule is paid
      isCurrentSingleAndFullStayPaid || // if the current schedule is a full stay schedule & one of the single schedules is paid
      isCurrentFullStayAndOneSinglePaid;
      var isDisabled = shouldActivateFullStayScheduleMode ? isDisableInFSSM : isDisabledRegularCase;
      return ReservationScheduleStep_jsx(FormikInput["a" /* FormikInput */], {
        isDisabled: isDisabled,
        key: "".concat(startDate).concat(endDate),
        name: "attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"),
        type: "checkbox",
        onChange: function onChange(e) {
          if (shouldActivateFullStayScheduleMode) {
            // if you select a single day schedule, the full stay schedule is automatically unselected
            if (e.target.checked) {
              var hasSelectedAllSingleSchedules = e.target.checked && attendeeSelectedSchedules.length === schedules.length - 2; // if you select all single day schedules, the full stay schedule is automatically selected

              if (hasSelectedAllSingleSchedules) {
                dist["windowWrapper"].requestAnimationFrame(function () {
                  values.attendees[attendeeId].schedules.forEach(function (_ref19, scheduleIndexFE) {
                    var startD = _ref19.startDate,
                        endD = _ref19.endDate;

                    if (startD === fullStaySchedule.startDate && endD === fullStaySchedule.endDate) {
                      setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexFE, "].isSelected"), true);
                    } else {
                      setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexFE, "].isSelected"), false);
                    }
                  });
                });
              }
            } // if you unselect the first single day schedule, the full stay schedule is automatically unselected


            if (!e.target.checked && attendeeSelectedSchedules.length === schedules.length) {
              dist["windowWrapper"].requestAnimationFrame(function () {
                values.attendees[attendeeId].schedules.forEach(function (_ref20, scheduleIndexFE) {
                  var sDate = _ref20.startDate,
                      eDate = _ref20.endDate;

                  if (sDate === fullStaySchedule.startDate && eDate === fullStaySchedule.endDate) {
                    setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexFE, "].isSelected"), false);
                  }
                });
              });
            } // if you select any single day schedule, the full stay schedule is automatically deselected


            if (e.target.checked && attendeeSelectedSchedules.length === 1) {
              dist["windowWrapper"].requestAnimationFrame(function () {
                values.attendees[attendeeId].schedules.forEach(function (_ref21, scheduleIndexFE) {
                  var sd = _ref21.startDate,
                      ed = _ref21.endDate;

                  if (sd === fullStaySchedule.startDate && ed === fullStaySchedule.endDate) {
                    setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexFE, "].isSelected"), false);
                  }
                });
              });
            }
          }

          if (!values.attendees[attendeeId].schedules[scheduleIndex].isSelected && values.attendees[attendeeId].schedules[scheduleIndex].remainingStock <= ActivityCard["b" /* REMAINING_STOCK_WARNING_THRESHOLD */]) {
            setLastAvailableSchedule({
              isVisible: true,
              nb: values.attendees[attendeeId].schedules[scheduleIndex].remainingStock
            });
          } else {
            setLastAvailableSchedule({});
          }

          var allSchedulesWillBeChecked = values.attendees[attendeeId].schedules.filter(function (_ref22) {
            var isSelected = _ref22.isSelected;
            return isSelected;
          }).length === schedules.length - 1 && e.target.checked; // hack to fix weird formik bug when calling setFieldValue in onChange
          // @see https://github.com/jaredpalmer/formik/issues/2059

          dist["windowWrapper"].requestAnimationFrame(function () {
            setFieldValue("wholeDurationOfStay.".concat(attendeeId), allSchedulesWillBeChecked);
          });

          if (!values.sameScheduleForAll) {
            return;
          }

          Object.keys(values.attendees).forEach(function (otherAttendeeId) {
            if (otherAttendeeId === attendeeId) {
              return null;
            }

            dist["windowWrapper"].requestAnimationFrame(function () {
              setFieldValue("attendees.".concat(otherAttendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), e.target.checked);
              setFieldValue("wholeDurationOfStay.".concat(otherAttendeeId), allSchedulesWillBeChecked);
            });
          });
        } // TODO: cleanup !!
        // eslint-disable-next-line react/no-unstable-nested-components
        ,
        placeholderComponent: function placeholderComponent(isChecked) {
          return ReservationScheduleStep_jsx("div", {
            className: Object(classnames_utils["a" /* classnames */])('border-1 flex font-bold items-center py-5 px-10 rounded-12 text-10', {
              'border-lightGrey text-black': !isChecked,
              'bg-saffron border-saffron-active text-black': isChecked,
              'italic opacity-50': isDisabled
            }),
            "data-testid": "reservationScheduleDay"
          }, ReservationScheduleStep_jsx(DateSchedule["a" /* DateSchedule */], {
            date: startDate
          }), startDate !== endDate && ReservationScheduleStep_jsx(react["Fragment"], null, ReservationScheduleStep_jsx("div", {
            className: "mx-10"
          }, Object(i18n["h" /* t */])('common.to')), ReservationScheduleStep_jsx(DateSchedule["a" /* DateSchedule */], {
            date: endDate
          })));
        }
      });
    })));
  }), lastAvailableSchedule.isVisible && ReservationScheduleStep_jsx("p", {
    className: "flex font-bold gap-5 items-center leading-1 mt-5 text-14 text-red"
  }, ReservationScheduleStep_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].WARNING,
    width: "18px"
  }), Object(i18n["h" /* t */])('booking.activities.remainingService', {
    nb: lastAvailableSchedule.nb
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("mlET");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationSlotsStep.jsx




















var ReservationSlotsStep_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-extra-boolean-cast */












var slotNotAvailable = {
  isDisabled: true,
  isPaid: false,
  isSelected: false
};
var ReservationSlotsStep_ReservationSlotsStep = function ReservationSlotsStep(_ref) {
  var showOnlyCurrentAttendeeSlots = _ref.showOnlyCurrentAttendeeSlots,
      attendeeId = _ref.attendeeId;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      attendeesList = _useContext.attendeesList;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  if (!Object.entries(values === null || values === void 0 ? void 0 : values.attendees).length || !Object.entries(values.slots).length) {
    return null;
  }

  var attendeeASelectedSchedules = values.attendees.A.schedules.filter(function (_ref2) {
    var isSelected = _ref2.isSelected,
        isPaid = _ref2.isPaid;
    return isSelected || isPaid;
  });

  var checkAllSlots = function checkAllSlots(_ref3) {
    var target = _ref3.target;
    attendeeASelectedSchedules.forEach(function (schedule) {
      Object.keys(values.slots).forEach(function (slotId) {
        if (target.checked && slotId.endsWith('A') || !slotId.includes(schedule.startDate) && !slotId.includes(schedule.endDate)) {
          return;
        }

        var slotIdOfA = slotId.replace(/.$/, 'A');
        dist["windowWrapper"].requestAnimationFrame(function () {
          setFieldValue("slots[".concat(slotId, "].isSelected"), target.checked ? values.slots[slotIdOfA].isSelected : false);
        });
      });
    });
  };

  var filteredAttendees = showOnlyCurrentAttendeeSlots && attendeeId ? Object.values(values.attendees).filter(function (_ref4) {
    var id = _ref4.id;
    return id === attendeeId;
  }) : Object.values(values.attendees);
  var filteredAttendeesArray = [];

  for (var attendee in values.attendees) {
    if (Object.hasOwnProperty.call(values.attendees, attendee)) {
      var element = _objectSpread({
        attendeeId: attendee
      }, values.attendees[attendee]);

      if (showOnlyCurrentAttendeeSlots && attendeeId && attendeeId !== attendee) {
        return;
      }

      filteredAttendeesArray.push(element);
    }
  }

  return ReservationSlotsStep_jsx(react["Fragment"], null, filteredAttendees.filter(function (_ref5) {
    var selected = _ref5.selected;
    return selected;
  }).length > 1 && ReservationSlotsStep_jsx("div", {
    className: "border-b-1 py-15"
  }, ReservationSlotsStep_jsx(FormikInput["a" /* FormikInput */], {
    label: Object(i18n["h" /* t */])('booking.activities.skiEquipment.sameScheduleAllParticipants'),
    name: "sameScheduleForAll",
    onChange: checkAllSlots,
    type: "checkbox"
  })), // $FlowFixMe
  Object.entries(values.attendees).map( // $FlowFixMe
  // eslint-disable-next-line no-shadow
  function (_ref6) {
    var _ref7 = Object(slicedToArray["a" /* default */])(_ref6, 2),
        attendeeId = _ref7[0],
        _ref7$ = _ref7[1],
        selected = _ref7$.selected,
        schedules = _ref7$.schedules;

    if (!selected) {
      return null;
    }

    var attendeeSelectedSchedules = schedules.filter(function (_ref8) {
      var isSelected = _ref8.isSelected,
          isPaid = _ref8.isPaid;
      return isSelected || isPaid;
    });
    attendeeSelectedSchedules.forEach(function (schedule) {
      // ugly fix #97990
      schedule.isSelected = true;
    });
    return ReservationSlotsStep_jsx("div", {
      className: "divide-y divide-lightGrey",
      key: attendeeId
    }, ReservationSlotsStep_jsx("p", {
      className: "air360-replay-ignore flex items-center gap-5 py-10 text-14"
    }, ReservationSlotsStep_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].PEOPLE,
      width: "1em"
    }), Object(reservationBlock_utils["i" /* getAttendeeLabel */])(attendeesList, attendeeId, appContext)), attendeeSelectedSchedules.map(function (_ref9, index) {
      var startDate = _ref9.startDate,
          endDate = _ref9.endDate;

      var _ref10 = values.slots[Object(reservationBlock_utils["j" /* getSlotKey */])({
        slotName: reservationBlock_utils["f" /* MORNING */],
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      })] || slotNotAvailable,
          isMorningPaid = _ref10.isPaid,
          isMorningDisabled = _ref10.isDisabled; // SLOTS BECOMES DYNAMIC
      // afternoon slot is either before 4pm or before 5pm


      var afternoonBefore4SlotKey = Object(reservationBlock_utils["j" /* getSlotKey */])({
        slotName: reservationBlock_utils["d" /* AFTERNOON_BEFORE_4PM */],
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      });
      var afternoonBefore5SlotKey = Object(reservationBlock_utils["j" /* getSlotKey */])({
        slotName: reservationBlock_utils["e" /* AFTERNOON_BEFORE_5PM */],
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      });
      var afternoonAfter4SlotKey = Object(reservationBlock_utils["j" /* getSlotKey */])({
        slotName: reservationBlock_utils["b" /* AFTERNOON_AFTER_4PM */],
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      });
      var afternoonAfter5SlotKey = Object(reservationBlock_utils["j" /* getSlotKey */])({
        slotName: reservationBlock_utils["c" /* AFTERNOON_AFTER_5PM */],
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      }); // slots

      var afternoonBefore4Slot = values.slots[afternoonBefore4SlotKey];
      var afternoonBefore5Slot = values.slots[afternoonBefore5SlotKey];
      var afternoonAfter4Slot = values.slots[afternoonAfter4SlotKey];
      var afternoonAfter5Slot = values.slots[afternoonAfter5SlotKey];
      var afternoonSlot = afternoonBefore4Slot || afternoonBefore5Slot || slotNotAvailable;
      var eveningSlot = afternoonAfter4Slot || afternoonAfter5Slot || slotNotAvailable;
      var afternoonSlotType = !!afternoonBefore4Slot ? reservationBlock_utils["d" /* AFTERNOON_BEFORE_4PM */] : reservationBlock_utils["e" /* AFTERNOON_BEFORE_5PM */]; // eslint-disable-next-line no-extra-boolean-cast

      var eveningSlotType = !!afternoonAfter4Slot ? reservationBlock_utils["b" /* AFTERNOON_AFTER_4PM */] : reservationBlock_utils["c" /* AFTERNOON_AFTER_5PM */];
      var afternoonSlotSubtitle = afternoonSlotType === reservationBlock_utils["d" /* AFTERNOON_BEFORE_4PM */] ? 'before4PM' : 'before5PM';
      var eveningSlotSubtitle = eveningSlotType === reservationBlock_utils["b" /* AFTERNOON_AFTER_4PM */] ? 'after4PM' : 'after5PM';
      var SLOTS = [{
        isDisabled: isMorningDisabled,
        isPaid: isMorningPaid,
        subtitle: 'morning',
        title: 'morningTitle',
        type: reservationBlock_utils["f" /* MORNING */]
      }, {
        isDisabled: afternoonSlot.isDisabled,
        isPaid: afternoonSlot.isPaid,
        subtitle: afternoonSlotSubtitle,
        title: 'afternoonTitle',
        type: afternoonSlotType
      }, {
        isDisabled: eveningSlot.isDisabled,
        isPaid: eveningSlot.isPaid,
        subtitle: eveningSlotSubtitle,
        title: 'eveningTitle',
        type: eveningSlotType
      }];
      return ReservationSlotsStep_jsx("div", {
        className: "flex flex-wrap gap-10 py-10",
        key: index
      }, ReservationSlotsStep_jsx("div", {
        className: "flex flex-col items-stretch rounded-12 border border-saffron bg-saffron px-10 py-5 text-10 font-bold text-black"
      }, ReservationSlotsStep_jsx(DateSchedule["a" /* DateSchedule */], {
        date: startDate
      }), startDate !== endDate && ReservationSlotsStep_jsx(react["Fragment"], null, ReservationSlotsStep_jsx("div", {
        className: "mx-10"
      }, Object(i18n["h" /* t */])('common.to')), ReservationSlotsStep_jsx(DateSchedule["a" /* DateSchedule */], {
        date: endDate
      }))), SLOTS.map(function (_ref11) {
        var type = _ref11.type,
            isDisabled = _ref11.isDisabled,
            isPaid = _ref11.isPaid,
            title = _ref11.title,
            subtitle = _ref11.subtitle;
        var slotKey = Object(reservationBlock_utils["j" /* getSlotKey */])({
          attendeeId: attendeeId,
          endDate: endDate,
          slotName: type,
          startDate: startDate
        });
        var attendeeSlotInputName = "slots.".concat(slotKey, ".isSelected");

        var autoSelectSlotForOtherAttendees = function autoSelectSlotForOtherAttendees(_ref12) {
          var target = _ref12.target;
          dist["windowWrapper"].requestAnimationFrame(function () {
            setFieldValue(attendeeSlotInputName, target.checked);
          });

          if (!values.sameScheduleForAll) {
            return;
          }

          Object.keys(values.slots).forEach(function (slotId) {
            if (slotKey === slotId || !slotId.includes(type + '-' + startDate + '-' + endDate)) {
              return;
            }

            dist["windowWrapper"].requestAnimationFrame(function () {
              setFieldValue("slots[".concat(slotId, "].isSelected"), target.checked);
            });
          });
        };

        return ReservationSlotsStep_jsx(FormikInput["a" /* FormikInput */], {
          className: "grow items-stretch",
          isDisabled: isDisabled || isPaid,
          key: attendeeSlotInputName,
          name: attendeeSlotInputName,
          onChange: autoSelectSlotForOtherAttendees // TODO: cleanup !!
          // eslint-disable-next-line react/no-unstable-nested-components
          ,
          placeholderComponent: function placeholderComponent(isChecked) {
            return ReservationSlotsStep_jsx("div", {
              className: Object(classnames_utils["a" /* classnames */])('flex grow flex-col items-stretch justify-center rounded-12 border-1 px-10 py-5 text-center text-10', {
                'border-lightGrey text-black': !isChecked && !isPaid,
                'border-saffron-active bg-saffron text-black': isChecked || isPaid,
                'italic opacity-50': isDisabled || isPaid
              })
            }, ReservationSlotsStep_jsx("div", {
              className: "font-bold uppercase"
            }, Object(i18n["h" /* t */])("booking.activities.timeSlot.".concat(title))), ReservationSlotsStep_jsx("div", {
              className: "text-10"
            }, Object(i18n["h" /* t */])("booking.activities.timeSlot.subtitles.".concat(subtitle))));
          },
          type: "checkbox"
        });
      }));
    }));
  }));
};
// EXTERNAL MODULE: ./src/utils/childcare/childcare.consts.js
var childcare_consts = __webpack_require__("gzwZ");

// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ScheduleEnvelopeFSS.jsx
var ScheduleEnvelopeFSS_jsx = react_default.a.createElement;


var ScheduleEnvelopeFSS_ScheduleEnvelopeFSS = function ScheduleEnvelopeFSS(_ref) {
  var isFullStaySchedule = _ref.isFullStaySchedule,
      InputComp = _ref.InputComp;

  if (isFullStaySchedule) {
    return ScheduleEnvelopeFSS_jsx("div", {
      className: "flex flex-col w-full pt-20"
    }, ScheduleEnvelopeFSS_jsx("span", {
      className: "font-bold text-black text-14 pb-5"
    }, Object(i18n["h" /* t */])('booking.activities.childcare.chooseWhenFullStay')), ScheduleEnvelopeFSS_jsx(InputComp, null));
  }

  return ScheduleEnvelopeFSS_jsx(InputComp, null);
};
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationScheduleStepFSS.jsx










var ReservationScheduleStepFSS_jsx = react_default.a.createElement;

/* eslint-disable react/no-unstable-nested-components */













var ReservationScheduleStepFSS_isSingleDaySchedule = function isSingleDaySchedule(schedule) {
  return schedule.startDate === schedule.endDate;
};

var ReservationScheduleStepFSS_ReservationScheduleStepFSS = function ReservationScheduleStepFSS(_ref) {
  var departureDate = _ref.stayDepartureDate,
      arrivalDate = _ref.stayArrivalDate,
      attendeeId = _ref.attendeeId;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      scheduleReservationMessage = _useContext.scheduleReservationMessage;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      validateForm = _useFormikContext.validateForm,
      setFieldValue = _useFormikContext.setFieldValue;

  var _useState = Object(react["useState"])({}),
      lastAvailableSchedule = _useState[0],
      setLastAvailableSchedule = _useState[1]; // show only current attendee schedules


  var filteredAttendeesValues = [values.attendees[attendeeId]]; // find the all duration schedule if exists
  // he has a special treatment because of the childcare BY DAY
  // that is equivalent to the whole duration of stay

  Object(react["useEffect"])(function () {
    validateForm();
    filteredAttendeesValues // $FlowFixMe
    .filter(function (_ref2) {
      var selected = _ref2.selected;
      return !selected;
    }).forEach(function (_ref3) {
      var attendeeSchedules = _ref3.schedules;
      // const attendeeSchedules = values.attendees[attendeeId].schedules;
      attendeeSchedules.forEach(function (_ref4, scheduleIndex) {
        var isSelected = _ref4.isSelected;

        if (!isSelected) {
          return;
        }

        setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), false);
      });
    });
    return function () {
      // when the component is unmount the validation is not triggered and the confirm button can stay disabled
      validateForm();
    };
  }, []);
  return ReservationScheduleStepFSS_jsx(react["Fragment"], null, scheduleReservationMessage && ReservationScheduleStepFSS_jsx("p", {
    className: "font-bold mt-10 text-sienna text-12"
  }, scheduleReservationMessage), // $FlowFixMe
  filteredAttendeesValues.map( // $FlowFixMe
  function (_ref5) {
    var schedules = _ref5.schedules;
    var fullStayScheduleIndex = schedules.findIndex(function (_ref6) {
      var startDate = _ref6.startDate,
          endDate = _ref6.endDate;
      return startDate === arrivalDate && endDate === departureDate;
    });
    var fullStaySchedule = schedules[fullStayScheduleIndex];
    var attendeeSelectedSchedules = schedules.filter(function (_ref7) {
      var isSelected = _ref7.isSelected;
      return isSelected;
    });
    var attendeePaidSchedules = schedules.filter(function (_ref8) {
      var isPaid = _ref8.isPaid;
      return isPaid;
    });
    return ReservationScheduleStepFSS_jsx("div", {
      className: "divide-y divide-lightGrey",
      key: attendeeId
    }, ReservationScheduleStepFSS_jsx("div", {
      className: "flex flex-wrap gap-10 py-10 "
    }, schedules.map(function (_ref9, scheduleIndex) {
      var endDate = _ref9.endDate,
          startDate = _ref9.startDate;
      // Disabling schedules frontend
      var currentChildSchedule = values.attendees[attendeeId].schedules[scheduleIndex];
      var fullStayScheduleIsPaid = fullStaySchedule.isPaid;
      var isCurrentSingleAndFullStayPaid = ReservationScheduleStepFSS_isSingleDaySchedule(currentChildSchedule) && fullStayScheduleIsPaid;
      var isCurrentFullStayAndOneSinglePaid = !ReservationScheduleStepFSS_isSingleDaySchedule(currentChildSchedule) && schedules.some(function (schedule) {
        return ReservationScheduleStepFSS_isSingleDaySchedule(schedule) && schedule.isPaid;
      });
      var isCurrentSchedulePaid = !!(currentChildSchedule === null || currentChildSchedule === void 0 ? void 0 : currentChildSchedule.isPaid) || !!(currentChildSchedule === null || currentChildSchedule === void 0 ? void 0 : currentChildSchedule.isFullyPaid);
      var isDisabled = // if current schedule is paid
      isCurrentSchedulePaid || // if the current schedule if it's a single schedule & full stay schedule is paid
      isCurrentSingleAndFullStayPaid || // if the current schedule is a full stay schedule & one of the single schedules is paid
      isCurrentFullStayAndOneSinglePaid; // SCHEDULE PLACEHOLDER : defined here cuz it needs isDisabled

      var PlaceHolderFSS = function PlaceHolderFSS(isChecked) {
        return ReservationScheduleStepFSS_jsx("div", {
          className: Object(classnames_utils["a" /* classnames */])('border-1 flex font-bold items-center py-5 px-10 rounded-12 text-10', {
            'border-lightGrey text-black': !isChecked,
            'bg-saffron border-saffron-active text-black': isChecked,
            'italic opacity-50': isDisabled,
            'w-1/2 justify-between': startDate !== endDate
          }),
          "data-testid": "reservationScheduleDay"
        }, ReservationScheduleStepFSS_jsx(DateSchedule["a" /* DateSchedule */], {
          date: startDate
        }), startDate !== endDate && ReservationScheduleStepFSS_jsx(react["Fragment"], null, ReservationScheduleStepFSS_jsx("div", {
          className: "mx-10"
        }, Object(i18n["h" /* t */])('common.to')), ReservationScheduleStepFSS_jsx(DateSchedule["a" /* DateSchedule */], {
          date: endDate
        })));
      }; // SCHEDULES STEP


      return ReservationScheduleStepFSS_jsx(ScheduleEnvelopeFSS_ScheduleEnvelopeFSS, {
        key: "".concat(startDate, "-").concat(endDate, "-Container"),
        isFullStaySchedule: startDate === arrivalDate && endDate === departureDate,
        InputComp: function InputComp() {
          return ReservationScheduleStepFSS_jsx(FormikInput["a" /* FormikInput */], {
            isDisabled: isDisabled,
            key: "".concat(startDate).concat(endDate),
            dataTestId: "scheduleCheckboxItem",
            name: "attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"),
            type: "checkbox",
            onChange: function onChange(e) {
              var hasSelectedAllSingleSchedules = e.target.checked && attendeeSelectedSchedules.length === schedules.length - 2;
              var hasPaidSomeSingleSchedules = (attendeePaidSchedules === null || attendeePaidSchedules === void 0 ? void 0 : attendeePaidSchedules.length) >= 1; // select all single day schedules, the full stay schedule is automatically selected

              if (hasSelectedAllSingleSchedules && !hasPaidSomeSingleSchedules) {
                dist["windowWrapper"].requestAnimationFrame(function () {
                  values.attendees[attendeeId].schedules.forEach(function (_ref10, scheduleIndexFE) {
                    var sDate = _ref10.startDate,
                        eDate = _ref10.endDate;

                    if (sDate === fullStaySchedule.startDate && eDate === fullStaySchedule.endDate) {
                      setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexFE, "].isSelected"), true);
                    } else {
                      setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexFE, "].isSelected"), false);
                    }
                  });
                });
              } // if i select the full stay schedule, all the single day schedules are automatically unselected


              if (e.target.checked && startDate === arrivalDate && endDate === departureDate) {
                values.attendees[attendeeId].schedules.map(function (_ref11, scheduleIndexMp) {
                  var scheduleStartDateMp = _ref11.startDate,
                      scheduleEndDateMp = _ref11.endDate;

                  // FS schedule
                  if (scheduleEndDateMp !== scheduleStartDateMp && scheduleEndDateMp === departureDate && scheduleStartDateMp === arrivalDate) {
                    // setTimeout here is a hack to fix formik bug when calling setFieldValue in onChange
                    setTimeout(function () {
                      dist["windowWrapper"].requestAnimationFrame(function () {
                        setFieldValue("attendees.".concat(attendeeId, ".schedules.[").concat(scheduleIndexMp, "].isSelected"), true);
                      });
                    }, 0);
                  } // single day other schedules


                  if (scheduleEndDateMp === scheduleStartDateMp) {
                    dist["windowWrapper"].requestAnimationFrame(function () {
                      setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexMp, "].isSelected"), false);
                    });
                  }
                });
              } // if you select any single day schedule, the full stay schedule is automatically deselected


              if (e.target.checked && attendeeSelectedSchedules.length === 1) {
                dist["windowWrapper"].requestAnimationFrame(function () {
                  values.attendees[attendeeId].schedules.forEach(function (_ref12, scheduleIndexFE) {
                    var startD = _ref12.startDate,
                        endD = _ref12.endDate;

                    if (startD === fullStaySchedule.startDate && endD === fullStaySchedule.endDate) {
                      setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndexFE, "].isSelected"), false);
                    }
                  });
                });
              }

              if (!values.attendees[attendeeId].schedules[scheduleIndex].isSelected && values.attendees[attendeeId].schedules[scheduleIndex].remainingStock <= childcare_consts["b" /* CHILDCARE_STOCK_THRESHOLD */]) {
                setLastAvailableSchedule({
                  isVisible: true,
                  nb: values.attendees[attendeeId].schedules[scheduleIndex].remainingStock
                });
              } else {
                setLastAvailableSchedule({});
              }
            },
            placeholderComponent: PlaceHolderFSS
          });
        }
      });
    })));
  }), lastAvailableSchedule.isVisible && ReservationScheduleStepFSS_jsx("p", {
    className: "flex font-bold gap-5 items-center leading-1 mt-5 text-14 text-red"
  }, ReservationScheduleStepFSS_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].WARNING,
    width: "18px"
  }), Object(i18n["h" /* t */])('booking.activities.remainingService', {
    nb: lastAvailableSchedule.nb
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationBlock.jsx





























var ReservationBlock_jsx = react_default.a.createElement;

function ReservationBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ReservationBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ReservationBlock_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ReservationBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-else-return */

/* eslint-disable no-shadow */


















var ReservationBlock_TIMESLOT_REGEX = /([a-z0-9_]+)-([0-9]{8})-([0-9]{8})-([a-z])/;
var STEPS = {
  ATTENDEES: 'ATTENDEES',
  SCHEDULES: 'SCHEDULES',
  SLOTS: 'SLOTS'
};

var ReservationBlock_ButtonContent = function ButtonContent(_ref) {
  var hasMultiSchedules = _ref.hasMultiSchedules,
      showStep = _ref.showStep,
      cancellingActivity = _ref.cancellingActivity,
      serviceType = _ref.serviceType,
      totalPrice = _ref.totalPrice,
      rentButtonLabel = _ref.rentButtonLabel,
      locale = _ref.locale,
      currency = _ref.currency;

  if (hasMultiSchedules && showStep === STEPS.ATTENDEES && !cancellingActivity) {
    return Object(i18n["h" /* t */])("booking.activities.".concat(Object(activities_utils["g" /* getUpsellCmsKeyPath */])(serviceType), ".chooseWhen"));
  }

  if (totalPrice > 0) {
    return ReservationBlock_jsx(TemplateString["a" /* TemplateString */], {
      template: rentButtonLabel,
      values: {
        price: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(totalPrice, locale, currency)
      }
    });
  }

  return Object(i18n["h" /* t */])('booking.common.validate');
};

var ReservationBlock_ReservationBlock = function ReservationBlock(_ref2) {
  var _schedules$, _schedules$$slots;

  var headerLabel = _ref2.headerLabel,
      introductionLabel = _ref2.introductionLabel,
      onSubmit = _ref2.onSubmit,
      rentButtonLabel = _ref2.rentButtonLabel,
      service = _ref2.service,
      showOnlyCurrentAttendeeSlots = _ref2.showOnlyCurrentAttendeeSlots,
      attendeeId = _ref2.attendeeId,
      _ref2$isButtonLoading = _ref2.isButtonLoading,
      isButtonLoading = _ref2$isButtonLoading === void 0 ? false : _ref2$isButtonLoading;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      currency = _useContext.currency,
      departureDate = _useContext.departureDate,
      arrivalDate = _useContext.arrivalDate;

  var initialShowStep = showOnlyCurrentAttendeeSlots ? STEPS.SCHEDULES : STEPS.ATTENDEES;

  var _useState = Object(react["useState"])(initialShowStep),
      showStep = _useState[0],
      setShowStep = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      cancellingActivity = _useState2[0],
      setCancellingActivity = _useState2[1];

  var hasMultiSlots = service.schedules.some(function (schedule) {
    return schedule.slots.length > 1 && schedule.slots.some(function (slot) {
      return slot.type !== 'DAY';
    });
  }); // THIS IS VERY IMPORTANT AND SHOULD STAY IN PLACE
  // FOR A CASE OF MIXED TYPES OF SCHEDULES IT PUTS THE FSS SCHEDULE AT THE END

  var schedules = service.schedules.sort(function (a, b) {
    return Number(a.startDate) - Number(b.startDate);
  });
  var serviceType = service.type; // Same type for all services

  var isRental = serviceType === reservationBlock_utils["g" /* RENTAL */];

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var hasMultiSchedules = schedules.length > 1 || schedules.length === 1 && ((_schedules$ = schedules[0]) === null || _schedules$ === void 0 ? void 0 : (_schedules$$slots = _schedules$.slots) === null || _schedules$$slots === void 0 ? void 0 : _schedules$$slots.length) > 1;
  var attendees = service.attendees,
      productInfoId = service.id;
  var hasReservedSchedule = service.attendees.some(function (attendee) {
    return attendee.schedules.some(function (_ref3) {
      var isPartiallyRented = _ref3.isPartiallyRented;
      return isPartiallyRented;
    });
  });
  var initialFormValues = {
    sameScheduleForAll: false,
    attendees: attendees.reduce(function (initialValues, _ref4) {
      var id = _ref4.id,
          price = _ref4.price,
          schedules = _ref4.schedules;
      return ReservationBlock_objectSpread(ReservationBlock_objectSpread({}, initialValues), {}, Object(defineProperty["a" /* default */])({}, id, {
        selected: schedules.some(function (schedule) {
          return schedule.isPartiallyPaid;
        }) || schedules.some(function (schedule) {
          return schedule.isPartiallyRented;
        }) || showOnlyCurrentAttendeeSlots && id === attendeeId,
        isPaid: schedules.every(function (schedule) {
          return schedule.isFullyPaid;
        }),
        price: price.value,
        schedules: schedules.map(function (schedule) {
          var commonValues = {
            isPaid: schedule.isPartiallyPaid,
            isFullyPaid: schedule.isFullyPaid,
            startDate: schedule.startDate,
            endDate: schedule.endDate,
            timeSlots: schedule.timeSlots.map(function (slot) {
              return slot.slotName;
            }),
            remainingStock: schedule.timeSlots[0].remainingStock
          };
          return hasMultiSchedules ? ReservationBlock_objectSpread({
            isSelected: schedule.isPartiallyRented || schedule.isPartiallyPaid
          }, commonValues) : ReservationBlock_objectSpread({
            isSelected: true
          }, commonValues);
        })
      }));
    }, {}),
    wholeDurationOfStay: attendees.reduce(function (wholeDurationOfStay, _ref5) {
      var id = _ref5.id,
          schedules = _ref5.schedules;
      return ReservationBlock_objectSpread(ReservationBlock_objectSpread({}, wholeDurationOfStay), {}, Object(defineProperty["a" /* default */])({}, id, schedules.every(function (schedule) {
        return schedule.isFullyRented;
      })));
    }, {}),
    slots: attendees.reduce(function (slots, attendee) {
      var id = attendee.id;
      return attendee.schedules.reduce(function (accumulatedSchedules, schedule) {
        var startDate = schedule.startDate,
            endDate = schedule.endDate,
            timeSlots = schedule.timeSlots;
        var cheapest = timeSlots.reduce(function (a, b) {
          if (a.price.value <= b.price.value) {
            return a;
          }

          return b;
        });
        var isUnique = !!timeSlots.reduce(function (a, b) {
          if (b.price.value === cheapest.price.value) {
            return [].concat(Object(toConsumableArray["a" /* default */])(a), [b]);
          }

          return a;
        }, []).length;
        return timeSlots.reduce(function (accumulatedSlots, _ref6) {
          var slotName = _ref6.slotName,
              serviceId = _ref6.id,
              isPaid = _ref6.isPaid,
              isRented = _ref6.isRented,
              price = _ref6.price;
          accumulatedSlots[Object(reservationBlock_utils["j" /* getSlotKey */])({
            slotName: slotName,
            startDate: startDate,
            endDate: endDate,
            attendeeId: id
          })] = {
            productInfoId: productInfoId,
            serviceId: serviceId,
            isSelected: isPaid || isRented || serviceId === cheapest.id && isUnique && !showOnlyCurrentAttendeeSlots,
            isPaid: isPaid,
            price: price.value
          };
          return accumulatedSlots;
        }, accumulatedSchedules);
      }, slots);
    }, {})
  };

  var validateForm = function validateForm(formValues) {
    var errors = {};

    if (showStep === STEPS.ATTENDEES && !cancellingActivity && (!hasReservedSchedule || hasMultiSchedules || hasMultiSlots) && // $FlowFixMe
    !Object.values(formValues.attendees).some(function (_ref7) {
      var selected = _ref7.selected,
          isPaid = _ref7.isPaid;
      return selected && !isPaid;
    })) {
      errors.attendees = true;
    }

    if (hasMultiSchedules && showStep === STEPS.SCHEDULES && (!hasReservedSchedule || hasMultiSlots) && !Object.values(formValues.attendees).every( // $FlowFixMe
    function (_ref8) {
      var selected = _ref8.selected,
          attendeeSchedules = _ref8.schedules;
      return !selected || selected && Object.values(attendeeSchedules).some( // $FlowFixMe :'(
      function (_ref9) {
        var isSelected = _ref9.isSelected;
        return isSelected;
      }) || Object.values(attendeeSchedules).every( // $FlowFixMe :'(
      function (_ref10) {
        var isFullyPaid = _ref10.isFullyPaid;
        return isFullyPaid;
      });
    })) {
      errors.schedules = true;
    }

    if (showStep === STEPS.SLOTS) {
      if (!hasReservedSchedule && (!Object.entries(formValues.slots).length === 0 || // $FlowFixMe
      !Object.values(formValues.slots).some(function (_ref11) {
        var isSelected = _ref11.isSelected,
            isPaid = _ref11.isPaid;
        return isSelected && !isPaid;
      }))) {
        errors.slots = true;
      }
    }

    return errors;
  };

  var handleFormSubmit = function handleFormSubmit(values) {
    var serviceIds = [];
    var attendeeIds = [];
    var attendeesReservations = Object.entries(values.slots).reduce(function (attendeesReservations, _ref12) {
      var _schedules$2, _schedules$2$slots;

      var _ref13 = Object(slicedToArray["a" /* default */])(_ref12, 2),
          slotKey = _ref13[0],
          slot = _ref13[1];

      var timeSlotRegex = new RegExp(ReservationBlock_TIMESLOT_REGEX, 'gi'); // $FlowFixMe

      var _timeSlotRegex$exec = timeSlotRegex.exec(slotKey),
          _timeSlotRegex$exec2 = Object(slicedToArray["a" /* default */])(_timeSlotRegex$exec, 5),
          timeSlotStartDate = _timeSlotRegex$exec2[2],
          timeSlotEndDate = _timeSlotRegex$exec2[3],
          timeSlotCustomerId = _timeSlotRegex$exec2[4]; // $FlowFixMe


      if (!serviceIds.includes(slot.serviceId)) {
        // $FlowFixMe
        serviceIds.push(slot.serviceId);
      }

      if (!attendeeIds.includes(timeSlotCustomerId)) {
        attendeeIds.push(timeSlotCustomerId);
      }

      var attendee = values.attendees[timeSlotCustomerId];
      var currentSchedule = attendee.schedules.find(function (_ref14) {
        var startDate = _ref14.startDate,
            endDate = _ref14.endDate;
        return startDate === timeSlotStartDate && endDate === timeSlotEndDate;
      });

      if (attendee.selected && attendee.schedules.length === 1 && !(((_schedules$2 = schedules[0]) === null || _schedules$2 === void 0 ? void 0 : (_schedules$2$slots = _schedules$2.slots) === null || _schedules$2$slots === void 0 ? void 0 : _schedules$2$slots.length) > 1) || attendee.selected && currentSchedule.isSelected && ( // $FlowFixMe
      currentSchedule.timeSlots.length === 1 || slot.isSelected)) {
        var schedule = {
          startDate: timeSlotStartDate,
          endDate: timeSlotEndDate,
          // $FlowFixMe
          slots: [slot.serviceId]
        };
        var attendeeIndex = attendeesReservations.findIndex(function (_ref15) {
          var customerId = _ref15.customerId;
          return customerId === timeSlotCustomerId;
        });

        if (attendeeIndex === -1) {
          attendeesReservations.push({
            customerId: timeSlotCustomerId,
            productInfoId: productInfoId,
            schedules: [schedule]
          });
        } else {
          var scheduleIndex = attendeesReservations[attendeeIndex].schedules.findIndex(function (schedule) {
            return schedule.startDate === timeSlotStartDate && schedule.endDate === timeSlotEndDate;
          });

          if (scheduleIndex === -1) {
            attendeesReservations[attendeeIndex].schedules.push(schedule);
          } else {
            attendeesReservations[attendeeIndex].schedules[scheduleIndex].slots.push( // $FlowFixMe
            slot.serviceId);
          }
        }
      }

      return attendeesReservations;
    }, []);
    onSubmit(attendeesReservations, serviceIds, attendeeIds);
  };

  var getTotalPriceReserved = function getTotalPriceReserved(formValues) {
    if ((hasMultiSlots && showStep === STEPS.SLOTS || !hasMultiSlots && hasMultiSchedules && showStep === STEPS.SCHEDULES || !hasMultiSlots && !hasMultiSchedules && showStep === STEPS.ATTENDEES) && formValues.slots) {
      var filteredAttendees = !showOnlyCurrentAttendeeSlots ? service.attendees : service.attendees.filter(function (_ref16) {
        var id = _ref16.id;
        return id === attendeeId;
      });
      return filteredAttendees.reduce(function (totalPrice, attendee) {
        return totalPrice + attendee.schedules.reduce(function (priceAttendeeSchedule, schedule) {
          return priceAttendeeSchedule + (schedule.isFullyPaid ? 0 : schedule.timeSlots.reduce(function (price, _ref17) {
            var _formValues$attendees;

            var slotName = _ref17.slotName,
                slotPrice = _ref17.price;
            var _formValues$slots$get = formValues.slots[Object(reservationBlock_utils["j" /* getSlotKey */])({
              slotName: slotName,
              startDate: schedule.startDate,
              endDate: schedule.endDate,
              attendeeId: attendee.id
            })],
                isSlotPaid = _formValues$slots$get.isPaid,
                isSlotSelected = _formValues$slots$get.isSelected;
            var isAttendeeSelected = formValues.attendees[attendee.id].selected;
            var isScheduleSelected = (_formValues$attendees = formValues.attendees[attendee.id].schedules.find(function (s) {
              return s.startDate === schedule.startDate && s.endDate === schedule.endDate;
            })) === null || _formValues$attendees === void 0 ? void 0 : _formValues$attendees.isSelected;
            var attendeePrice = isAttendeeSelected && isScheduleSelected && (!hasMultiSlots && hasMultiSchedules && showStep === STEPS.SCHEDULES || !hasMultiSlots && !hasMultiSchedules && showStep === STEPS.ATTENDEES || hasMultiSlots && isSlotSelected && !isSlotPaid) ? slotPrice.value : 0;
            return price + attendeePrice;
          }, 0));
        }, 0);
      }, 0);
    }

    return 0;
  };

  var getLowerPrice = function getLowerPrice(attendee) {
    if (!(hasMultiSchedules || hasMultiSlots)) {
      return attendee.price;
    }

    var lowerPrice = ReservationBlock_objectSpread({}, attendee.price);

    attendee.schedules.forEach(function (schedule) {
      schedule.timeSlots.forEach(function (slot) {
        if (slot.price.value < lowerPrice.value) {
          lowerPrice = ReservationBlock_objectSpread({}, slot.price);
        }
      });
    });
    return lowerPrice;
  };

  var isInitialValid = Object.keys(validateForm(initialFormValues)).length === 0;
  var stepsTotal = hasMultiSlots ? 3 : 2; // FULL STAY IN ONE SCHEDULE MODE FSSM

  var _partition2 = partition_default()(schedules, function (_ref18) {
    var startDate = _ref18.startDate,
        endDate = _ref18.endDate;
    return startDate === arrivalDate && endDate === departureDate;
  }),
      _partition3 = Object(slicedToArray["a" /* default */])(_partition2, 2),
      singleDaySchedules = _partition3[0],
      fullStaySchedule = _partition3[1];

  var shouldActivateFullStayScheduleMode = singleDaySchedules.length > 0 && fullStaySchedule.length > 0; // childcare shows one block per attendee

  var attendeesFiltered = showOnlyCurrentAttendeeSlots && attendeeId ? attendees.filter(function (_ref19) {
    var id = _ref19.id;
    return id === attendeeId;
  }) : attendees;
  return ReservationBlock_jsx(react["Fragment"], null, ReservationBlock_jsx("header", {
    className: "z-1 border-b-1 border-lightGrey px-20 py-15 text-16 font-bold leading-tight text-black"
  }, headerLabel), ReservationBlock_jsx("div", {
    className: "p-20"
  }, ReservationBlock_jsx(formik_esm["d" /* Formik */], {
    initialValues: initialFormValues,
    onSubmit: handleFormSubmit,
    validate: validateForm,
    validateOnMount: !isInitialValid
  }, function (formik) {
    var totalPrice = getTotalPriceReserved(formik.values);
    return ReservationBlock_jsx(react["Fragment"], null, ReservationBlock_jsx(ReservationBlockHeader_ReservationBlockHeader, {
      isActive: showStep === STEPS.ATTENDEES && !showOnlyCurrentAttendeeSlots || shouldActivateFullStayScheduleMode && !!attendeeId,
      label: introductionLabel,
      onEdit: function onEdit() {
        return setShowStep(STEPS.ATTENDEES);
      },
      stepNumber: 1,
      stepsTotal: hasMultiSchedules && !showOnlyCurrentAttendeeSlots ? stepsTotal : 1,
      isEditVisible: !showOnlyCurrentAttendeeSlots
    }), !showOnlyCurrentAttendeeSlots && ReservationBlock_jsx(lib["UnmountClosed"], {
      isOpened: showStep === STEPS.ATTENDEES
    }, ReservationBlock_jsx(ReservationAttendeesStep_ReservationAttendeesStep, {
      attendees: attendeesFiltered,
      hasReservedSchedule: hasReservedSchedule,
      cancellingActivity: cancellingActivity,
      getLowerPrice: getLowerPrice,
      setCancellingActivity: setCancellingActivity
    })), hasMultiSchedules && showStep !== STEPS.ATTENDEES && !showOnlyCurrentAttendeeSlots && ReservationBlock_jsx(ReservationBlockHeader_ReservationBlockHeader, {
      isActive: showStep === STEPS.SCHEDULES,
      label: Object(i18n["h" /* t */])("booking.activities.".concat(Object(activities_utils["g" /* getUpsellCmsKeyPath */])(serviceType), ".registrationDates")),
      onEdit: function onEdit() {
        return setShowStep(STEPS.SCHEDULES);
      },
      stepNumber: 2,
      isEditVisible: !showOnlyCurrentAttendeeSlots,
      stepsTotal: hasMultiSchedules && !showOnlyCurrentAttendeeSlots ? stepsTotal : 1
    }), ReservationBlock_jsx(lib["UnmountClosed"], {
      isOpened: showStep === STEPS.SCHEDULES
    }, shouldActivateFullStayScheduleMode && attendeeId ? ReservationBlock_jsx(ReservationScheduleStepFSS_ReservationScheduleStepFSS, {
      stayDepartureDate: departureDate,
      stayArrivalDate: arrivalDate,
      attendeeId: attendeeId
    }) : ReservationBlock_jsx(ReservationScheduleStep_ReservationScheduleStep, {
      attendees: attendeesFiltered
    })), showStep === STEPS.SLOTS && ReservationBlock_jsx(ReservationBlockHeader_ReservationBlockHeader, {
      isActive: showStep === STEPS.SLOTS,
      label: Object(i18n["h" /* t */])('booking.activities.timeSlot.title'),
      stepNumber: 3,
      stepsTotal: hasMultiSchedules && !showOnlyCurrentAttendeeSlots ? stepsTotal : 1
    }), ReservationBlock_jsx(lib["UnmountClosed"], {
      isOpened: showStep === STEPS.SLOTS
    }, ReservationBlock_jsx(ReservationSlotsStep_ReservationSlotsStep, {
      showOnlyCurrentAttendeeSlots: showOnlyCurrentAttendeeSlots,
      attendeeId: attendeeId
    })), ReservationBlock_jsx(Button["a" /* Button */], {
      isLoading: isButtonLoading,
      className: "mt-20 w-full",
      "data-testid": "ReservationBlock-validationBtn",
      isDisabled: !formik.isValid || initialFormValues === formik.values,
      onClick: function onClick() {
        (totalPrice > 0 || cancellingActivity) && serviceType !== 'CHILDCARE' && trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_UPSELL, {
          detail_click: Object(reservationBlock_utils["h" /* activityOrEquipementDetailClick */])(cancellingActivity, isRental),
          activity_type: serviceType.toLowerCase()
        });

        if (hasMultiSchedules && showStep === STEPS.ATTENDEES && // $FlowFixMe
        Object.values(formik.values.attendees).some(function (_ref20) {
          var selected = _ref20.selected;
          return selected;
        }) && !cancellingActivity) {
          setShowStep(STEPS.SCHEDULES);
          formik.setErrors({
            schedules: true
          });
        } else if (showStep === STEPS.SCHEDULES && hasMultiSlots) {
          setShowStep(STEPS.SLOTS);
          formik.setErrors({
            slots: true
          });
        } else if (!formik.dirty) {
          // if the user has not touch the form we just call onSubmit with no value (to close the pop-in)
          // $FlowFixMe
          onSubmit();
        } else {
          formik.submitForm();
        }
      }
    }, ReservationBlock_jsx(ReservationBlock_ButtonContent, {
      hasMultiSchedules: hasMultiSchedules,
      showStep: showStep,
      cancellingActivity: cancellingActivity,
      serviceType: serviceType,
      totalPrice: totalPrice,
      rentButtonLabel: rentButtonLabel,
      locale: appContext.locale,
      currency: currency,
      isButtonLoading: isButtonLoading
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/PopInReservationBlock.jsx




var PopInReservationBlock_jsx = react_default.a.createElement;






var PopInReservationBlock_PopInReservationBlock = function PopInReservationBlock(_ref) {
  var onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      attendeeId = _ref.attendeeId,
      _ref$showOnlyCurrentA = _ref.showOnlyCurrentAttendeeSlots,
      showOnlyCurrentAttendeeSlots = _ref$showOnlyCurrentA === void 0 ? false : _ref$showOnlyCurrentA,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["onClose", "onSubmit", "attendeeId", "showOnlyCurrentAttendeeSlots"]);

  var _useDisclosure = Object(useDisclosure["a" /* useDisclosure */])(),
      isButtonLoading = _useDisclosure.isOpen,
      setButtonNotLoading = _useDisclosure.onClose,
      setButtonLoading = _useDisclosure.onOpen;

  return PopInReservationBlock_jsx(Modal["a" /* Modal */], {
    ariaLabel: otherProps.headerLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: onClose,
    size: "small"
  }, PopInReservationBlock_jsx(ReservationBlock_ReservationBlock, Object(esm_extends["a" /* default */])({}, otherProps, {
    attendeeId: attendeeId,
    showOnlyCurrentAttendeeSlots: showOnlyCurrentAttendeeSlots,
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(service, serviceIds, attendeeIds) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!service) {
                  _context.next = 5;
                  break;
                }

                setButtonLoading();
                _context.next = 4;
                return onSubmit(service, serviceIds, attendeeIds);

              case 4:
                setButtonNotLoading();

              case 5:
                onClose();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }(),
    isButtonLoading: isButtonLoading
  })));
};

/***/ }),

/***/ "ZFcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Slider; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-5 mt-10',
    thControl: 'mx-5'
  },
  center: {
    thInner: 'relative',
    thControls: 'z-2 absolute flex justify-between pointer-events-none top-1/2 transform -translate-y-1/2 w-full',
    thControl: 'pointer-events-auto before:absolute before:content-[""] before:h-120 before:right-0 before:h-40',
    thControlLeft: 'transform -translate-x-1/2',
    thControlRight: 'transform translate-x-1/2',
    thControlDisabled: 'invisible'
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-5',
    thControl: 'mx-5'
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-5 mb-10 order-first',
    thControl: 'mx-5'
  }
};
var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].LIGHT_SAND
    });
  },
  brand: function brand(_ref2) {
    var navPosition = _ref2.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].SAFFRON
    });
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.jsx









var __jsx = react_default.a.createElement;






function Slider(props) {
  var className = props.className,
      children = props.children,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      hasControls = props.hasControls,
      hasTabindex = props.hasTabindex,
      id = props.id,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$navPosition = props.navPosition,
      navPosition = _props$navPosition === void 0 ? 'top' : _props$navPosition,
      _props$nbItemsToScrol = props.nbItemsToScroll,
      nbItemsToScroll = _props$nbItemsToScrol === void 0 ? 1 : _props$nbItemsToScrol,
      nextLabel = props.nextLabel,
      onChangeIndex = props.onChangeIndex,
      onNext = props.onNext,
      onPrevious = props.onPrevious,
      previousLabel = props.previousLabel,
      scrollAreaClassName = props.scrollAreaClassName,
      scrollAreaContainerClassName = props.scrollAreaContainerClassName,
      scrollControlsClassName = props.scrollControlsClassName,
      scrollItemClassName = props.scrollItemClassName,
      scrollItemStyle = props.scrollItemStyle,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var childrenCount = react["Children"].count(children);
  var containerRef = Object(react["useRef"])(null);
  var refsArray = Object(react["useRef"])([]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var _useState = Object(react["useState"])(initialIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])({
    hasReachedLeft: false,
    hasReachedRight: false
  }),
      reachedX = _useState2[0],
      setReachedX = _useState2[1];

  var _useState3 = Object(react["useState"])(react["Children"].map(children, function () {
    return false;
  })),
      hiddenIndexes = _useState3[0],
      setHiddenIndexes = _useState3[1];

  var _useState4 = Object(react["useState"])(null),
      prevInitialIndex = _useState4[0],
      setPrevInitialIndex = _useState4[1];

  Object(react["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  var getHiddenIndexes = function getHiddenIndexes() {
    if (cols > 0) {
      return;
    }

    if (containerRef.current) {
      var _containerRef$current = containerRef.current,
          clientWidth = _containerRef$current.clientWidth,
          scrollLeft = _containerRef$current.scrollLeft,
          containerOffsetLeft = _containerRef$current.offsetLeft;
      var indexes = refsArray.current.filter(Boolean).map(function (_ref) {
        var offsetLeft = _ref.offsetLeft,
            offsetWidth = _ref.offsetWidth;
        return offsetLeft < scrollLeft + containerOffsetLeft || offsetLeft + offsetWidth > scrollLeft + containerOffsetLeft + clientWidth;
      });
      setHiddenIndexes(indexes);
    }
  };

  var getReachedX = function getReachedX() {
    if (containerRef.current) {
      var _containerRef$current2 = containerRef.current,
          clientWidth = _containerRef$current2.clientWidth,
          scrollLeft = _containerRef$current2.scrollLeft,
          scrollWidth = _containerRef$current2.scrollWidth;

      var _hasReachedLeft = scrollLeft === 0;

      var _hasReachedRight = scrollLeft + clientWidth >= scrollWidth;

      setReachedX({
        hasReachedLeft: _hasReachedLeft,
        hasReachedRight: _hasReachedRight
      });
    }
  }; // get index in possible range


  var getSafeIndex = function getSafeIndex(idx) {
    if (idx < 0) {
      return 0;
    }

    var maxIndex = cols > 0 ? childrenCount - cols : childrenCount - 1;
    return idx > maxIndex ? maxIndex : idx;
  };

  var scrollToIndex = function scrollToIndex(index, e) {
    var _containerRef$current3;

    if (e) {
      e.preventDefault();
    }

    var idx = getSafeIndex(index);
    var scrollValue = refsArray.current.slice(0, idx).reduce(function (v, ref) {
      // $FlowFixMe
      return v + ref.offsetWidth;
    }, 0);

    if ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.scrollTo) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollValue
      });
    }
  };

  Object(react["useEffect"])(function () {
    getReachedX();
    getHiddenIndexes();
    scrollToIndex(initialIndex);
    setPrevInitialIndex(initialIndex);
  }, [children]);
  Object(react["useEffect"])(function () {
    if (initialIndex !== prevInitialIndex) {
      scrollToIndex(initialIndex);
      setPrevInitialIndex(initialIndex);
    }
  }, [initialIndex]);

  if (!childrenCount) {
    return null;
  }

  var onScroll = throttle_default()(function () {
    getReachedX();
    getHiddenIndexes(); // $FlowFixMe

    var _containerRef$current4 = containerRef.current,
        offsetLeft = _containerRef$current4.offsetLeft,
        scrollLeft = _containerRef$current4.scrollLeft;
    var positions = refsArray.current.filter(Boolean).map(function (ref) {
      return ref.offsetLeft;
    });
    var closest = positions.reduce(function (prev, curr) {
      return Math.abs(curr - scrollLeft) < Math.abs(prev - scrollLeft) ? curr : prev;
    }, offsetLeft);
    var pos = positions.indexOf(closest);

    if (activeIndex > pos) {
      onPrevious && onPrevious();
    } else if (activeIndex < pos) {
      onNext && onNext();
    }

    if (pos > -1) {
      setActiveIndex(pos);
      var el = refsArray.current[pos]; // $FlowFixMe

      var elFocused = hasTabindex ? el : el.firstChild; // $FlowFixMe

      elFocused.focus({
        preventScroll: true
      });
    }
  }, 250);

  var _themes$theme = themes[theme]({
    navPosition: navPosition
  }),
      thControl = _themes$theme.thControl,
      thControlLeft = _themes$theme.thControlLeft,
      thControlRight = _themes$theme.thControlRight,
      thControlColor = _themes$theme.thControlColor,
      thControlDisabled = _themes$theme.thControlDisabled,
      thControls = _themes$theme.thControls,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;

  var hasReachedLeft = reachedX.hasReachedLeft,
      hasReachedRight = reachedX.hasReachedRight;
  var isSnapScrollDisabled = isRTL && Object(feature_testing["a" /* hasTouch */])();
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, 'relative', {
      '-scale-x-1 transform': isRTL
    }, className),
    dir: "ltr",
    id: id
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('h-full', thInner)
  }, __jsx("div", {
    className: scrollAreaClassName
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full flex-row flex-nowrap', scrollAreaContainerClassName),
    onScroll: onScroll,
    ref: containerRef
  }, react["Children"].map(children, function (child, idx) {
    var _classnames;

    var isHidden = cols > 0 ? idx < activeIndex || idx >= activeIndex + cols : hiddenIndexes[idx];
    return __jsx("div", Object(esm_extends["a" /* default */])({
      "aria-hidden": isHidden,
      className: Object(classnames_utils["a" /* classnames */])(isFunction_default()(scrollItemClassName) ? scrollItemClassName(idx) : scrollItemClassName, (_classnames = {
        'snap-start': !isSnapScrollDisabled
      }, Object(defineProperty["a" /* default */])(_classnames, "w-1/".concat(cols), cols > 1), Object(defineProperty["a" /* default */])(_classnames, 'w-full', cols === 1), Object(defineProperty["a" /* default */])(_classnames, '-scale-x-1 transform', isRTL), _classnames)),
      key: idx,
      ref: function ref(_ref2) {
        refsArray.current[idx] = _ref2;
      }
    }, hasTabindex ? {
      tabIndex: -1
    } : null, {
      style: scrollItemStyle
    }), /*#__PURE__*/Object(react["cloneElement"])(child, {
      dir: isRTL ? 'rtl' : 'ltr'
    }));
  })))), hasControls && !(hasReachedLeft && hasReachedRight) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(scrollControlsClassName, thControls)
  }, __jsx(ArrowButton["a" /* ArrowButton */], {
    className: Object(classnames_utils["a" /* classnames */])(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedLeft)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedLeft,
    label: previousLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex - nbItemsToScroll, e);
    }
  }), __jsx(ArrowButton["a" /* ArrowButton */], {
    className: Object(classnames_utils["a" /* classnames */])(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedRight)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedRight,
    label: nextLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex + nbItemsToScroll, e);
    },
    rotation: 180
  })));
}

/***/ }),

/***/ "ZKlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TabHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.themes.js




var themes = {
  "default": function _default(_ref) {
    var _classnames;

    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$color,
        isAccordion = _ref.isAccordion,
        isActive = _ref.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex font-bold font-sans gap-5 items-center px-20 py-10 rounded-pill text-16 text-black transition-colors duration-250 ease-in whitespace-nowrap', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "border-1 border-".concat(color), isAccordion), Object(defineProperty["a" /* default */])(_classnames, "bg-white hocus:bg-".concat(color, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), !isActive), Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(color, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), isActive), _classnames)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  simple: function simple(_ref2) {
    var _classnames2;

    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref2$color,
        isActive = _ref2.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 flex font-bold font-sans gap-5 items-center p-10 rounded-12 text-12 text-center transition-colors duration-250 ease-in uppercase', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "bg-white hocus:bg-".concat(color, " border-lightGrey hocus:border-").concat(color, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), !isActive), Object(defineProperty["a" /* default */])(_classnames2, "arrow-down arrow-".concat(color, " bg-").concat(color, " border-").concat(color, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), isActive), _classnames2)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  underlined: function underlined(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref3$color,
        isActive = _ref3.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-b-2 border-current flex font-bold gap-5 h-full items-center overflow-hidden shrink-0 text-16', Object(defineProperty["a" /* default */])({
        'text-mediumGrey': !isActive
      }, "text-".concat(color), isActive)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  rounded: function rounded(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref4$color,
        isActive = _ref4.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 border-lightGrey flex gap-5 items-center overflow-hidden rounded-t-12', Object(defineProperty["a" /* default */])({
        'bg-pearl': !isActive
      }, "arrow-down-top arrow-".concat(color, " bg-white border-b-0"), isActive)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  flat: function flat(_ref5) {
    var isActive = _ref5.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 flex h-full items-center p-10 md:px-20 rounded-2 transition-colors duration-250 ease-in', {
        'bg-pearl': !isActive,
        'bg-white border-b-0': isActive
      }),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






// $FlowFixMe
var TabHeader = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      controlsId = props.controlsId,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'tab-header' : _props$dataTestId,
      iconName = props.iconName,
      id = props.id,
      isAccordion = props.isAccordion,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      _onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      role = props.role,
      style = props.style,
      tabIndex = props.tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData;
  var tracker = Object(useTracking["a" /* useTracking */])();
  var track = !isActive && trackingData ? function () {
    return tracker(trackingData);
  } : noop_default.a;

  var _themes$theme = themes[theme](props),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot;

  var aria = _objectSpread(_objectSpread({}, controlsId ? {
    'aria-controls': controlsId
  } : null), isAccordion ? {
    'aria-expanded': isActive
  } : {
    'aria-selected': isActive
  });

  return __jsx("button", Object(esm_extends["a" /* default */])({}, aria, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-cs-override-id": "TabHeader" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
    ,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: function onClick() {
      _onClick && _onClick();
      track();
    },
    onKeyDown: onKeyDown,
    id: id,
    ref: ref,
    role: role,
    style: style,
    tabIndex: tabIndex,
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconWidth
  }), children);
});

/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].L : _props$ratioKey,
      url = props.url;

  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* isVideoUrl */ "b"])(url)) {
    return null;
  }

  return __jsx(_image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].VALUES[ratioKey],
    className: className
  }, __jsx(react_lazyload__WEBPACK_IMPORTED_MODULE_2___default.a, {
    className: "bg-no-repeat bg-center bg-cover leading-0 flex h-full items-center justify-center overflow-hidden rounded-12",
    once: true,
    offset: 100
  }, __jsx("iframe", {
    loading: "lazy",
    title: "Video iframe",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])(iFrameClassName, 'border-0 animate-fadeIn animation-duration-500 h-[54vw] w-[96vw] max-h-full lazy'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* getVideoUrl */ "a"])(url),
    allowFullScreen: true
  })));
}

/***/ }),

/***/ "bbEf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Columns_Columns; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// CONCATENATED MODULE: ./src/client/components/utils/layout/layout.utils.js


function getCols(number, arr) {
  var a = Array(number).fill().map(function () {
    return [];
  });

  for (var i = 0; i < arr.length; i++) {
    a[i % number].push(arr[i]);
  }

  return a;
}
// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// CONCATENATED MODULE: ./src/client/components/frameworks/columns/Columns.jsx


var __jsx = react_default.a.createElement;



var Columns_Columns = function Columns(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$colsNumber = _ref.colsNumber,
      colsNumber = _ref$colsNumber === void 0 ? 2 : _ref$colsNumber;
  var childrenArray = react["Children"].toArray(children);
  var l = childrenArray.filter(Boolean).length;

  if (!l) {
    return null;
  }

  if (colsNumber === 1) {
    return children;
  }

  var cols = getCols(colsNumber, childrenArray);
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('-mx-10 flex flex-wrap', className)
  }, cols.map(function (col, i) {
    return __jsx("div", {
      className: "px-10 w-1/".concat(colsNumber),
      key: i
    }, col);
  }));
};

/***/ }),

/***/ "djlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateSchedule; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var DateSchedule = function DateSchedule(_ref) {
  var date = _ref.date;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_1___default()(date);
  return __jsx("div", {
    className: "text-center"
  }, __jsx("div", null, momentDate.format('MMM').toUpperCase()), __jsx("div", {
    className: "text-14"
  }, momentDate.format('dd').toUpperCase()), __jsx("div", null, momentDate.format('DD')));
};

/***/ }),

/***/ "h3D+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Multimedia; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flattenDeep.js
var flattenDeep = __webpack_require__("cdI6");
var flattenDeep_default = /*#__PURE__*/__webpack_require__.n(flattenDeep);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/medias/medias.js
var medias_medias = __webpack_require__("SyAd");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.themes.js

var ActionButtonsGroup_themes_themes = function themes(_ref) {
  var isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      reverseLabelAndNumber = _ref.reverseLabelAndNumber;
  return {
    "default": {
      thRoot: 'flex flex-wrap -m-1',
      thButton: 'cursor-pointer bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
      thButtonActive: 'cursor-default bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 pointer-events-none p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
      thIcon: '',
      thIconLgSize: '3.25rem',
      thIconSize: '1.625rem',
      thText: 'text-initial',
      thNumber: 'block leading-1'
    },
    overlay: {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex gap-10', {
        'mt-auto flex-wrap justify-center': !isScrollable,
        'mt-auto overflow-x-scroll sm:overflow-hidden': isScrollable
      }),
      thButton: 'bg-white hocus:bg-white-active capitalize cursor-pointer flex font-bold gap-5 items-center justify-center px-20 py-10 rounded-pill text-12 text-black hocus:text-black-active duration-250 ease-in transition-all',
      thButtonActive: 'cursor-default bg-black/60 capitalize flex font-bold gap-5 items-center justify-center px-20 py-10 pointer-events-none rounded-pill text-12 text-white duration-250 ease-in transition-all',
      thIcon: 'shrink-0 overflow-visible',
      thIconLgSize: '3rem',
      thIconSize: '1.5rem',
      thText: "flex ".concat(reverseLabelAndNumber ? 'flex-row-reverse ' : '', " font-bold justify-between w-full text-initial"),
      thNumber: 'ps-5'
    },
    overlayCompact: {
      thRoot: Object(classnames_utils["a" /* classnames */])('lg:hidden', {
        'mt-auto flex flex-wrap justify-center rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active': !isScrollable,
        'mt-auto flex overflow-x-scroll rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active sm:overflow-hidden': isScrollable
      }),
      thButton: 'text-inherit leading-none mx-5',
      thButtonActive: 'text-inherit leading-none',
      thIcon: 'shrink-0 overflow-visible align-middle',
      thIconLgSize: '3rem',
      thIconSize: '1rem',
      thText: '',
      thHideLabel: true,
      thOverrideMinWidth: true,
      thNumber: ''
    },
    accommodation: {
      thRoot: "divide-y md:divide-x flex flex-col md:flex-row h-full justify-center overflow-hidden border-1 border-t-0 border-".concat(isExclusiveCollection ? 'ultramarine' : 'lightGrey', " rounded-b-12 w-full"),
      thButton: 'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
      thButtonActive: 'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
      thIcon: "overflow-visible text-".concat(isExclusiveCollection ? 'ultramarine' : 'black'),
      thIconLgSize: '4rem',
      thIconSize: '2rem',
      thText: 'font-bold text-initial text-black duration-250 ease-in transition-all',
      thNumber: 'ps-5'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.jsx


var __jsx = react_default.a.createElement;





var ActionButtonsGroup_ActionButtonsGroup = function ActionButtonsGroup(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$minWidth = _ref.minWidth,
      minWidthProp = _ref$minWidth === void 0 ? 'initial' : _ref$minWidth,
      _ref$reverseLabelAndN = _ref.reverseLabelAndNumber,
      reverseLabelAndNumber = _ref$reverseLabelAndN === void 0 ? true : _ref$reverseLabelAndN,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var track = Object(useTracking["a" /* useTracking */])();

  if (!items.length) {
    return null;
  }

  var _themes$theme = ActionButtonsGroup_themes_themes({
    isExclusiveCollection: isExclusiveCollection,
    isScrollable: isScrollable,
    reverseLabelAndNumber: reverseLabelAndNumber
  })[theme],
      thRoot = _themes$theme.thRoot,
      thButton = _themes$theme.thButton,
      thButtonActive = _themes$theme.thButtonActive,
      thIcon = _themes$theme.thIcon,
      thIconLgSize = _themes$theme.thIconLgSize,
      thIconSize = _themes$theme.thIconSize,
      thText = _themes$theme.thText,
      thHideLabel = _themes$theme.thHideLabel,
      thOverrideMinWidth = _themes$theme.thOverrideMinWidth,
      thNumber = _themes$theme.thNumber;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, items.map(function (_ref2) {
    var ariaLabel = _ref2.ariaLabel,
        buttonClassName = _ref2.buttonClassName,
        dataTestId = _ref2.dataTestId,
        iconIsNotSquare = _ref2.iconIsNotSquare,
        iconName = _ref2.iconName,
        id = _ref2.id,
        isActive = _ref2.isActive,
        label = _ref2.label,
        minWidth = _ref2.minWidth,
        number = _ref2.number,
        _onClick = _ref2.onClick,
        trackingData = _ref2.trackingData;
    return __jsx("button", {
      "aria-disabled": isActive,
      "aria-label": ariaLabel,
      className: Object(classnames_utils["a" /* classnames */])(buttonClassName, Object(defineProperty["a" /* default */])({}, thButtonActive, isActive), Object(defineProperty["a" /* default */])({}, thButton, !isActive)),
      "data-testid": dataTestId,
      key: "ActionButtonsGroup-".concat(id),
      onClick: function onClick() {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        trackingData && track(trackingData);
      },
      style: {
        minWidth: thOverrideMinWidth ? 'initial' : minWidth || minWidthProp
      },
      type: "button"
    }, iconName && __jsx(Icon["a" /* Icon */], {
      className: thIcon,
      isNotSquare: iconIsNotSquare,
      name: iconName,
      width: iconIsNotSquare ? thIconLgSize : thIconSize
    }), label && !thHideLabel && __jsx("span", {
      className: thText
    }, number && __jsx("span", {
      className: thNumber
    }, "".concat(number, " ")), label));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/zoom/Zoom.jsx
var Zoom = __webpack_require__("7x6O");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx + 1 modules
var ProgressBar = __webpack_require__("woxT");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// CONCATENATED MODULE: ./src/client/components/frameworks/carousel/Carousel.jsx

var Carousel_jsx = react_default.a.createElement;






var Carousel_Carousel = function Carousel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      _ref$initialIndex = _ref.initialIndex,
      initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;
  var childrenCount = react["Children"].toArray(children).filter(Boolean).length;

  if (!childrenCount) {
    return null;
  }

  return Carousel_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate overflow-hidden', className)
  }, Carousel_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "h-full w-full",
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    initialIndex: initialIndex,
    items: children
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        index = _ref2.index,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return Carousel_jsx("div", {
      className: "relative isolate flex w-full flex-1 pb-20"
    }, itemsNode, hasControls && Carousel_jsx("div", {
      className: "fap-10 pointer-events-none absolute inset-0 m-auto flex w-full items-center justify-between px-20"
    }, !isPreviousControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto z-1 me-auto shadow-sm",
      color: colors["a" /* COLORS */].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto z-1 ms-auto shadow-sm",
      color: colors["a" /* COLORS */].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasControls && Carousel_jsx("div", {
      className: "absolute bottom-0 left-0 w-full"
    }, Carousel_jsx(ProgressBar["a" /* ProgressBar */], {
      color: colors["a" /* COLORS */].WHITE,
      max: childrenCount,
      min: 1,
      value: index + 1
    })));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// CONCATENATED MODULE: ./src/client/components/utils/youku-api/index.js






function getVideoThumbnailUrl(videoId) {
  var clientId = config_default.a.get('youku.clientId');

  if (!clientId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku client Id'));
  }

  if (!videoId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku video Id'));
  }

  return axios_default.a.get("https://api.youku.com/videos/show.json?client_id=".concat(clientId, "&video_id=").concat(videoId)).then(function (response) {
    return response.data.bigThumbnail || response.data.thumbnail || new errors["d" /* NotFoundError */]('Youku video not found');
  })["catch"](function () {
    return null;
  });
}
// CONCATENATED MODULE: ./src/client/components/frameworks/image/YoukuThumbnail.jsx











var YoukuThumbnail_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var YoukuThumbnail_YoukuThumbnail = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(YoukuThumbnail, _Component);

  var _super = _createSuper(YoukuThumbnail);

  function YoukuThumbnail(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, YoukuThumbnail);

    _this = _super.call(this, props);
    _this.state = {
      thumbnailUrl: null
    };
    return _this;
  }

  Object(createClass["a" /* default */])(YoukuThumbnail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var youkuRegEx = new RegExp('https://vthumb.ykimg.com/([a-zA-Z0-9]+)');
      var urlMatch = youkuRegEx.exec(this.props.imageUrl);

      if (urlMatch && urlMatch[1]) {
        getVideoThumbnailUrl(urlMatch[1]).then(function (youkuThumbnail) {
          _this2.setState({
            thumbnailUrl: youkuThumbnail
          });
        }).catch(function () {
          return null;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var thumbnailUrl = this.state.thumbnailUrl;
      return YoukuThumbnail_jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({}, this.props, {
        imageUrl: thumbnailUrl
      }));
    }
  }]);

  return YoukuThumbnail;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// CONCATENATED MODULE: ./src/client/components/frameworks/media-thumbnail/MediaThumbnail.jsx

var MediaThumbnail_jsx = react_default.a.createElement;






var MediaThumbnail_MediaThumbnail = function MediaThumbnail(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className,
      hasLazyLoading = _ref.hasLazyLoading,
      iconName = _ref.iconName,
      _onClick = _ref.onClick,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["c" /* default */].M : _ref$ratio,
      src = _ref.src,
      trackingData = _ref.trackingData,
      ratioDisplay = _ref.ratioDisplay;
  var hasChildren = !!react["Children"].count(children);
  var track = Object(useTracking["a" /* useTracking */])(trackingData);

  if (!hasChildren && isEmpty_default()(src)) {
    return null;
  }

  return MediaThumbnail_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('relative block h-full w-full overflow-hidden bg-white transition-opacity duration-250 ease-in hover:opacity-75', className),
    onClick: function onClick() {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
      trackingData && track();
    },
    type: "button"
  }, hasChildren ? children : MediaThumbnail_jsx(Image["b" /* default */], {
    altMsg: alt,
    hasLazyLoading: hasLazyLoading,
    imageUrl: src,
    ratioKey: ratio,
    ratioDisplay: ratioDisplay
  }), !!iconName && MediaThumbnail_jsx("div", {
    className: "absolute end-0 top-0 m-5 size-50 bg-black/60 p-10 leading-0 text-white"
  }, MediaThumbnail_jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: "100%"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/multimedia-launcher/MultimediaLauncher.jsx





var MultimediaLauncher_jsx = react_default.a.createElement;









var YOUKU_SRC = 'vthumb.ykimg.com';

function MultimediaLauncherThumbnail(props) {
  return props.src ? MultimediaLauncher_jsx(MediaThumbnail_MediaThumbnail, Object(esm_extends["a" /* default */])({}, props, {
    hasLazyLoading: props.hasLazyLoading
  }), props.src.includes(YOUKU_SRC) ? MultimediaLauncher_jsx(YoukuThumbnail_YoukuThumbnail, {
    imageUrl: props.src,
    ratioKey: props.ratio
  }) : null) : null;
}

function MultimediaLauncher(_ref) {
  var buttons = _ref.buttons,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isImageSlideShow = _ref.isImageSlideShow,
      isOverlay = _ref.isOverlay,
      _ref$medias = _ref.medias,
      medias = _ref$medias === void 0 ? [] : _ref$medias,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      theme = _ref.theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var defaultTheme = isOverlay ? 'overlay' : 'default';
  var computedTheme = theme || defaultTheme;
  return MultimediaLauncher_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-full overflow-hidden', {
      'rounded-12': computedTheme === 'default'
    }, className)
  }, !isOverlay && !isImageSlideShow && (isTablet ? MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 -m-1 flex animate-fadeIn border-b-1 border-transparent"
  }, MultimediaLauncher_jsx("div", {
    className: "w-1/2 p-1"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading,
    ratioDisplay: 1 / 2
  }))), MultimediaLauncher_jsx("div", {
    className: "flex w-1/2 flex-wrap"
  }, medias.slice(1, 5).map(function (media) {
    return MultimediaLauncher_jsx("div", {
      className: "w-1/2 p-1",
      key: "MultimediaLauncherThumbnail-".concat(media.src)
    }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, media, {
      hasLazyLoading: hasLazyLoading,
      ratioDisplay: 1 / 4
    })));
  }))) : MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 animate-fadeIn border-b-2 border-transparent"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading
  })))), !isOverlay && isImageSlideShow && MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 animate-fadeIn"
  }, medias.length > 0 ? MultimediaLauncher_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    className: className,
    closeLabel: closeLabel,
    galleryLabel: galleryLabel,
    hasInfiniteScroll: true,
    hasLazyLoading: false,
    media: medias.map(function (_ref2) {
      var alt = _ref2.alt,
          onClick = _ref2.onClick,
          src = _ref2.src;
      return {
        alt: alt,
        onClick: onClick,
        src: src
      };
    }),
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["c" /* default */].XL
  }) : MultimediaLauncher_jsx(Image["b" /* default */], {
    altMsg: medias[0].alt,
    hasLazyLoading: false,
    imageUrl: medias[0].src,
    ratioKey: ratios_utils["c" /* default */].XL
  })), MultimediaLauncher_jsx(ActionButtonsGroup_ActionButtonsGroup, {
    className: "animation-duration-500 animate-fadeIn",
    isExclusiveCollection: isExclusiveCollection,
    items: buttons,
    minWidth: isOverlay ? '6.25rem' : '8.4375rem',
    theme: computedTheme
  }));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/map/StreetView.jsx
var StreetView = __webpack_require__("HKmi");

// CONCATENATED MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx


























var Multimedia_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Multimedia_createSuper(Derived) { var hasNativeReflectConstruct = Multimedia_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Multimedia_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }















var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};

var Multimedia_Multimedia = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_Multimedia, _Component);

  var _super = Multimedia_createSuper(_Multimedia);

  function _Multimedia(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _Multimedia);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeCarousel", function () {
      _this.setState({
        activeMedias: '',
        carouselIndex:  false || _this.props.initialIndex
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showCarousel", function (type) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _this.setState({
        activeMedias: type,
        carouselIndex: index
      });
    });

    _this.state = {
      activeMedias: '',
      carouselIndex: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_Multimedia, [{
    key: "getCarouselItem",

    /* Carousel */
    // eslint-disable-next-line max-params, class-methods-use-this, clubmed/no-fake-component
    value: function getCarouselItem(type, _ref, altMsg, isDesktop) {
      var fov = _ref.fov,
          heading = _ref.heading,
          latitude = _ref.latitude,
          longitude = _ref.longitude,
          url = _ref.url;

      switch (type) {
        case medias_medias["b" /* MEDIA_TYPES */].PHOTOS:
          return Multimedia_jsx("div", {
            "data-testid": "MultimediaPhoto",
            className: "relative flex h-full w-full max-w-full flex-1 items-center justify-center overflow-hidden"
          }, Multimedia_jsx(Image["a" /* Image */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 max-w-[2000px] transform -translate-x-1/2 -translate-y-1/2",
            hasLazyLoading: false,
            key: "CarouselItem-".concat(type, "-").concat(url),
            imageUrl: url,
            dimensions: DIMENSIONS,
            fullscreen: true,
            transformation: "resize"
          }));

        case medias_medias["b" /* MEDIA_TYPES */].STREETVIEWS:
          if (url === null || url === void 0 ? void 0 : url.includes('matterport')) {
            return Multimedia_jsx("iframe", {
              title: "matterport iframe",
              width: "100%",
              height: "100%",
              src: "".concat(url, "&play=1"),
              frameBorder: "0",
              id: "matterport-iframe"
            });
          }

          return Multimedia_jsx(StreetView["a" /* StreetView */], {
            fov: fov,
            heading: heading,
            key: "CarouselItem-".concat(type, "-").concat(latitude, "-").concat(longitude),
            latitude: latitude,
            longitude: longitude
          });

        case medias_medias["b" /* MEDIA_TYPES */].FLOORPLAN:
          return isDesktop ? Multimedia_jsx("div", {
            className: "h-full pt-20"
          }, Multimedia_jsx("div", {
            "data-testid": "MultimediaFloorplan",
            className: "relative flex h-full w-full max-w-full flex-1 items-center justify-center overflow-hidden"
          }, Multimedia_jsx(Image["a" /* Image */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 max-w-[2000px] transform -translate-x-1/2 -translate-y-1/2",
            hasLazyLoading: false,
            key: "CarouselItem-".concat(type, "-").concat(url),
            imageUrl: url,
            dimensions: DIMENSIONS,
            fullscreen: true,
            transformation: "resize"
          }))) : Multimedia_jsx("div", {
            className: "flex h-full max-w-screen flex-col justify-center"
          }, Multimedia_jsx(Zoom["a" /* Zoom */], {
            imageUrl: url,
            altMsg: "Floor plan",
            inert: true
          }));

        case medias_medias["b" /* MEDIA_TYPES */].VIDEOS:
        case medias_medias["b" /* MEDIA_TYPES */].VIDEOS360:
          return Multimedia_jsx(Video["a" /* Video */], {
            className: "static m-auto flex h-full flex-1 items-center justify-center overflow-hidden md:w-4/5 md:max-w-4/5",
            key: "CarouselItem-".concat(type, "-").concat(url),
            url: url
          });

        default:
          return null;
      }
    }
  }, {
    key: "getCarouselItems",
    value: function getCarouselItems(type, isDesktop) {
      var _this2 = this;

      var _this$props = this.props,
          medias = _this$props.medias,
          _this$props$pictureAl = _this$props.pictureAltLabel,
          pictureAltLabel = _this$props$pictureAl === void 0 ? '' : _this$props$pictureAl;
      return (medias[type] || []).map(function (media, idx) {
        var altMsg = (media === null || media === void 0 ? void 0 : media.alt) || Object(dist["messageFormat"])(pictureAltLabel).format({
          nb: idx + 1,
          total: medias[type].length
        });

        var carouselItem = _this2.getCarouselItem(type, media, altMsg, isDesktop);

        return Multimedia_jsx(react["Fragment"], {
          key: "CarouselItemWrapper-".concat(type, "-").concat(media.url)
        }, carouselItem);
      });
    }
    /* Medias */

  }, {
    key: "hasMedias",
    value: function hasMedias(isDesktop) {
      var _this3 = this;

      return Object.keys(this.props.medias).reduce(function (has, type) {
        return has || _this3.hasTypeMedias(type, isDesktop);
      }, false);
    }
  }, {
    key: "hasTypeMedias",
    value: function hasTypeMedias(type, isDesktop) {
      var hasTypeMedias = Array.isArray(get_default()(this.props, ['medias', type])) && get_default()(this.props, ['medias', type]).length > 0;

      if (type === medias_medias["b" /* MEDIA_TYPES */].VIDEOS360) {
        return hasTypeMedias && isDesktop;
      }

      return hasTypeMedias;
    }
  }, {
    key: "mapLauncherMedias",
    value: function mapLauncherMedias(type, isDesktop) {
      var _this4 = this;

      var medias = this.hasTypeMedias(type, isDesktop) ? this.props.medias[type] : [];
      return medias.map(function (media, index) {
        return {
          alt: Object(dist["messageFormat"])(_this4.props.launcherPictureAltLabel || '').format({
            nb: index + 1,
            mediaType: _this4.props.labels && _this4.props.labels[type]
          }),
          hasForcedImage: !!media.thumbnailUrl,
          iconName: type === medias_medias["b" /* MEDIA_TYPES */].PHOTOS ? '' : medias_medias["a" /* ICONS */][type],
          onClick: function onClick() {
            var _this4$props, _this4$props$onClickM;

            (_this4$props = _this4.props) === null || _this4$props === void 0 ? void 0 : (_this4$props$onClickM = _this4$props.onClickMediaBtn) === null || _this4$props$onClickM === void 0 ? void 0 : _this4$props$onClickM.call(_this4$props, type);

            _this4.showCarousel(type, index);
          },
          ratio: _this4.props.ratioKey,
          src: media.thumbnailUrl || media.url || media.imageLarge || ''
        };
      });
    }
  }, {
    key: "getLauncherMedias",
    value: function getLauncherMedias(isDesktop, hasImageSlideShowLauncher) {
      var _this5 = this;

      var types = hasImageSlideShowLauncher ? [medias_medias["b" /* MEDIA_TYPES */].PHOTOS] : medias_medias["e" /* ORDERED_MEDIAS_LAUNCHER */];
      return flattenDeep_default()(types.map(function (type) {
        return _this5.mapLauncherMedias(type, isDesktop);
      })).filter(function (i) {
        return !!i.src;
      });
    }
  }, {
    key: "getLauncherProps",
    value: function getLauncherProps(isDesktop) {
      var _this6 = this;

      var _this$props2 = this.props,
          _this$props2$hasImage = _this$props2.hasImageSlideShowLauncher,
          hasImageSlideShowLauncher = _this$props2$hasImage === void 0 ? false : _this$props2$hasImage,
          _this$props2$hasFullS = _this$props2.hasFullScreenButton,
          hasFullScreenButton = _this$props2$hasFullS === void 0 ? false : _this$props2$hasFullS,
          _this$props2$labels = _this$props2.labels,
          labels = _this$props2$labels === void 0 ? {} : _this$props2$labels,
          _this$props2$medias = _this$props2.medias,
          medias = _this$props2$medias === void 0 ? {} : _this$props2$medias,
          openGalleryLabel = _this$props2.openGalleryLabel,
          initialIndex = _this$props2.initialIndex;
      var hasPhotosTypeMedias = this.hasTypeMedias(medias_medias["b" /* MEDIA_TYPES */].PHOTOS, isDesktop);

      var getIndexToOpenTo = function getIndexToOpenTo(type, index) {
        if (type !== medias_medias["b" /* MEDIA_TYPES */].PHOTOS) {
          return index;
        }

        return initialIndex || index;
      };

      var getButton = function getButton(type, index) {
        var numberOfItems = Array.isArray(medias === null || medias === void 0 ? void 0 : medias[type]) && type !== medias_medias["b" /* MEDIA_TYPES */].FLOORPLAN ? medias[type].length : null;
        return {
          ariaLabel: openGalleryLabel ? "".concat(labels[type], " (").concat(get_default()(medias, [type], []).length, ") - ").concat(openGalleryLabel) : null,
          dataTestId: "Multimedia-".concat(type, "-button"),
          iconIsNotSquare: type === medias_medias["b" /* MEDIA_TYPES */].STREETVIEWS,
          iconName: medias_medias["a" /* ICONS */][type],
          id: type,
          isActive: type === _this6.state.activeMedias,
          label: labels[type],
          number: numberOfItems,
          onClick: function onClick() {
            var _this6$props, _this6$props$onClickM;

            (_this6$props = _this6.props) === null || _this6$props === void 0 ? void 0 : (_this6$props$onClickM = _this6$props.onClickMediaBtn) === null || _this6$props$onClickM === void 0 ? void 0 : _this6$props$onClickM.call(_this6$props, type);

            _this6.showCarousel(type, getIndexToOpenTo(type, index));
          }
        };
      };

      var buttons = medias_medias["d" /* ORDERED_MEDIAS */].map(function (type, index) {
        var internalIndex = type === medias_medias["b" /* MEDIA_TYPES */].PHOTOS ? index : 0;
        return _this6.hasTypeMedias(type, isDesktop) ? getButton(type, internalIndex) : null;
      }).filter(Boolean);
      var extraButtons = [hasFullScreenButton ? _objectSpread(_objectSpread({}, getButton(medias_medias["b" /* MEDIA_TYPES */].PHOTOS)), {}, {
        iconName: icons["a" /* ICONS */].EXPAND,
        label: '',
        minWidth: 'initial',
        buttonClassName: 'absolute end-0 md:bottom-0 md:top-auto top-0 mt-10 md:mx-10 md:mx-20 mb-0'
      }) : null].filter(Boolean);
      return {
        buttons: buttons,
        extraButtons: extraButtons,
        medias: hasImageSlideShowLauncher && hasPhotosTypeMedias ? this.getLauncherMedias(isDesktop, hasImageSlideShowLauncher) // $FlowFixMe
        : this.getLauncherMedias(isDesktop).slice(0, 5)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return Multimedia_jsx(ResponsiveContext["a" /* ResponsiveContext */].Consumer, null, function (_ref2) {
        var isDesktop = _ref2.isDesktop;

        if (!_this7.hasMedias(isDesktop)) {
          return null;
        }

        var _this7$state = _this7.state,
            activeMedias = _this7$state.activeMedias,
            carouselIndex = _this7$state.carouselIndex;
        var _this7$props = _this7.props,
            className = _this7$props.className,
            closeLabel = _this7$props.closeLabel,
            descriptionLabels = _this7$props.descriptionLabels,
            galleryLabel = _this7$props.galleryLabel,
            hasImageSlideShowLauncher = _this7$props.hasImageSlideShowLauncher,
            isExclusiveCollection = _this7$props.isExclusiveCollection,
            isOverlay = _this7$props.isOverlay,
            nextLabel = _this7$props.nextLabel,
            portalName = _this7$props.portalName,
            previousLabel = _this7$props.previousLabel,
            theme = _this7$props.theme; // $FlowFixMe

        var descriptionLabel = descriptionLabels === null || descriptionLabels === void 0 ? void 0 : descriptionLabels[activeMedias];

        var items = _this7.getCarouselItems(activeMedias, isDesktop);

        var launcherProps = _this7.getLauncherProps(isDesktop);

        return Multimedia_jsx(react["Fragment"], null, Multimedia_jsx(MultimediaLauncher, {
          buttons: [].concat(Object(toConsumableArray["a" /* default */])(launcherProps.buttons), Object(toConsumableArray["a" /* default */])(launcherProps.extraButtons)),
          className: className,
          closeLabel: closeLabel,
          galleryLabel: galleryLabel,
          isExclusiveCollection: isExclusiveCollection,
          hasLazyLoading: true,
          isImageSlideShow: hasImageSlideShowLauncher,
          isOverlay: isOverlay,
          medias: launcherProps.medias,
          nextLabel: nextLabel,
          previousLabel: previousLabel,
          theme: theme
        }), !!activeMedias && Multimedia_jsx(Backdrop["a" /* Backdrop */], {
          ariaLabel: galleryLabel,
          className: "backdrop-blur-[4px] backdrop-saturate-0",
          closeLabel: closeLabel,
          hasCloseButton: true,
          onClose: _this7.closeCarousel,
          portalName: portalName
        }, Multimedia_jsx("div", {
          className: "flex h-full w-full flex-col"
        }, Multimedia_jsx(Carousel_Carousel, {
          className: "flex flex-1",
          hasInfiniteScroll: true,
          initialIndex: carouselIndex,
          key: Math.random(),
          nextLabel: nextLabel,
          previousLabel: previousLabel
        }, items), descriptionLabel && Multimedia_jsx("div", {
          className: "flex w-full justify-center p-20 py-10"
        }, Multimedia_jsx("span", {
          className: "text-center text-12 text-white"
        }, descriptionLabel)), Multimedia_jsx("div", {
          className: "flex h-[72px] items-center justify-center px-10"
        }, Multimedia_jsx(ActionButtonsGroup_ActionButtonsGroup, {
          isScrollable: true,
          items: launcherProps.buttons,
          minWidth: "6.25rem",
          reverseLabelAndNumber: theme !== 'accommodation',
          theme: "overlay"
        })))));
      });
    }
  }]);

  return _Multimedia;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Multimedia_Multimedia, "defaultProps", {
  medias: {},
  ratioKey: ratios_utils["c" /* default */].L
});

var Multimedia = Multimedia_Multimedia;

/***/ }),

/***/ "jHPj":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    pullAll = __webpack_require__("DyR2");

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),

/***/ "k0YQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMAINING_STOCK_WARNING_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivityCard; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_activities_activities_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8W+g");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6jSF");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kiXb");
/* harmony import */ var _views_booking_booking_confirmation_BookingConfirmationTracking_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("s1v2");
/* harmony import */ var _frameworks_feature_card_FeatureCard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("OwO1");
/* harmony import */ var _upsell_booking_UpsellBooking__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("lOIz");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */







var REMAINING_STOCK_WARNING_THRESHOLD = 8;
var ActivityCard = function ActivityCard(_ref) {
  var _additionalService$pr;

  var activity = _ref.activity,
      bookingId = _ref.bookingId,
      className = _ref.className,
      onBook = _ref.onBook;

  var _useCartLocked = Object(_utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* useCartLocked */ "o"])(bookingId),
      isCartLocked = _useCartLocked.isCartLocked;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_5__["useState"])(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  if (!activity) {
    return null;
  }

  var additionalService = activity.additionalService,
      ageRestriction = activity.ageRestriction,
      description = activity.description,
      duration = activity.duration,
      equipments = activity.equipments,
      furtherInformation = activity.furtherInformation,
      id = activity.id,
      images = activity.images,
      isIncluded = activity.isIncluded,
      level = activity.level,
      name = activity.name,
      participants = activity.participants,
      seasonality = activity.seasonality,
      services = activity.services,
      subtitle = activity.subtitle,
      transportation = activity.transportation,
      treatments = activity.treatments,
      upsellType = activity.upsellType;
  var list = [{
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.group'),
    value: participants ? Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])(Object(_utils_activities_activities_utils__WEBPACK_IMPORTED_MODULE_6__[/* getParticpantsI18n */ "f"])(participants), {
      max: participants.max || '',
      min: participants.min || ''
    }) : null
  }, {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.age'),
    note: ageRestriction === null || ageRestriction === void 0 ? void 0 : ageRestriction.specificConditions,
    value: ageRestriction === null || ageRestriction === void 0 ? void 0 : ageRestriction.formatted
  }, {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.level'),
    value: level
  }, {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.seasonality'),
    value: seasonality
  }, {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.transportation'),
    value: transportation
  }, {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.equipments'),
    value: equipments
  }, {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.services'),
    value: services
  }, {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "h"])('common.treatmentsLabel'),
    value: treatments
  }].filter(function (l) {
    return l.value;
  });
  var schedules = (additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr = additionalService.pricingInfo) === null || _additionalService$pr === void 0 ? void 0 : _additionalService$pr.schedules) || [];
  var remainingStocksByDate = schedules.map(function (_ref2) {
    var slots = _ref2.slots;
    return {
      quantity: slots[0].remainingStock
    };
  });
  var remainingStock = remainingStocksByDate.filter(function (_ref3) {
    var quantity = _ref3.quantity;
    return quantity <= REMAINING_STOCK_WARNING_THRESHOLD;
  })[0];
  return __jsx(_upsell_booking_UpsellBooking__WEBPACK_IMPORTED_MODULE_11__[/* UpsellBooking */ "a"], {
    onBook: onBook,
    upsell: activity
  }, function (_ref4) {
    var currentPrice = _ref4.currentPrice,
        isAdded = _ref4.isAdded,
        isLoading = _ref4.isLoading,
        isUnavailable = _ref4.isUnavailable,
        onExpand = _ref4.onExpand,
        onSubmit = _ref4.onSubmit;
    return __jsx("div", {
      className: "cursor-pointer",
      onClick: function onClick() {
        setIsExpanded(!isExpanded);
        onExpand && onExpand(isExpanded);
      }
    }, __jsx(_frameworks_feature_card_FeatureCard__WEBPACK_IMPORTED_MODULE_10__[/* FeatureCard */ "a"], {
      className: className,
      description: description,
      duration: duration,
      id: id,
      images: images,
      isAdded: isAdded,
      isIncluded: isIncluded,
      isLoading: isLoading,
      isUnavailable: isUnavailable,
      isCartLocked: isCartLocked,
      list: list,
      name: name,
      note: furtherInformation,
      onBook: onSubmit,
      isExpanded: isExpanded,
      price: currentPrice,
      remainingStock: remainingStock,
      subtitle: subtitle,
      showSliderOfImages: upsellType === _views_booking_booking_confirmation_BookingConfirmationTracking_utils__WEBPACK_IMPORTED_MODULE_9__[/* upSellTypeMapping */ "f"].EXCURSION
    }));
  });
};

/***/ }),

/***/ "lOIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsellBooking; });
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3yYM");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_activities_activities_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8W+g");
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var _context_ServicesContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("2Odu");
/* harmony import */ var _utils_string_string_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tX1K");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("DqI1");
/* harmony import */ var _reservation_block_PopInReservationBlock__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("YOo2");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;












var UpsellBooking = function UpsellBooking(_ref) {
  var _additionalService$pr, _additionalService$pr2, _additionalService$pr3;

  var children = _ref.children,
      onBook = _ref.onBook,
      upsell = _ref.upsell;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(false),
      isPopinOpen = _useState[0],
      setIsPopinOpen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_4__["useContext"])(_context_ServicesContext__WEBPACK_IMPORTED_MODULE_8__[/* ServicesContext */ "a"]),
      dates = _useContext.dates,
      updateService = _useContext.updateService;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_13__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var additionalService = upsell.additionalService,
      id = upsell.id,
      openingDates = upsell.openingDates,
      price = upsell.price,
      upsellType = upsell.upsellType;
  var keyPath = Object(_utils_activities_activities_utils__WEBPACK_IMPORTED_MODULE_6__[/* getUpsellCmsKeyPath */ "g"])(additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr = additionalService.pricingInfo) === null || _additionalService$pr === void 0 ? void 0 : _additionalService$pr.type);
  var isInBookingMode = Boolean(updateService);
  var currentPrice = isInBookingMode ? additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr2 = additionalService.pricingInfo) === null || _additionalService$pr2 === void 0 ? void 0 : _additionalService$pr2.startingPricePerAdult : price;
  var isAdded = Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* isUpsellBooked */ "t"])(additionalService);
  var onSubmit = additionalService ? function () {
    setIsPopinOpen(true);
    onBook && onBook(id);
  } : null;
  var isAvailable = (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) && dates ? openingDates.some(function (_ref2) {
    var endDate = _ref2.endDate,
        startDate = _ref2.startDate;
    return moment__WEBPACK_IMPORTED_MODULE_5___default()(dates.arrivalDate).isBetween(moment__WEBPACK_IMPORTED_MODULE_5___default()(startDate), moment__WEBPACK_IMPORTED_MODULE_5___default()(endDate), 'day') || moment__WEBPACK_IMPORTED_MODULE_5___default()(dates.departureDate).isBetween(moment__WEBPACK_IMPORTED_MODULE_5___default()(startDate), moment__WEBPACK_IMPORTED_MODULE_5___default()(endDate), 'day');
  }) : true;

  var onExpand = function onExpand(isExpanded) {
    trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_12__[/* TRACK_EVENT_NAMES */ "F"].CLICK_ACTIVITIES_LAYER, {
      detail_click: isExpanded ? 'close_arrow' : 'open_arrow',
      activity_type: Object(_utils_string_string_util__WEBPACK_IMPORTED_MODULE_9__[/* camelToSnakeCase */ "b"])(upsellType),
      availability: isAvailable || null
    });
  };

  return __jsx(react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], null, children({
    currentPrice: currentPrice,
    isAdded: isAdded,
    isLoading: isLoading,
    isUnavailable: !isAvailable,
    onExpand: onExpand,
    onSubmit: onSubmit
  }), additionalService && isPopinOpen && __jsx(_reservation_block_PopInReservationBlock__WEBPACK_IMPORTED_MODULE_14__[/* PopInReservationBlock */ "a"], {
    headerLabel: (_additionalService$pr3 = additionalService.productInfo) === null || _additionalService$pr3 === void 0 ? void 0 : _additionalService$pr3.label,
    introductionLabel: keyPath ? Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])("booking.activities.".concat(keyPath, ".registration")) : '',
    onClose: function onClose() {
      return setIsPopinOpen(false);
    },
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(updatedService, serviceIds, attendeeIds) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return updateService(updatedService, additionalService.pricingInfo, serviceIds, attendeeIds, Object(_utils_string_string_util__WEBPACK_IMPORTED_MODULE_9__[/* camelToSnakeCase */ "b"])(upsellType));

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                _logger__WEBPACK_IMPORTED_MODULE_10___default.a.error(_context.t0);

              case 9:
                setIsLoading(false);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }(),
    rentButtonLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('booking.common.addPrice'),
    service: additionalService.pricingInfo
  }));
};

/***/ }),

/***/ "lW4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withOpenAndScrollToHash; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zygG");
/* harmony import */ var lodash_upperCase__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("4xcl");
/* harmony import */ var lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("RUiN");
/* harmony import */ var _tabs_util__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("GzVq");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function getWithIds(_ref) {
  var id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var mainId = id || Object(_tabs_util__WEBPACK_IMPORTED_MODULE_17__[/* getTabsMainId */ "c"])(items);
  var itemsWithIds = items.map(function (item, index) {
    var _getTabsItemIds = Object(_tabs_util__WEBPACK_IMPORTED_MODULE_17__[/* getTabsItemIds */ "b"])({
      id: item.headerId,
      index: index,
      mainId: mainId,
      title: item.header && item.header.title
    }),
        _getTabsItemIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getTabsItemIds, 2),
        headerId = _getTabsItemIds2[0],
        panelId = _getTabsItemIds2[1];

    return _objectSpread(_objectSpread({}, item), {}, {
      headerId: headerId,
      panelId: panelId
    });
  });
  return [mainId, itemsWithIds];
}
/* scroll to Tabs or Accordion item #id and open it */


function withOpenAndScrollToHash(WrappedComponent) {
  return function OpenTabAndScrollToHash(props) {
    var _useState = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])({
      initialSelectedItem: props.initialSelectedItem || 0,
      initialSelectedItems: props.initialSelectedItems || [0]
    }),
        _useState$ = _useState[0],
        initialSelectedItem = _useState$.initialSelectedItem,
        initialSelectedItems = _useState$.initialSelectedItems,
        setInitialItems = _useState[1];

    var _getWithIds = getWithIds({
      id: props.id,
      items: props.items
    }),
        _getWithIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getWithIds, 2),
        mainId = _getWithIds2[0],
        itemsWithIds = _getWithIds2[1];

    var router = Object(next_router__WEBPACK_IMPORTED_MODULE_14__["useRouter"])();
    var uri = new urijs__WEBPACK_IMPORTED_MODULE_15___default.a(router.asPath);
    var urihash = uri.hash();

    var hashChangeHandler = function hashChangeHandler(hash) {
      var ids = itemsWithIds.map(function (_ref2) {
        var _ref2$headerId = _ref2.headerId,
            headerId = _ref2$headerId === void 0 ? '' : _ref2$headerId;
        return "#".concat(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default()(headerId));
      });
      var index = ids.indexOf("#".concat(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default()(hash)));

      if (index !== -1) {
        setInitialItems({
          initialSelectedItem: index,
          initialSelectedItems: [index]
        });
        Object(_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_16__[/* scrollToElement */ "a"])("#".concat(mainId), 100);
      } else {
        setInitialItems({
          initialSelectedItem: 0,
          initialSelectedItems: [0]
        });
      }
    };

    Object(react__WEBPACK_IMPORTED_MODULE_13__["useEffect"])(function () {
      if (urihash) {
        hashChangeHandler(urihash);
      }
    }, [urihash]);
    return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({}, props, {
      id: mainId,
      initialSelectedItems: initialSelectedItems,
      initialSelectedItem: initialSelectedItem,
      setInitialItems: setInitialItems,
      items: itemsWithIds,
      key: mainId // to reinitialize state when it is new tabs, see : https://fr.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key

    }));
  };
}

/***/ }),

/***/ "r+bv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ImmersiveSlideShow_ImmersiveSlideShow; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/item/ImmersiveSlideShowItem.jsx
var __jsx = react_default.a.createElement;



var ImmersiveSlideShowItem_ImmersiveSlideShowItem = function ImmersiveSlideShowItem(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$isImmersive = _ref.isImmersive,
      isImmersive = _ref$isImmersive === void 0 ? false : _ref$isImmersive,
      src = _ref.src;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative', className),
    key: src
  }, __jsx(Hero["a" /* Hero */], {
    alt: alt,
    isImmersive: isImmersive,
    size: immersiveSize,
    url: src
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/heroUtils.js
var heroUtils = __webpack_require__("5xkM");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/controls/ImmersiveSlideShowControls.themes.js

var themes = {
  "default": {
    thRoot: 'absolute flex items-center gap-10 justify-between max-w-site px-20 lg:px-0 m-auto inset-0 pointer-events-none w-full',
    thButtonColor: colors["a" /* COLORS */].WHITE,
    thPreviousButton: 'me-auto pointer-events-auto shadow-sm z-1',
    thNextButton: 'ms-auto pointer-events-auto shadow-sm z-1',
    thPageIndicator: 'absolute left-0 bottom-0 mb-30 ml-30 inline-flex items-center overflow-hidden px-10 py-5 font-sans bg-white rounded-pill text-12'
  },
  activities: {
    thRoot: 'absolute bottom-0 flex gap-5 items-center justify-end p-20 pointer-events-none right-0 w-full z-1',
    thButtonColor: colors["a" /* COLORS */].WHITE,
    thPreviousButton: 'pointer-events-auto shadow-sm z-1',
    thNextButton: 'pointer-events-auto shadow-sm z-1',
    thPageIndicator: 'bg-white font-bold font-sans inline-flex items-end me-auto overflow-hidden px-20 py-10 rounded-pill text-14'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/controls/ImmersiveSlideShowControls.jsx
var ImmersiveSlideShowControls_jsx = react_default.a.createElement;




var ImmersiveSlideShowControls_ImmersiveSlideShowControls = function ImmersiveSlideShowControls(_ref) {
  var activeIndex = _ref.activeIndex,
      className = _ref.className,
      isNextDisabled = _ref.isNextDisabled,
      isPrevDisabled = _ref.isPrevDisabled,
      _ref$isPaginationDisa = _ref.isPaginationDisabled,
      isPaginationDisabled = _ref$isPaginationDisa === void 0 ? true : _ref$isPaginationDisa,
      nextLabel = _ref.nextLabel,
      onNext = _ref.onNext,
      onPrev = _ref.onPrev,
      previousLabel = _ref.previousLabel,
      slidesCount = _ref.slidesCount,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thButtonColor = _themes$theme.thButtonColor,
      thPreviousButton = _themes$theme.thPreviousButton,
      thNextButton = _themes$theme.thNextButton,
      thPageIndicator = _themes$theme.thPageIndicator;
  return ImmersiveSlideShowControls_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, !isPaginationDisabled && ImmersiveSlideShowControls_jsx("div", {
    className: thPageIndicator
  }, activeIndex, " of ", slidesCount), !isPrevDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: thPreviousButton,
    color: thButtonColor,
    label: previousLabel,
    onClick: onPrev
  }), !isNextDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: thNextButton,
    color: thButtonColor,
    label: nextLabel,
    onClick: onNext,
    rotation: 180
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/large/ImmersiveSlideShowLarge.jsx



var ImmersiveSlideShowLarge_jsx = react_default.a.createElement;





var getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).map(function (_, idx) {
    return idx === length - 1 || idx < 2;
  });
};

var ImmersiveSlideShowLarge_ImmersiveSlideShowLarge = function ImmersiveSlideShowLarge(_ref) {
  var className = _ref.className,
      _ref$controlsTheme = _ref.controlsTheme,
      controlsTheme = _ref$controlsTheme === void 0 ? 'default' : _ref$controlsTheme,
      _ref$isPaginationDisa = _ref.isPaginationDisabled,
      isPaginationDisabled = _ref$isPaginationDisa === void 0 ? true : _ref$isPaginationDisa,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) {
      return;
    }

    var newDisplayedIndex = displayedIndex.map(function (isDisplayed, idx) {
      return isDisplayed || idx === activeIndex + 1 || idx === activeIndex - 1;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  var increase = function increase() {
    activeIndex === items.length - 1 ? setActiveIndex(0) : setActiveIndex(activeIndex + 1);
  };

  var decrease = function decrease() {
    activeIndex === 0 ? setActiveIndex(items.length - 1) : setActiveIndex(activeIndex - 1);
  };

  var _getHeroDimensions = Object(heroUtils["e" /* getHeroDimensions */])(immersiveSize),
      heightClassName = _getHeroDimensions.heightClassName;

  return ImmersiveSlideShowLarge_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(heightClassName, 'overflow-hidden relative', className)
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowLarge_jsx("div", {
      "aria-hidden": idx !== activeIndex,
      className: Object(classnames_utils["a" /* classnames */])('absolute inset-0 duration-500 ease-in transition-opacity', {
        'opacity-100': idx === activeIndex,
        'opacity-0': idx !== activeIndex
      }),
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  }), items.length > 1 && ImmersiveSlideShowLarge_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    nextLabel: nextLabel,
    activeIndex: activeIndex + 1,
    slidesCount: items.length,
    onNext: increase,
    onPrev: decrease,
    previousLabel: previousLabel,
    isPaginationDisabled: isPaginationDisabled,
    theme: controlsTheme
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/debounce.js
var debounce = __webpack_require__("RNvQ");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/narrow/ImmersiveSlideShowNarrow.jsx




var ImmersiveSlideShowNarrow_jsx = react_default.a.createElement;




var PRELOADED_ITEMS_NB = 3;

var ImmersiveSlideShowNarrow_getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).fill(true, 0, PRELOADED_ITEMS_NB);
};

var ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow = function ImmersiveSlideShowNarrow(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$isPaginationDisa = _ref.isPaginationDisabled,
      isPaginationDisabled = _ref$isPaginationDisa === void 0 ? true : _ref$isPaginationDisa,
      _ref$controlsTheme = _ref.controlsTheme,
      controlsTheme = _ref$controlsTheme === void 0 ? 'default' : _ref$controlsTheme;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(ImmersiveSlideShowNarrow_getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var coef = isRTL ? -1 : 1;
  var containerRef = Object(react["useRef"])(null);

  var scroll = function scroll(index, e) {
    if (e) {
      e.preventDefault();
    }

    var isFirst = activeIndex === 0;
    var isLast = activeIndex === items.length - 1;

    if (isFirst && index < activeIndex) {
      index = items.length - 1;
    }

    if (isLast && index > activeIndex) {
      index = 0;
    }

    if (containerRef && containerRef.current) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: coef * containerRef.current.scrollWidth * (index / items.length)
      });
    }

    setActiveIndex(index);
  };

  var onScroll = debounce_default()(function () {
    if (containerRef && containerRef.current) {
      var pos = Math.round(coef * containerRef.current.scrollLeft / containerRef.current.scrollWidth * items.length);
      setActiveIndex(pos);
    }
  }, 150);

  Object(react["useEffect"])(function () {
    // $FlowFixMe
    containerRef.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      containerRef.current.removeEventListener('scroll', onScroll);
    };
  }, [coef]);
  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) {
      return;
    }

    var newDisplayedIndex = displayedIndex.map(function (_, idx) {
      return idx < activeIndex + PRELOADED_ITEMS_NB;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  return ImmersiveSlideShowNarrow_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('overflow-hidden relative', className)
  }, ImmersiveSlideShowNarrow_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-row flex-nowrap overflow-auto snap-x snap-mandatory w-full', className),
    dir: isRTL ? 'rtl' : 'ltr',
    ref: containerRef
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowNarrow_jsx("div", {
      className: "flex-none overflow-visible snap-center w-full",
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  })), items.length > 1 && ImmersiveSlideShowNarrow_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    activeIndex: activeIndex + 1,
    isPaginationDisabled: isPaginationDisabled,
    nextLabel: nextLabel,
    onNext: function onNext(e) {
      return scroll(activeIndex + coef, e);
    },
    onPrev: function onPrev(e) {
      return scroll(activeIndex - coef, e);
    },
    previousLabel: previousLabel,
    slidesCount: items.length,
    theme: controlsTheme
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx



var ImmersiveSlideShow_jsx = react_default.a.createElement;






var ImmersiveSlideShow_ImmersiveSlideShow = function ImmersiveSlideShow(_ref) {
  var _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      _ref$pictureAltLabel = _ref.pictureAltLabel,
      pictureAltLabel = _ref$pictureAltLabel === void 0 ? '' : _ref$pictureAltLabel,
      previousLabel = _ref.previousLabel,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["immersiveSize", "media", "nextLabel", "pictureAltLabel", "previousLabel"]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!media.length) {
    return null;
  }

  var items = media.map(function (src, idx) {
    return ImmersiveSlideShow_jsx(ImmersiveSlideShowItem_ImmersiveSlideShowItem, Object(esm_extends["a" /* default */])({}, rest, {
      alt: Object(dist["messageFormat"])(pictureAltLabel).format({
        nb: idx + 1
      }),
      immersiveSize: immersiveSize,
      isImmersive: isDesktop,
      key: src,
      src: src
    }));
  });
  var controlsTheme = rest.controlsTheme,
      isPaginationDisabled = rest.isPaginationDisabled;
  return isDesktop ? ImmersiveSlideShow_jsx(ImmersiveSlideShowLarge_ImmersiveSlideShowLarge, {
    items: items,
    controlsTheme: controlsTheme,
    isPaginationDisabled: isPaginationDisabled,
    immersiveSize: immersiveSize,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  }) : ImmersiveSlideShow_jsx(ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow, {
    items: items,
    controlsTheme: controlsTheme,
    isPaginationDisabled: isPaginationDisabled,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  });
};

/***/ }),

/***/ "v+bK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingEngineTrackingContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var BookingEngineTrackingContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])(undefined);

/***/ }),

/***/ "v5ZW":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIndexOf = __webpack_require__("c7Qd"),
    baseIndexOfWith = __webpack_require__("A0wc"),
    baseUnary = __webpack_require__("SU8Q"),
    copyArray = __webpack_require__("QT01");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),

/***/ "woxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProgressBar_ProgressBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isInteger.js
var isInteger = __webpack_require__("RYcy");
var isInteger_default = /*#__PURE__*/__webpack_require__.n(isInteger);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.themes.js
var themes = {
  "default": {
    thRoot: 'bg-darkGrey leading-0 overflow-hidden relative',
    thBar: 'transition-width duration-250 ease-in h-2'
  },
  rounded: {
    thRoot: 'bg-lightSand leading-0 overflow-hidden relative rounded-pill',
    thBar: 'rounded-pill transition-width duration-250 ease-in h-15'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx

var __jsx = react_default.a.createElement;




var ProgressBar_ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$color,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      value = _ref.value;

  if (!isInteger_default()(value) || value < 0) {
    return null;
  }

  var stepPercent = 100 / (max - min);
  var currentPercent = stepPercent * (value - min);
  var _themes$theme = themes[theme],
      thBar = _themes$theme.thBar,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", {
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    role: "progressbar"
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thBar, "bg-".concat(color)),
    "data-testid": "progress-bar",
    style: {
      width: "".concat(currentPercent, "%")
    }
  }));
};

/***/ }),

/***/ "yr32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpsellCard; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("C/y5");
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("rd3t");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_measure_measure__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("yJ4S");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("u/u4");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kiXb");
/* harmony import */ var _badge_Badge__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("VHif");
/* harmony import */ var _dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("i5Mr");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("qBqs");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("0IQ5");
/* harmony import */ var _template_string_TemplateString__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Ohju");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("qqKu");
/* harmony import */ var _title_Title__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("MWZw");











var __jsx = react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var MIN_HEIGHT = 60;
var UpsellCard = function UpsellCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      imageUrl = _ref.imageUrl,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      label = _ref.label,
      _onClick = _ref.onClick,
      price = _ref.price,
      text = _ref.text,
      url = _ref.url,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_ref, ["children", "className", "imageUrl", "isChecked", "isDisabled", "label", "onClick", "price", "text", "url"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_11__["useState"])(false),
      isOpened = _useState[0],
      setIsOpened = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_11__["useState"])(true),
      isFinish = _useState2[0],
      setIsFinish = _useState2[1];

  var _useMeasure = Object(_utils_measure_measure__WEBPACK_IMPORTED_MODULE_15__[/* useMeasure */ "a"])(),
      _useMeasure2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_useMeasure, 2),
      bind = _useMeasure2[0],
      height = _useMeasure2[1].height;

  var styles = Object(_react_spring_web__WEBPACK_IMPORTED_MODULE_13__["useSpring"])({
    config: _react_spring_web__WEBPACK_IMPORTED_MODULE_13__["config"].stiff,
    from: {
      height: MIN_HEIGHT
    },
    to: {
      height: isOpened ? height : MIN_HEIGHT
    },
    onStart: function onStart() {
      return setIsFinish(false);
    },
    onRest: function onRest(_ref2) {
      var value = _ref2.value;
      return setIsFinish(value.height === MIN_HEIGHT);
    }
  });
  var hasExpand = Boolean(react__WEBPACK_IMPORTED_MODULE_11__["Children"].count(children));
  var TagName = url ? _dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"] : 'button';
  var props = url ? {
    shallow: true,
    url: url
  } : {
    type: 'button'
  };
  return __jsx("article", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, rest, {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])('text-initial relative isolate flex min-h-140 items-start gap-15 rounded-12 border-1 border-solid border-lightGrey bg-white p-10 shadow', className)
  }), isChecked && __jsx("span", {
    className: "absolute end-0 top-0 m-5"
  }, __jsx(_badge_Badge__WEBPACK_IMPORTED_MODULE_18__[/* Badge */ "a"], {
    className: "size-20 border-green bg-green text-white",
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_14__[/* ICONS */ "a"].CHECK,
    variant: "pill"
  })), __jsx("div", {
    className: "my-10 aspect-square size-100 shrink-0 overflow-hidden rounded-full bg-grey"
  }, __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_21__[/* Image */ "a"], {
    imageUrl: imageUrl,
    ratioDisplay: 1 / 4,
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_16__[/* default */ "c"].SQUARE
  })), __jsx("div", {
    className: "flex-1"
  }, __jsx(_title_Title__WEBPACK_IMPORTED_MODULE_24__[/* Title */ "a"], {
    className: "mb-2",
    theme: "title-sans-n3"
  }, label), __jsx(_react_spring_web__WEBPACK_IMPORTED_MODULE_13__["animated"].div, {
    style: _objectSpread({
      overflow: 'hidden'
    }, styles)
  }, __jsx("div", bind, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_23__[/* Text */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])('text-14', {
      'line-clamp-3': isFinish
    }),
    text: text
  }), children)), __jsx("div", {
    className: "mt-10 flex items-center justify-between gap-10 border-t-1 border-lightGrey pt-5"
  }, price && __jsx("p", {
    className: "text-12"
  }, __jsx(_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_22__[/* TemplateString */ "a"], {
    template: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.price.priceFrom'),
    valuesClassName: {
      price: 'font-bold text-16 text-sienna'
    },
    values: {
      currency: '',
      price: "+ ".concat(price)
    }
  })), !isDisabled && __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, props, {
    className: "ms-auto flex gap-5 text-14 text-black underline",
    onClick: function onClick() {
      hasExpand && !url && setIsOpened(function (v) {
        return !v;
      });
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    }
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('common.viewMore'), hasExpand && __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    className: "mt-5",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_14__[/* ICONS */ "a"].ARROW_DOWN,
    rotation: isOpened ? 180 : 0,
    width: "1em"
  })))));
};

/***/ }),

/***/ "zhg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_BOOKING_CART; });
/* unused harmony export getBookingsCartQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookingsCart; });
/* unused harmony export removeService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateBookingCartSequencially; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _store_utils_createAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Nhxn");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__);












var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';

var bookingCartQuery = function bookingCartQuery(appContext) {
  return "\n  bookingId\n  attendees {\n    id\n    firstname\n    lastname\n    birthday\n    unicodeFirstname\n    unicodeLastname\n    type\n  }\n  stayServices {\n    stayIndex\n    childcares {\n      id\n      productId\n      type\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n      attendees {\n        id\n        schedules {\n          price {\n            value\n          }\n          startDate\n          endDate\n        }\n      }\n    }\n    transfers {\n      id\n      productId\n      type\n      label\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    insurance {\n      id\n      productId\n      type\n      label\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    whiteLabelServices {\n      id\n      productId\n      type\n      serviceInfo {\n        subtype\n        label\n      }\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    rentals {\n      id\n      productId\n      type\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n      attendees {\n        id\n        schedules {\n          price {\n            value\n          }\n          startDate\n          endDate\n        }\n      }\n    }\n    activities {\n      id\n      productId\n      type\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    pickRoom {\n      id\n      type\n      accommodations {\n        id\n        rooms {\n          id\n        }\n      }\n    }\n  }\n  price {\n    total {\n        formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__["getBookingPrecision"])(appContext.locale), ")\n        value\n        currency\n    }\n    currency\n    detail {\n      service\n      amount\n    }\n  }\n  isEmpty\n  hasServicesInOption");
};

var cartQuery = function cartQuery(appContext) {
  return "\n  amount {\n    total {\n      value\n      currency\n      formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__["getBookingPrecision"])(appContext.locale), ")\n    }\n  }\n  isEmpty\n  cartBookings {\n    ").concat(bookingCartQuery(appContext), "\n  }");
};

var getBookingsCartQuery = function getBookingsCartQuery(appContext, bookingIds) {
  var gqlBookingIds = bookingIds.map(function (id) {
    return "\"".concat(id, "\"");
  });
  return "\n    query {\n      bookingsCart(bookingIds : [".concat(gqlBookingIds.toString(), "]) {\n        ").concat(cartQuery(appContext), "\n      }\n    }\n  ");
};
var fetchBookingsCart = function fetchBookingsCart(bookingIds, context) {
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(FETCH_BOOKING_CART, {}, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runNoCacheQuery(getBookingsCartQuery(context, bookingIds), context, {
        requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_GET_BOOKINGS_CART */ "j"]
      })
    }));
  };
};

var addService = function addService(_ref) {
  var context = _ref.context,
      id = _ref.id,
      bookingId = _ref.bookingId,
      amountToUpdate = _ref.amountToUpdate,
      schedules = _ref.schedules,
      accommodations = _ref.accommodations,
      serviceName = _ref.serviceName,
      stayIndex = _ref.stayIndex;
  return "mutation {\n  addServiceCart(\n    bookingId : \"".concat(bookingId, "\",\n    amount: ").concat(amountToUpdate, ",\n    serviceCart: {\n      id: \"").concat(id, "\",\n      stay_index: ").concat(stayIndex || 0, ",\n      ").concat(schedules ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_10__[/* attributesToString */ "a"])({
    schedules: schedules
  }) : '', "\n      ").concat(accommodations ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_10__[/* attributesToString */ "a"])({
    accommodations: accommodations
  }) : '', "\n    }\n    serviceName: \"").concat(serviceName, "\") {\n      cart {\n        ").concat(bookingCartQuery(context), "\n      }\n      totalAmount {\n        value\n        currency\n        formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__["getBookingPrecision"])(context.locale), ")\n      }\n    }\n  }");
};

var removeService = function removeService(appContext, id, bookingId, amountToUpdate) {
  return "mutation {\n    removeServiceCart(\n      bookingId : \"".concat(bookingId, "\",\n      amount: ").concat(amountToUpdate, ",\n      itemId: \"").concat(id, "\")\n      {\n        cart {\n          ").concat(bookingCartQuery(appContext), "\n        }\n        totalAmount {\n          value\n          currency\n          formattedValue\n        }\n      }\n  }");
};
var updateBookingCart = function updateBookingCart(_ref2) {
  var context = _ref2.context,
      id = _ref2.id,
      bookingId = _ref2.bookingId,
      schedules = _ref2.schedules,
      accommodations = _ref2.accommodations,
      serviceName = _ref2.serviceName,
      action = _ref2.action,
      successMsg = _ref2.successMsg,
      stayIndex = _ref2.stayIndex;
  return function (dispatch, getState) {
    var _getState, _getState$memberSpace, _getState$memberSpace2, _getState$memberSpace3, _bookingsCart$amount, _bookingsCart$amount$;

    var bookingsCart = ((_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$memberSpace = _getState.memberSpace) === null || _getState$memberSpace === void 0 ? void 0 : (_getState$memberSpace2 = _getState$memberSpace.cart) === null || _getState$memberSpace2 === void 0 ? void 0 : (_getState$memberSpace3 = _getState$memberSpace2.data) === null || _getState$memberSpace3 === void 0 ? void 0 : _getState$memberSpace3.bookingsCart) || {};
    var totalAmount = ((_bookingsCart$amount = bookingsCart.amount) === null || _bookingsCart$amount === void 0 ? void 0 : (_bookingsCart$amount$ = _bookingsCart$amount.total) === null || _bookingsCart$amount$ === void 0 ? void 0 : _bookingsCart$amount$.value) || 0;
    var bookingPrice = bookingsCart === null || bookingsCart === void 0 ? void 0 : bookingsCart.cartBookings.find(function (cartBooking) {
      return cartBooking.bookingId === bookingId;
    }).price.total.value;
    var amountToUpdate = totalAmount - bookingPrice;
    dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UPDATE_BOOKING_CART, {
      id: id,
      bookingId: bookingId,
      toastLabel: successMsg
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
        context: context,
        id: id,
        bookingId: bookingId,
        amountToUpdate: amountToUpdate,
        schedules: schedules,
        accommodations: accommodations,
        serviceName: serviceName,
        stayIndex: stayIndex
      }) : removeService(context, id, bookingId, amountToUpdate), context, {
        requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "K"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "I"]
      })
    }));
  };
};
var updateBookingCartSequencially = function updateBookingCartSequencially(params, cartState) {
  var _cartState$amount, _cartState$amount$tot, _cartState$cartBookin, _cartState$cartBookin2, _cartState$cartBookin3;

  if (params.length === 0) {
    return Promise.resolve();
  }

  var _params$ = params[0],
      context = _params$.context,
      id = _params$.id,
      bookingId = _params$.bookingId,
      schedules = _params$.schedules,
      accommodations = _params$.accommodations,
      serviceName = _params$.serviceName,
      action = _params$.action,
      stayIndex = _params$.stayIndex;
  var totalAmount = (cartState === null || cartState === void 0 ? void 0 : (_cartState$amount = cartState.amount) === null || _cartState$amount === void 0 ? void 0 : (_cartState$amount$tot = _cartState$amount.total) === null || _cartState$amount$tot === void 0 ? void 0 : _cartState$amount$tot.value) || 0;
  var bookingPrice = (cartState === null || cartState === void 0 ? void 0 : (_cartState$cartBookin = cartState.cartBookings.find(function (cartBooking) {
    return cartBooking.bookingId === bookingId;
  })) === null || _cartState$cartBookin === void 0 ? void 0 : (_cartState$cartBookin2 = _cartState$cartBookin.price) === null || _cartState$cartBookin2 === void 0 ? void 0 : (_cartState$cartBookin3 = _cartState$cartBookin2.total) === null || _cartState$cartBookin3 === void 0 ? void 0 : _cartState$cartBookin3.value) || 0;
  var amountToUpdate = totalAmount - bookingPrice;
  var promise = _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
    context: context,
    id: id,
    bookingId: bookingId,
    amountToUpdate: amountToUpdate,
    schedules: schedules,
    accommodations: accommodations,
    serviceName: serviceName,
    stayIndex: stayIndex
  }) : removeService(context, id, bookingId, amountToUpdate), context, {
    requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "K"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "I"]
  });
  return promise.then(function () {
    return updateBookingCartSequencially(params.slice(1));
  });
};
/* export const updateBookingCartAll = (params: Array<updateCartParams>, cartState: BookingsCart) => {
  return Promise.all(
    params.map(({ id, bookingId, schedules, accommodations, serviceName, context, action }) =>
      graphQLClient.runNoCacheQuery(
        action === 'update'
          ? addService({ id, bookingId, 0, schedules, accommodations, serviceName })
          : removeService(id, bookingId, 0),
        context,
        {
          requestName:
            action === 'update'
              ? CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART
              : CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM,
        },
      ),
    ),
  );
}; */

/***/ })

}]);